// "use client";

// import React, { useState, useEffect, useRef, useMemo } from "react";
// import {
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Box,
//   Chip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Avatar,
//   Skeleton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
//   Stack,
//   Paper,
//   useTheme,
//   Tabs,
//   Tab,
//   FormControl,
//   Select,
//   MenuItem,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemAvatar,
//   LinearProgress,
//   TablePagination,
//   Tooltip,
//   Container,
//   Fade,
//   Grow,
//   alpha,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   FormLabel,
// } from "@mui/material";
// import {
//   People,
//   LocationOn,
//   TrendingUp,
//   WorkOutline,
//   School,
//   BarChart,
//   PieChart,
//   Timeline,
//   CloudDownload,
//   Star,
//   CheckCircle,
//   HelpOutline,
//   MonetizationOn,
//   AccessTime,
//   RateReview,
//   History,
//   ArrowDownward,
// } from "@mui/icons-material";
// import * as htmlToImage from "html-to-image";
// import ReactApexChart from "react-apexcharts";
// import Layout from "../common/Layout";
// import apiClient from "../../context/apiClient";

// // NOTE: No changes needed in utility functions
// const downloadFile = ({ data, fileName, fileType }) => {
//   const blob = new Blob([data], { type: fileType });
//   const a = document.createElement("a");
//   a.download = fileName;
//   a.href = window.URL.createObjectURL(blob);
//   const clickEvt = new MouseEvent("click", {
//     view: window,
//     bubbles: true,
//     cancelable: true,
//   });
//   a.dispatchEvent(clickEvt);
//   a.remove();
// };

// const convertToCSV = (data) => {
//   if (!data || data.length === 0) return "";
//   const headers = Object.keys(data[0]);
//   const csvRows = [headers.join(",")];
//   for (const row of data) {
//     const values = headers.map((header) => {
//       const escaped = ("" + row[header]).replace(/"/g, '""');
//       return `"${escaped}"`;
//     });
//     csvRows.push(values.join(","));
//   }
//   return csvRows.join("\n");
// };

// const generateUniqueColors = (count) => {
//   if (count === 0) return [];
//   const colors = [];
//   const hueStep = 360 / count;
//   for (let i = 0; i < count; i++) {
//     const hue = i * hueStep;
//     colors.push(`hsl(${hue}, 70%, 50%)`);
//   }
//   return colors;
// };

// // NOTE: No changes needed in ExportReportDialog as it inherits styles from the theme
// const ExportReportDialog = ({
//   open,
//   onClose,
//   candidatesData,
//   demographicsData,
//   overviewData,
//   skillChartRef,
//   locationTableRef,
// }) => {
//   const [reportType, setReportType] = useState("demographics_skills");
//   const [format, setFormat] = useState("png");

//   const handleDownload = async () => {
//     let dataToExport = [];
//     let fileName = `${reportType}_report`;
//     const isImageFormat = format === "png";

//     if (isImageFormat) {
//       const elementToCapture =
//         reportType === "demographics_skills"
//           ? skillChartRef.current
//           : locationTableRef.current;
//       if (!elementToCapture) {
//         console.error("Target element for image capture not found.");
//         return;
//       }
//       try {
//         const dataUrl = await htmlToImage.toPng(elementToCapture);
//         const a = document.createElement("a");
//         a.href = dataUrl;
//         a.download = `${reportType}_${new Date()
//           .toISOString()
//           .slice(0, 10)}.png`;
//         a.click();
//       } catch (error) {
//         console.error("Failed to capture component as image", error);
//       }
//     } else {
//       switch (reportType) {
//         case "candidates":
//           dataToExport = candidatesData.map((c) => ({
//             id: c.candidate_id,
//             name: c.candidate_name,
//             location: c.location,
//             status: c.status,
//             match_score: c.match_score,
//             skills: c.skills.join("|"),
//             experience: c.experience
//               .map((e) => `${e.title} at ${e.company}`)
//               .join(" | "),
//           }));
//           break;
//         case "demographics_skills":
//           dataToExport = demographicsData.skill_distribution;
//           fileName = "skill_distribution_report";
//           break;
//         case "demographics_locations":
//           dataToExport = demographicsData.candidate_locations;
//           fileName = "candidate_locations_report";
//           break;
//         case "overview":
//           dataToExport = [overviewData.summary_stats];
//           break;
//         default:
//           console.error("Invalid report type");
//           return;
//       }

//       if (format === "csv") {
//         const csvData = convertToCSV(dataToExport);
//         downloadFile({
//           data: csvData,
//           fileName: `${fileName}.csv`,
//           fileType: "text/csv",
//         });
//       } else if (format === "json") {
//         downloadFile({
//           data: JSON.stringify(dataToExport, null, 2),
//           fileName: `${fileName}.json`,
//           fileType: "application/json",
//         });
//       }
//     }
//     onClose();
//   };

//   const isVisualReport =
//     reportType === "demographics_skills" ||
//     reportType === "demographics_locations";

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//       <DialogTitle fontWeight="bold">Export Report</DialogTitle>
//       <DialogContent dividers>
//         <Stack spacing={4}>
//           <FormControl component="fieldset">
//             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
//               Select Report Type
//             </FormLabel>
//             <RadioGroup
//               value={reportType}
//               onChange={(e) => setReportType(e.target.value)}
//             >
//               <FormControlLabel
//                 value="demographics_skills"
//                 control={<Radio />}
//                 label="Skill Distribution"
//               />
//               <FormControlLabel
//                 value="demographics_locations"
//                 control={<Radio />}
//                 label="Candidate Locations"
//               />
//               <FormControlLabel
//                 value="candidates"
//                 control={<Radio />}
//                 label="Top Candidates (Data Only)"
//               />
//               <FormControlLabel
//                 value="overview"
//                 control={<Radio />}
//                 label="Hiring Stats Overview (Data Only)"
//               />
//             </RadioGroup>
//           </FormControl>
//           <FormControl component="fieldset">
//             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
//               Select Format
//             </FormLabel>
//             <RadioGroup
//               row
//               value={format}
//               onChange={(e) => setFormat(e.target.value)}
//             >
//               <FormControlLabel
//                 value="png"
//                 control={<Radio />}
//                 label="Image (PNG)"
//                 disabled={!isVisualReport}
//               />
//               <FormControlLabel value="csv" control={<Radio />} label="CSV" />
//               <FormControlLabel value="json" control={<Radio />} label="JSON" />
//             </RadioGroup>
//           </FormControl>
//         </Stack>
//       </DialogContent>
//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={onClose} color="inherit">
//           Cancel
//         </Button>
//         <Button
//           onClick={handleDownload}
//           variant="contained"
//           startIcon={<CloudDownload />}
//         >
//           Download
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// const cleanSkill = (skill) => {
//   return skill.replace(/[\[\]"]/g, "");
// };

// const SkillDonutChart = ({ data, colors }) => {
//   const theme = useTheme();
//   const chartSeries = data.map((item) => item.count);
//   const chartOptions = {
//     chart: { type: "donut", background: "transparent" },
//     plotOptions: {
//       pie: {
//         donut: {
//           size: "70%",
//           labels: {
//             show: true,
//             total: {
//               show: true,
//               label: "Total Skills",
//               color: theme.palette.text.secondary,
//               formatter: (w) =>
//                 w.globals.seriesTotals.reduce((a, b) => a + b, 0),
//             },
//           },
//         },
//       },
//     },
//     dataLabels: { enabled: false },
//     legend: { show: false },
//     colors: colors,
//     tooltip: { y: { formatter: (val) => `${val} candidates` } },
//     theme: {
//       mode: theme.palette.mode,
//     },
//     stroke: {
//         colors: [theme.palette.background.paper],
//     },
//   };
//   return (
//     <ReactApexChart
//       options={chartOptions}
//       series={chartSeries}
//       type="donut"
//       height={420}
//     />
//   );
// };

// const SkillList = ({ data, colors }) => {
//   return (
//     <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 2 }}>
//       <List>
//         {data.map((item, index) => (
//           <ListItem key={item.skill} disablePadding>
//             <Stack
//               direction="row"
//               alignItems="center"
//               spacing={2}
//               sx={{ width: "100%", py: 0.5 }}
//             >
//               <Box
//                 sx={{
//                   width: 16,
//                   height: 16,
//                   borderRadius: "4px",
//                   bgcolor: colors[index % colors.length],
//                   flexShrink: 0,
//                 }}
//               />
//               <ListItemText
//                 primary={
//                   <Typography variant="body2" color="text.primary" noWrap>
//                     {cleanSkill(item.skill)}
//                   </Typography>
//                 }
//               />
//               <Typography
//                 variant="body2"
//                 color="text.secondary"
//                 fontWeight="bold"
//               >
//                 {item.count}
//               </Typography>
//             </Stack>
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );
// };

// const ApplicationTrendChart = ({ data, height = 450 }) => {
//   const theme = useTheme();

//   if (
//     !data ||
//     !data.datasets ||
//     !data.datasets[0] ||
//     !data.datasets[0].data ||
//     data.datasets[0].data.length === 0
//   ) {
//     return (
//       <Box
//         sx={{
//           height,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           bgcolor: (theme) => alpha(theme.palette.divider, 0.04),
//           borderRadius: 2,
//           border: (theme) => `1px dashed ${theme.palette.divider}`,
//           m: 3,
//         }}
//       >
//         <Typography variant="body2" color="text.secondary">
//           No trend data available.
//         </Typography>
//       </Box>
//     );
//   }

//   const chartSeries = [
//     {
//       name: "Applications",
//       data: data.datasets[0].data,
//     },
//   ];

//   const chartOptions = {
//     chart: {
//       type: "area",
//       height: height,
//       toolbar: {
//         show: false,
//       },
//       zoom: {
//         enabled: false,
//       },
//       background: "transparent",
//     },
//     colors: [theme.palette.primary.main],
//     dataLabels: {
//       enabled: false,
//     },
//     stroke: {
//       curve: "smooth",
//       width: 3,
//       lineCap: "round",
//     },
//     fill: {
//       type: "gradient",
//       gradient: {
//         shadeIntensity: 1,
//         opacityFrom: 0.4,
//         opacityTo: 0.1,
//         stops: [0, 90, 100],
//       },
//     },
//     grid: {
//       show: true,
//       borderColor: theme.palette.divider,
//       strokeDashArray: 4,
//       xaxis: {
//         lines: {
//           show: false,
//         },
//       },
//       yaxis: {
//         lines: {
//           show: true,
//         },
//       },
//     },
//     xaxis: {
//       categories: data.labels,
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//       labels: {
//         style: {
//           colors: theme.palette.text.secondary,
//           fontWeight: 500,
//         },
//       },
//     },
//     yaxis: {
//       labels: {
//         style: {
//           colors: theme.palette.text.secondary,
//         },
//         formatter: function (val) {
//           return val.toFixed(0);
//         },
//       },
//     },
//     tooltip: {
//       x: {
//         format: "MMM yyyy",
//       },
//       y: {
//         formatter: (val) => `${val} applications`,
//       },
//       theme: theme.palette.mode,
//       marker: {
//         show: true,
//       },
//     },
//   };

//   return (
//     <ReactApexChart
//       options={chartOptions}
//       series={chartSeries}
//       type="area"
//       height={height}
//     />
//   );
// };

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`analytics-tabpanel-${index}`}
//       aria-labelledby={`analytics-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Fade in={value === index} timeout={500}>
//           <Box sx={{ pt: 4 }}>{children}</Box>
//         </Fade>
//       )}
//     </div>
//   );
// }

// const getStatusColor = (status) => {
//   switch (status) {
//     case "hired":
//       return "success";
//     case "interviewed":
//       return "primary";
//     case "shortlisted":
//       return "info";
//     case "applied":
//     case "matched":
//       return "warning";
//     default:
//       return "default";
//   }
// };

// const getStatusIcon = (status) => {
//   switch (status) {
//     case "hired":
//       return <CheckCircle />;
//     case "interviewed":
//       return <People />;
//     case "shortlisted":
//       return <Star />;
//     case "applied":
//     case "matched":
//       return <WorkOutline />;
//     default:
//       return <HelpOutline />;
//   }
// };

// const OverviewTab = ({ loading, data }) => {
//   const theme = useTheme();

//   const applicationTrendsData = {
//     labels: data.application_trend?.map((d) => d.month) || [],
//     datasets: [
//       {
//         label: "Applications",
//         data: data.application_trend?.map((d) => d.application_count) || [],
//         backgroundColor: theme.palette.primary.main,
//       },
//     ],
//   };

//   const statCards = [
//     {
//       label: "Total Applications",
//       value: data.summary_stats?.total_applications || 0,
//     },
//     {
//       label: "Total Interviews",
//       value: data.summary_stats?.total_interviews || 0,
//     },
//     {
//       label: "Total Hires",
//       value: data.summary_stats?.total_hires || 0,
//     },
//     {
//       label: "Acceptance Rate",
//       value: data.summary_stats?.acceptance_rate || "0%",
//     },
//   ];

//   return (
//     <Stack spacing={4}>
//       <Grid container spacing={{ xs: 2, md: 3 }}>
//         {loading
//           ? [...Array(4)].map((_, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Skeleton
//                   variant="rectangular"
//                   width="100%"
//                   height={140}
//                   sx={{ borderRadius: "12px" }}
//                 />
//               </Grid>
//             ))
//           : statCards.map((card, index) => (
//               <Box key={index} sx={{ flex: 1, minWidth: 0 }}>

//                 <Box
//                    sx={{
//                         width: "100%",
//                         height: 140,
//                         backgroundColor: "primary.main", // Use theme color
//                         borderRadius: "12px",
//                         boxShadow: theme.shadows[3],
//                         position: "relative",
//                         overflow: "hidden",
//                         p: { xs: 1.5, sm: 2, md: 2.5 },
//                         display: "flex",
//                         flexDirection: "column",
//                         justifyContent: "space-between",
//                       }}
//                 >
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       top: 0,
//                       right: 0,
//                       width: "100%",
//                       height: "100%",
//                       zIndex: 0,
//                     }}
//                   >
//                     <svg
//                        width="100%" height="100%" viewBox="0 0 280 140"
//                           preserveAspectRatio="none"
//                           style={{ position: "absolute", right: 0, top: 0 }}
//                     >
//                       <path
//                         d="M200 0 L280 0 L280 140 C 250 140, 230 105, 230 70 C 230 35, 250 0, 200 0 Z"
//                         fill={theme.palette.accent.main}
//                       />
//                     </svg>
//                   </Box>
//                   <Box sx={{ position: "relative", zIndex: 1 }}>
//                     <Typography
//                       sx={{
//                         fontSize: { xs: "0.7rem", sm: "0.75rem" },
//                         fontWeight: 600,
//                         color: alpha(
//                           theme.palette.primary.contrastText,
//                           0.85
//                         ),
//                         textTransform: "uppercase",
//                         lineHeight: 1.2,
//                       }}
//                     >
//                       {card.label}
//                     </Typography>
//                   </Box>
//                   <Box sx={{ position: "relative", zIndex: 1 }}>
//                     <Typography
//                       sx={{
//                         fontSize: {
//                           xs: "1.75rem",
//                           sm: "2rem",
//                           md: "2.25rem",
//                         },
//                         fontWeight: "bold",
//                         color: "primary.contrastText",
//                         lineHeight: 1,
//                       }}
//                     >
//                       {card.value}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>
//             ))}
//       </Grid>

//       <Card
//         sx={{
//           backgroundColor: "mint.main",
//           transition: "all 0.3s ease",
//           "&:hover": { boxShadow: theme.shadows[8] },
//         }}
//       >
//         <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
//           <Box sx={{ p: { xs: 2, sm: 3 }, pb: 0 }}>
//             {loading ? (
//               <Skeleton variant="text" width="60%" height={32} />
//             ) : (
//               <Typography
//                 variant="h6"
//                 fontWeight="bold"
//                 color="text.primary"
//               >
//                 Application Trends
//               </Typography>
//             )}
//           </Box>
//           {loading ? (
//             <Box sx={{ p: { xs: 2, sm: 3 } }}>
//               <Skeleton
//                 variant="rectangular"
//                 height={400}
//                 sx={{ borderRadius: 2 }}
//               />
//             </Box>
//           ) : (
//             <ApplicationTrendChart data={applicationTrendsData} />
//           )}
//         </CardContent>
//       </Card>
//     </Stack>
//   );
// };

// const RecentActivityTab = ({ loading, data }) => {
//   const theme = useTheme();

//   const getActivityIcon = (activityString) => {
//     const lowerCaseActivity = activityString.toLowerCase();
//     if (lowerCaseActivity.includes("hired")) return <CheckCircle />;
//     if (lowerCaseActivity.includes("interview")) return <People />;
//     if (lowerCaseActivity.includes("applied")) return <WorkOutline />;
//     return <RateReview />;
//   };

//   return (
//     <Card
//       sx={{
//         backgroundColor: "mint.main",
//         transition: "all 0.3s ease",
//         "&:hover": { boxShadow: theme.shadows[8] },
//       }}
//     >
//       <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
//         {loading ? (
//           <Skeleton variant="text" width="50%" height={32} />
//         ) : (
//           <Typography
//             variant="h6"
//             fontWeight="bold"
//             gutterBottom
//             color="text.primary"
//           >
//             Recent Activity
//           </Typography>
//         )}
//         <List sx={{ mt: 2 }}>
//           {loading
//             ? Array.from(new Array(5)).map((_, index) => (
//                 <ListItem key={index} sx={{ px: 0, py: 1.5 }}>
//                   <ListItemAvatar>
//                     <Skeleton variant="circular" width={48} height={48} />
//                   </ListItemAvatar>
//                   <ListItemText
//                     primary={<Skeleton variant="text" width="80%" />}
//                     secondary={<Skeleton variant="text" width="60%" />}
//                   />
//                 </ListItem>
//               ))
//             : data?.map((activity, index) => (
//                 <ListItem
//                   key={`${activity.candidate_name}-${index}`}
//                   sx={{
//                     px: 0,
//                     py: 1.5,
//                     borderRadius: 2,
//                     transition: "all 0.2s ease",
//                     "&:hover": {
//                       bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
//                     },
//                   }}
//                 >
//                   <ListItemAvatar>
//                     <Avatar
//                       sx={{
//                         bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
//                         color: "primary.main",
//                         width: 48,
//                         height: 48,
//                         boxShadow: theme.shadows[2],
//                       }}
//                     >
//                       {getActivityIcon(activity.activity)}
//                     </Avatar>
//                   </ListItemAvatar>
//                   <ListItemText
//                     primary={
//                       <Typography
//                         variant="body2"
//                         fontWeight="600"
//                         color="text.primary"
//                       >
//                         {activity.candidate_name}
//                       </Typography>
//                     }
//                     secondary={
//                       <Typography variant="caption" color="text.secondary">
//                         {activity.activity} • {activity.time_ago}
//                       </Typography>
//                     }
//                   />
//                 </ListItem>
//               ))}
//         </List>
//       </CardContent>
//     </Card>
//   );
// };

// // MODIFIED: TrendsTab component is now responsive
// const TrendsTab = ({ loading, data }) => {
//   const theme = useTheme();

//   const funnelData = [
//     {
//       icon: <WorkOutline color="primary" />,
//       title: "Applications",
//       value: data?.hiring_funnel?.applications || 0,
//       color: theme.palette.primary.main,
//     },
//     {
//       icon: <People color="secondary" />,
//       title: "Interviews",
//       value: data?.hiring_funnel?.interviews || 0,
//       conversion: data?.hiring_funnel?.interview_conversion_rate || "0%",
//       color: theme.palette.secondary.main,
//     },
//     {
//       icon: <CheckCircle color="success" />,
//       title: "Hires",
//       value: data?.hiring_funnel?.hires || 0,
//       conversion: data?.hiring_funnel?.hire_conversion_rate || "0%",
//       color: theme.palette.success.main,
//     },
//   ];

//   const kpiData = [
//     {
//       icon: <AccessTime />,
//       title: "Average Time to Hire",
//       value: data?.key_performance_metrics?.average_time_to_hire || "N/A",
//       color: theme.palette.primary,
//     },
//     {
//       icon: <MonetizationOn />,
//       title: "Cost Per Hire",
//       value: data?.key_performance_metrics?.cost_per_hire || "N/A",
//       color: theme.palette.success,
//     },
//     {
//       icon: <RateReview />,
//       title: "Offer Acceptance Rate",
//       value: data?.key_performance_metrics?.offer_acceptance_rate || "N/A",
//       color: theme.palette.secondary,
//     },
//   ];

//   return (
//     <Grid container spacing={4}>
//       <Grid item xs={12} lg={5}>
//         <Card
//           sx={{
//             height: "100%",
//             width: "100%", // <-- Responsive width
//             maxWidth: "600px", // <-- Max width for larger screens
//             margin: "0 auto", // Center the card in the grid item
//             backgroundColor: "mint.main",
//             transition: "all 0.3s ease",
//             "&:hover": { boxShadow: theme.shadows[8] },
//           }}
//         >
//           <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
//             <Typography
//               variant="h6"
//               fontWeight="bold"
//               gutterBottom
//               color="text.primary"
//             >
//               Hiring Funnel
//             </Typography>
//             {loading ? (
//               <Stack spacing={4} sx={{ mt: 3 }}>
//                 <Skeleton
//                   variant="rectangular"
//                   height={60}
//                   sx={{ borderRadius: 2 }}
//                 />
//                 <Skeleton
//                   variant="rectangular"
//                   height={60}
//                   sx={{ borderRadius: 2 }}
//                 />
//                 <Skeleton
//                   variant="rectangular"
//                   height={60}
//                   sx={{ borderRadius: 2 }}
//                 />
//               </Stack>
//             ) : (
//               <Stack spacing={2} sx={{ mt: 4 }}>
//                 {funnelData.map((step, index) => (
//                   <Grow in timeout={500 + index * 200} key={step.title}>
//                     <Box>
//                       <Paper
//                         variant="outlined"
//                         sx={{
//                           p: 2,
//                           display: "flex",
//                           alignItems: "center",
//                           borderRadius: 2,
//                           borderColor: alpha(step.color, 0.3),
//                           background: `linear-gradient(to right, ${alpha(
//                             step.color,
//                             0.1
//                           )}, transparent)`,
//                         }}
//                       >
//                         <Avatar
//                           sx={{
//                             bgcolor: alpha(step.color, 0.15),
//                             color: step.color,
//                             mr: 2,
//                           }}
//                         >
//                           {step.icon}
//                         </Avatar>
//                         <Box sx={{ flexGrow: 1 }}>
//                           <Typography variant="body2" color="text.secondary">
//                             {step.title}
//                           </Typography>
//                           <Typography variant="h5" fontWeight="bold">
//                             {step.value}
//                           </Typography>
//                         </Box>
//                         {step.conversion && (
//                           <Box sx={{ textAlign: "right" }}>
//                             <Typography
//                               variant="caption"
//                               color="text.secondary"
//                             >
//                               Conversion
//                             </Typography>
//                             <Typography
//                               variant="body1"
//                               fontWeight="bold"
//                               color={step.color}
//                             >
//                               {step.conversion}
//                             </Typography>
//                           </Box>
//                         )}
//                       </Paper>
//                       {index < funnelData.length - 1 && (
//                         <Box display="flex" justifyContent="center" my={1}>
//                           <ArrowDownward sx={{ color: "divider" }} />
//                         </Box>
//                       )}
//                     </Box>
//                   </Grow>
//                 ))}
//               </Stack>
//             )}
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12} lg={7}>
//         <Card
//           sx={{
//             height: "100%",
//             width: "100%", // <-- Responsive width
//             maxWidth: "700px", // <-- Max width for larger screens
//             margin: "0 auto", // Center the card in the grid item
//             backgroundColor: "mint.main",
//             transition: "all 0.3s ease",
//             "&:hover": { boxShadow: theme.shadows[8] },
//           }}
//         >
//           <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
//             <Typography
//               variant="h6"
//               fontWeight="bold"
//               gutterBottom
//               color="text.primary"
//             >
//               Key Performance Metrics
//             </Typography>
//             <Grid container spacing={3} sx={{ mt: 2, height: "100%" }}>
//               {loading
//                 ? Array.from(new Array(3)).map((_, index) => (
//                     <Grid item xs={12} sm={4} key={index}>
//                       <Skeleton
//                         variant="rectangular"
//                         height={150}
//                         sx={{ borderRadius: 2 }}
//                       />
//                     </Grid>
//                   ))
//                 : kpiData.map((kpi, index) => (
//                     <Grid item xs={12} sm={4} key={kpi.title}>
//                       <Grow in timeout={500 + index * 200}>
//                         <Paper
//                           variant="outlined"
//                           sx={{
//                             p: { xs: 2, sm: 3 },
//                             borderRadius: 2,
//                             textAlign: "center",
//                             height: "100%",
//                             display: "flex",
//                             flexDirection: "column",
//                             justifyContent: "center",
//                             borderColor: alpha(kpi.color.main, 0.3),
//                             backgroundColor: alpha(kpi.color.main, 0.05),
//                           }}
//                         >
//                           <Avatar
//                             sx={{
//                               bgcolor: alpha(kpi.color.main, 0.1),
//                               color: kpi.color.main,
//                               width: 56,
//                               height: 56,
//                               mx: "auto",
//                               mb: 1.5,
//                             }}
//                           >
//                             {kpi.icon}
//                           </Avatar>
//                           <Typography
//                             variant="body2"
//                             fontWeight="600"
//                             color="text.primary"
//                           >
//                             {kpi.title}
//                           </Typography>
//                           <Typography
//                             variant="h4"
//                             fontWeight="bold"
//                             color="text.primary"
//                             sx={{ mt: 1 }}
//                           >
//                             {kpi.value}
//                           </Typography>
//                         </Paper>
//                       </Grow>
//                     </Grid>
//                   ))}
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );
// };

// // MODIFIED: DemographicsTab component is now responsive
// const DemographicsTab = ({
//   loading,
//   data,
//   skillChartRef,
//   locationTableRef,
//   timeRange,
//   handleTimeRangeChange,
//   jobFilter,
//   handleJobFilterChange,
//   filterOptions,
//   onExportClick,
// }) => {
//   const theme = useTheme();
//   const colorPalette = useMemo(() => {
//     if (!data || !data.skill_distribution) {
//       return [];
//     }
//     return generateUniqueColors(data.skill_distribution.length);
//   }, [data.skill_distribution]);

//   return (
//     <Stack spacing={4}>
//       <Paper
//         elevation={0}
//         sx={{
//           p: 2,
//           backgroundColor: "mint.main",
//           border: (theme) => `1px solid ${theme.palette.divider}`,
//         }}
//       >
//         <Stack
//           direction={{ xs: "column", md: "row" }}
//           spacing={2}
//           alignItems="center"
//           justifyContent="flex-end"
//         >
//           <FormControl size="small" sx={{ width: { xs: "100%", md: "auto" } }}>
//             <Select
//               value={timeRange}
//               onChange={handleTimeRangeChange}
//               sx={{
//                 minWidth: 140,
//               }}
//             >
//               <MenuItem value="last30days">Last Month</MenuItem>
//               <MenuItem value="last3months">Last 3 Months</MenuItem>
//               <MenuItem value="last6months">Last 6 Months</MenuItem>
//               <MenuItem value="lastyear">Last Year</MenuItem>
//             </Select>
//           </FormControl>
//           <FormControl size="small" sx={{ width: { xs: "100%", md: "auto" } }}>
//             <Select
//               value={jobFilter}
//               onChange={handleJobFilterChange}
//               sx={{
//                  minWidth: 180,
//               }}
//             >
//               {filterOptions.job_roles.map((job) => (
//                 <MenuItem
//                   key={job || "all-jobs"}
//                   value={
//                     job === "All Jobs" || !job ? "all" : job
//                   }
//                 >
//                   {job || "All Jobs"}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <Button
//             variant="outlined"
//             startIcon={<CloudDownload />}
//             size="medium"
//             onClick={onExportClick}
//             sx={{
//               width: { xs: "100%", md: "auto" },
//             }}
//           >
//             Export Report
//           </Button>
//         </Stack>
//       </Paper>
//       <Grid container spacing={4}>
//         <Grid item xs={12} lg={7}>
//           <Card
//             ref={skillChartRef}
//             sx={{
//               height: "100%",
//               width:"100%", // <-- Responsive width
//               backgroundColor: "mint.main",
//             }}
//           >
//             <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 fontWeight="bold"
//                 color="text.primary"
//               >
//                 Skill Distribution
//               </Typography>
//               {loading ? (
//                 <Skeleton variant="rectangular" height={450} />
//               ) : (
//                 <Grid
//                   container
//                   spacing={2}
//                   alignItems="center"
//                   sx={{ mt: 1 }}
//                 >
//                   <Grid item xs={12} md={8}>
//                     <SkillDonutChart
//                       data={data.skill_distribution}
//                       colors={colorPalette}
//                     />
//                   </Grid>
//                   <Grid item xs={12} md={4}>
//                     <SkillList
//                       data={data.skill_distribution}
//                       colors={colorPalette}
//                     />
//                   </Grid>
//                 </Grid>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} lg={5}>
//           <Card
//             ref={locationTableRef}
//             sx={{
//               height: "100%",
//               width: "100%", // <-- Responsive width
//               maxWidth: "700px", // <-- Max width for larger screens
//               margin: "0 auto", // Center the card
//               backgroundColor: "mint.main",
//             }}
//           >
//             <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 fontWeight="bold"
//                 color="text.primary"
//               >
//                 Candidate Locations
//               </Typography>
//               <TableContainer sx={{ mt: 3, maxHeight: 450 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>
//                         <Typography variant="subtitle2" fontWeight="bold">
//                           Location
//                         </Typography>
//                       </TableCell>
//                       <TableCell align="right">
//                         <Typography variant="subtitle2" fontWeight="bold">
//                           Candidates
//                         </Typography>
//                       </TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {loading
//                       ? Array.from(new Array(5)).map((_, index) => (
//                           <TableRow key={index}>
//                             <TableCell>
//                               <Skeleton variant="text" />
//                             </TableCell>
//                             <TableCell align="right">
//                               <Skeleton
//                                 variant="rounded"
//                                 width={40}
//                                 height={24}
//                               />
//                             </TableCell>
//                           </TableRow>
//                         ))
//                       : data.candidate_locations.map((loc) => (
//                           <TableRow
//                             key={loc.location}
//                             sx={{
//                               "&:hover": {
//                                 bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
//                               },
//                             }}
//                           >
//                             <TableCell component="th" scope="row">
//                               <Typography variant="body2" fontWeight="500">
//                                 {loc.location}
//                               </Typography>
//                             </TableCell>
//                             <TableCell align="right">
//                               <Chip
//                                 label={loc.candidates}
//                                 size="small"
//                                 color="primary"
//                                 variant="outlined"
//                               />
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
//     </Stack>
//   );
// };

// // MODIFIED: CandidatesTab component is now responsive
// const CandidatesTab = ({
//   loading,
//   candidates,
//   totalCandidates,
//   page,
//   rowsPerPage,
//   handleChangePage,
//   handleChangeRowsPerPage,
// }) => {
//   const theme = useTheme();
//   const getExperienceTooltip = (experienceArray) => {
//     if (!Array.isArray(experienceArray) || experienceArray.length === 0) {
//       return "No experience details available.";
//     }
//     return experienceArray
//       .map(
//         (exp) =>
//           `${exp.title || "N/A"} at ${exp.company || "N/A"} (${
//             exp.duration || "N/A"
//           })`
//       )
//       .join("\n");
//   };

//   return (
//     <Card
//       sx={{
//         backgroundColor: "mint.main",
//       }}
//     >
//       <CardContent sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
//         <Typography
//           variant="h6"
//           gutterBottom
//           fontWeight="bold"
//           color="text.primary"
//         >
//           Top Candidates
//         </Typography>
//         {/* ADDED: Box with overflowX for horizontal scrolling on small screens */}
//         <Box sx={{ overflowX: "auto" }}>
//           <TableContainer sx={{ mt: 3 }}>
//             <Table sx={{ minWidth: 650 }} aria-label="top candidates table">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Candidate</TableCell>
//                   <TableCell>Experience</TableCell>
//                   <TableCell>Top Skills</TableCell>
//                   <TableCell>Match Score</TableCell>
//                   <TableCell>Status</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {loading
//                   ? Array.from(new Array(rowsPerPage)).map((_, index) => (
//                       <TableRow key={index}>
//                         <TableCell>
//                           <Stack
//                             direction="row"
//                             alignItems="center"
//                             spacing={2}
//                           >
//                             <Skeleton
//                               variant="circular"
//                               width={48}
//                               height={48}
//                             />
//                             <Stack spacing={0.5}>
//                               <Skeleton variant="text" width={120} />
//                               <Skeleton variant="text" width={100} />
//                             </Stack>
//                           </Stack>
//                         </TableCell>
//                         <TableCell>
//                           <Skeleton variant="text" width={100} />
//                         </TableCell>
//                         <TableCell>
//                           <Stack direction="row" spacing={0.5} flexWrap="wrap">
//                             <Skeleton
//                               variant="rounded"
//                               width={60}
//                               height={24}
//                             />
//                             <Skeleton
//                               variant="rounded"
//                               width={70}
//                               height={24}
//                             />
//                             <Skeleton
//                               variant="rounded"
//                               width={50}
//                               height={24}
//                             />
//                           </Stack>
//                         </TableCell>
//                         <TableCell>
//                           <Stack
//                             direction="row"
//                             alignItems="center"
//                             spacing={2}
//                           >
//                             <Skeleton
//                               variant="rectangular"
//                               width={100}
//                               height={8}
//                               sx={{ borderRadius: 1 }}
//                             />
//                             <Skeleton variant="text" width={30} />
//                           </Stack>
//                         </TableCell>
//                         <TableCell>
//                           <Skeleton
//                             variant="rounded"
//                             width={90}
//                             height={28}
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   : candidates.map((candidate) => (
//                       <TableRow
//                         key={candidate.candidate_id}
//                         hover
//                         sx={{
//                           "&:hover": {
//                             bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
//                           },
//                         }}
//                       >
//                         <TableCell>
//                           <Stack
//                             direction="row"
//                             alignItems="center"
//                             spacing={2}
//                           >
//                             <Avatar
//                               src={candidate.avatar}
//                               sx={{ width: 48, height: 48 }}
//                             />
//                             <Stack>
//                               <Typography variant="body2" fontWeight="600">
//                                 {candidate.candidate_name}
//                               </Typography>
//                               <Stack
//                                 direction="row"
//                                 alignItems="center"
//                                 spacing={0.5}
//                               >
//                                 <LocationOn
//                                   sx={{
//                                     fontSize: 16,
//                                     color: "text.secondary",
//                                   }}
//                                 />
//                                 <Typography
//                                   variant="caption"
//                                   color="text.secondary"
//                                 >
//                                   {candidate.location}
//                                 </Typography>
//                               </Stack>
//                             </Stack>
//                           </Stack>
//                         </TableCell>
//                         <TableCell>
//                           <Tooltip
//                             title={
//                               <div style={{ whiteSpace: "pre-line" }}>
//                                 {getExperienceTooltip(candidate.experience)}
//                               </div>
//                             }
//                             arrow
//                           >
//                             <Typography
//                               variant="body2"
//                               sx={{ cursor: "pointer" }}
//                             >
//                               {(candidate.experience &&
//                                 candidate.experience[0]?.duration) ||
//                                 "N/A"}
//                             </Typography>
//                           </Tooltip>
//                         </TableCell>
//                         <TableCell>
//                           <Tooltip
//                             title={
//                               Array.isArray(candidate.skills)
//                                 ? candidate.skills.join(", ")
//                                 : ""
//                             }
//                             arrow
//                             placement="top"
//                           >
//                             <Stack
//                               direction="row"
//                               spacing={0.5}
//                               flexWrap="wrap"
//                               sx={{ cursor: "pointer", gap: 0.5 }}
//                             >
//                               {Array.isArray(candidate.skills) &&
//                                 candidate.skills.slice(0, 3).map((skill) => (
//                                   <Chip
//                                     key={skill}
//                                     label={skill}
//                                     size="small"
//                                     variant="outlined"
//                                   />
//                                 ))}
//                             </Stack>
//                           </Tooltip>
//                         </TableCell>
//                         <TableCell>
//                           <Stack
//                             direction="row"
//                             alignItems="center"
//                             spacing={2}
//                           >
//                             <LinearProgress
//                               variant="determinate"
//                               value={candidate.match_score}
//                               sx={{
//                                 width: 100,
//                                 height: 8,
//                                 borderRadius: 1,
//                               }}
//                             />
//                             <Typography
//                               variant="body2"
//                               color="text.secondary"
//                               fontWeight="500"
//                             >
//                               {candidate.match_score}%
//                             </Typography>
//                           </Stack>
//                         </TableCell>
//                         <TableCell>
//                           <Chip
//                             icon={getStatusIcon(candidate.status)}
//                             label={
//                               candidate.status.charAt(0).toUpperCase() +
//                               candidate.status.slice(1)
//                             }
//                             color={getStatusColor(candidate.status)}
//                             size="small"
//                             variant="filled"
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Box>
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25]}
//           component="div"
//           count={totalCandidates}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </CardContent>
//     </Card>
//   );
// };

// function EmployerAnalytics() {
//   const theme = useTheme();
//   const [tabValue, setTabValue] = useState(0);
//   const [timeRange, setTimeRange] = useState("last30days");
//   const [jobFilter, setJobFilter] = useState("all");
//   const [loading, setLoading] = useState(true);
//   const [candidatesData, setCandidatesData] = useState([]);
//   const [overviewData, setOverviewData] = useState({
//     summary_stats: {
//       total_applications: 0,
//       total_interviews: 0,
//       total_hires: 0,
//       acceptance_rate: "0%",
//     },
//     application_trend: [],
//     recent_activity: [],
//   });
//   const [demographicsData, setDemographicsData] = useState({
//     skill_distribution: [],
//     candidate_locations: [],
//   });
//   const [trendsData, setTrendsData] = useState(null);
//   const [filterOptions, setFilterOptions] = useState({
//     job_roles: ["All Jobs"],
//     time_ranges: [
//       "Last Month",
//       "Last 3 Months",
//       "Last 6 Months",
//       "Last Year",
//     ],
//   });
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [isExportModalOpen, setIsExportModalOpen] = useState(false);
//   const skillChartRef = useRef(null);
//   const locationTableRef = useRef(null);

//   const safeJsonParse = (str, fallback = []) => {
//     if (typeof str !== "string") return fallback;
//     try {
//       return JSON.parse(str);
//     } catch (e) {
//       return fallback;
//     }
//   };

//   useEffect(() => {
//     const fetchInitialData = async () => {
//       setLoading(true);
//       try {
//         const [candidatesResponse, overviewResponse, trendsResponse] =
//           await Promise.all([
//             apiClient.get("/hiring-analytics/top-matching-candidates/"),
//             apiClient.get("/hiring-analytics/combined-dashboard/"),
//             apiClient.get("/employer-analytics/trends"),
//           ]);
//         const mappedCandidates = candidatesResponse.data.map(
//           (apiCandidate) => ({
//             candidate_id: apiCandidate.candidate_id,
//             candidate_name: apiCandidate.candidate_name,
//             skills: apiCandidate.skills || [],
//             match_score: apiCandidate.match_score,
//             avatar: `/placeholder.svg?height=40&width=40`,
//             experience: safeJsonParse(apiCandidate.experience, []),
//             location: apiCandidate.location || "N/A",
//             status: apiCandidate.status
//               ? apiCandidate.status.toLowerCase()
//               : "matched",
//           })
//         );

//         setCandidatesData(mappedCandidates);
//         setOverviewData(overviewResponse.data);
//         setTrendsData(trendsResponse.data);
//       } catch (error) {
//         console.error("Failed to fetch initial data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchInitialData();
//   }, []);

//   useEffect(() => {
//     const fetchDemographicsData = async () => {
//       setLoading(true);
//       let url = "/demographics/";
//       if (jobFilter !== "all") {
//         url = `/demographics/job/${encodeURIComponent(jobFilter)}/`;
//       } else if (timeRange !== "all") {
//         url = `/demographics/time/${timeRange}/`;
//       }

//       try {
//         const response = await apiClient.get(url);
//         setDemographicsData(response.data);
//         if (response.data.filter_options) {
//           setFilterOptions(response.data.filter_options);
//         }
//       } catch (error) {
//         console.error("Failed to fetch demographics data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDemographicsData();
//   }, [jobFilter, timeRange]);

//   const handleTabChange = (event, newValue) => setTabValue(newValue);
//   const handleTimeRangeChange = (event) => {
//     setTimeRange(event.target.value);
//     setJobFilter("all");
//   };
//   const handleJobFilterChange = (event) => {
//     setJobFilter(event.target.value);
//     setTimeRange("all");
//   };
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   return (
//     <Layout title="Hiring Analytics">
//       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
//         <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 } }}>
//           <Stack spacing={{ xs: 2, md: 4 }}>
//             <Paper
//               sx={{
//                 p: { xs: 2, sm: 3 },
//                 backgroundColor: "mint.main",
//                 color: "primary.main",
//               }}
//             >
//               <Typography
//                 variant="h4"
//                 component="h1"
//                 fontWeight="bold"
//                 sx={{
//                   background: (theme) => theme.palette.primary.main,
//                   backgroundClip: "text",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                   fontSize: { xs: "1.75rem", sm: "2.5rem" },
//                 }}
//               >
//                 Hiring Analytics Dashboard
//               </Typography>
//             </Paper>

//             <Paper
//               elevation={0}
//               sx={{
//                 backgroundColor: "background.paper",
//                 overflow: "hidden",
//                  backgroundColor: "mint.main",

//               }}
//             >
//               <Tabs
//                 value={tabValue}
//                 onChange={handleTabChange}
//                 indicatorColor="primary"
//                 textColor="primary"
//                 variant="scrollable"
//                 scrollButtons="auto"
//                 allowScrollButtonsMobile
//                 sx={{
//                   "& .MuiTab-root": {
//                     textTransform: "none",
//                     fontWeight: 600,
//                     fontSize: { xs: "0.8rem", sm: "0.875rem" },

//                   },
//                   "& .MuiTabs-indicator": {
//                     height: 3,
//                     borderRadius: "3px 3px 0 0",
//                   },
//                 }}
//               >
//                 <Tab
//                   icon={<BarChart />}
//                   label="OVERVIEW"
//                   iconPosition="start"
//                 />
//                 <Tab icon={<Timeline />} label="TRENDS" iconPosition="start" />
//                 <Tab
//                   icon={<PieChart />}
//                   label="DEMOGRAPHICS"
//                   iconPosition="start"
//                 />
//                 <Tab
//                   icon={<People />}
//                   label="CANDIDATES"
//                   iconPosition="start"
//                 />
//                 <Tab
//                   icon={<History />}
//                   label="RECENT ACTIVITY"
//                   iconPosition="start"
//                 />
//               </Tabs>
//             </Paper>

//             <Box>
//               <TabPanel value={tabValue} index={0}>
//                 <OverviewTab loading={loading} data={overviewData} />
//               </TabPanel>
//               <TabPanel value={tabValue} index={1}>
//                 <TrendsTab loading={loading} data={trendsData} />
//               </TabPanel>
//               <TabPanel value={tabValue} index={2}>
//                 <DemographicsTab
//                   loading={loading}
//                   data={demographicsData}
//                   skillChartRef={skillChartRef}
//                   locationTableRef={locationTableRef}
//                   timeRange={timeRange}
//                   handleTimeRangeChange={handleTimeRangeChange}
//                   jobFilter={jobFilter}
//                   handleJobFilterChange={handleJobFilterChange}
//                   filterOptions={filterOptions}
//                   onExportClick={() => setIsExportModalOpen(true)}
//                 />
//               </TabPanel>
//               <TabPanel value={tabValue} index={3}>
//                 <CandidatesTab
//                   loading={loading}
//                   candidates={candidatesData.slice(
//                     page * rowsPerPage,
//                     page * rowsPerPage + rowsPerPage
//                   )}
//                   totalCandidates={candidatesData.length}
//                   page={page}
//                   rowsPerPage={rowsPerPage}
//                   handleChangePage={handleChangePage}
//                   handleChangeRowsPerPage={handleChangeRowsPerPage}
//                 />
//               </TabPanel>
//               <TabPanel value={tabValue} index={4}>
//                 <RecentActivityTab
//                   loading={loading}
//                   data={overviewData.recent_activity}
//                 />
//               </TabPanel>
//             </Box>
//           </Stack>
//         </Container>
//       </Box>
//       <ExportReportDialog
//         open={isExportModalOpen}
//         onClose={() => setIsExportModalOpen(false)}
//         candidatesData={candidatesData}
//         demographicsData={demographicsData}
//         overviewData={overviewData}
//         skillChartRef={skillChartRef}
//         locationTableRef={locationTableRef}
//       />
//     </Layout>
//   );
// }

// export default EmployerAnalytics;

// // "use client";

// // import React, { useState, useEffect, useRef, useMemo } from "react";
// // import {
// //   Grid,
// //   Card,
// //   CardContent,
// //   Typography,
// //   Button,
// //   Box,
// //   Chip,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Avatar,
// //   Skeleton,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   CircularProgress,
// //   Stack,
// //   Paper,
// //   useTheme,
// //   Tabs,
// //   Tab,
// //   FormControl,
// //   Select,
// //   MenuItem,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   ListItemAvatar,
// //   LinearProgress,
// //   TablePagination,
// //   Tooltip,
// //   Container,
// //   Fade,
// //   Grow,
// //   alpha,
// //   RadioGroup,
// //   FormControlLabel,
// //   Radio,
// //   FormLabel,
// // } from "@mui/material";
// // import {
// //   People,
// //   LocationOn,
// //   TrendingUp,
// //   WorkOutline,
// //   School,
// //   BarChart,
// //   PieChart,
// //   Timeline,
// //   CloudDownload,
// //   Star,
// //   CheckCircle,
// //   HelpOutline,
// //   MonetizationOn,
// //   AccessTime,
// //   RateReview,
// //   History,
// //   ArrowDownward,
// // } from "@mui/icons-material";
// // import * as htmlToImage from "html-to-image";
// // import ReactApexChart from "react-apexcharts";
// // import Layout from "../common/Layout";
// // import apiClient from "../../context/apiClient";

// // // NOTE: No changes needed in utility functions
// // const downloadFile = ({ data, fileName, fileType }) => {
// //   const blob = new Blob([data], { type: fileType });
// //   const a = document.createElement("a");
// //   a.download = fileName;
// //   a.href = window.URL.createObjectURL(blob);
// //   const clickEvt = new MouseEvent("click", {
// //     view: window,
// //     bubbles: true,
// //     cancelable: true,
// //   });
// //   a.dispatchEvent(clickEvt);
// //   a.remove();
// // };

// // const convertToCSV = (data) => {
// //   if (!data || data.length === 0) return "";
// //   const headers = Object.keys(data[0]);
// //   const csvRows = [headers.join(",")];
// //   for (const row of data) {
// //     const values = headers.map((header) => {
// //       const escaped = ("" + row[header]).replace(/"/g, '""');
// //       return `"${escaped}"`;
// //     });
// //     csvRows.push(values.join(","));
// //   }
// //   return csvRows.join("\n");
// // };

// // const generateUniqueColors = (count) => {
// //   if (count === 0) return [];
// //   const colors = [];
// //   const hueStep = 360 / count;
// //   for (let i = 0; i < count; i++) {
// //     const hue = i * hueStep;
// //     colors.push(`hsl(${hue}, 70%, 50%)`);
// //   }
// //   return colors;
// // };

// // // NOTE: No changes needed in ExportReportDialog as it inherits styles from the theme
// // const ExportReportDialog = ({
// //   open,
// //   onClose,
// //   candidatesData,
// //   demographicsData,
// //   overviewData,
// //   skillChartRef,
// //   locationTableRef,
// // }) => {
// //   const [reportType, setReportType] = useState("demographics_skills");
// //   const [format, setFormat] = useState("png");

// //   const handleDownload = async () => {
// //     let dataToExport = [];
// //     let fileName = `${reportType}_report`;
// //     const isImageFormat = format === "png";

// //     if (isImageFormat) {
// //       const elementToCapture =
// //         reportType === "demographics_skills"
// //           ? skillChartRef.current
// //           : locationTableRef.current;
// //       if (!elementToCapture) {
// //         console.error("Target element for image capture not found.");
// //         return;
// //       }
// //       try {
// //         const dataUrl = await htmlToImage.toPng(elementToCapture);
// //         const a = document.createElement("a");
// //         a.href = dataUrl;
// //         a.download = `${reportType}_${new Date()
// //           .toISOString()
// //           .slice(0, 10)}.png`;
// //         a.click();
// //       } catch (error) {
// //         console.error("Failed to capture component as image", error);
// //       }
// //     } else {
// //       switch (reportType) {
// //         case "candidates":
// //           dataToExport = candidatesData.map((c) => ({
// //             id: c.candidate_id,
// //             name: c.candidate_name,
// //             location: c.location,
// //             status: c.status,
// //             match_score: c.match_score,
// //             skills: c.skills.join("|"),
// //             experience: c.experience
// //               .map((e) => `${e.title} at ${e.company}`)
// //               .join(" | "),
// //           }));
// //           break;
// //         case "demographics_skills":
// //           dataToExport = demographicsData.skill_distribution;
// //           fileName = "skill_distribution_report";
// //           break;
// //         case "demographics_locations":
// //           dataToExport = demographicsData.candidate_locations;
// //           fileName = "candidate_locations_report";
// //           break;
// //         case "overview":
// //           dataToExport = [overviewData.summary_stats];
// //           break;
// //         default:
// //           console.error("Invalid report type");
// //           return;
// //       }

// //       if (format === "csv") {
// //         const csvData = convertToCSV(dataToExport);
// //         downloadFile({
// //           data: csvData,
// //           fileName: `${fileName}.csv`,
// //           fileType: "text/csv",
// //         });
// //       } else if (format === "json") {
// //         downloadFile({
// //           data: JSON.stringify(dataToExport, null, 2),
// //           fileName: `${fileName}.json`,
// //           fileType: "application/json",
// //         });
// //       }
// //     }
// //     onClose();
// //   };

// //   const isVisualReport =
// //     reportType === "demographics_skills" ||
// //     reportType === "demographics_locations";

// //   return (
// //     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
// //       <DialogTitle fontWeight="bold">Export Report</DialogTitle>
// //       <DialogContent dividers>
// //         <Stack spacing={4}>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Report Type
// //             </FormLabel>
// //             <RadioGroup
// //               value={reportType}
// //               onChange={(e) => setReportType(e.target.value)}
// //             >
// //               <FormControlLabel
// //                 value="demographics_skills"
// //                 control={<Radio />}
// //                 label="Skill Distribution"
// //               />
// //               <FormControlLabel
// //                 value="demographics_locations"
// //                 control={<Radio />}
// //                 label="Candidate Locations"
// //               />
// //               <FormControlLabel
// //                 value="candidates"
// //                 control={<Radio />}
// //                 label="Top Candidates (Data Only)"
// //               />
// //               <FormControlLabel
// //                 value="overview"
// //                 control={<Radio />}
// //                 label="Hiring Stats Overview (Data Only)"
// //               />
// //             </RadioGroup>
// //           </FormControl>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Format
// //             </FormLabel>
// //             <RadioGroup
// //               row
// //               value={format}
// //               onChange={(e) => setFormat(e.target.value)}
// //             >
// //               <FormControlLabel
// //                 value="png"
// //                 control={<Radio />}
// //                 label="Image (PNG)"
// //                 disabled={!isVisualReport}
// //               />
// //               <FormControlLabel value="csv" control={<Radio />} label="CSV" />
// //               <FormControlLabel value="json" control={<Radio />} label="JSON" />
// //             </RadioGroup>
// //           </FormControl>
// //         </Stack>
// //       </DialogContent>
// //       <DialogActions sx={{ p: 2 }}>
// //         <Button onClick={onClose} color="inherit">
// //           Cancel
// //         </Button>
// //         <Button
// //           onClick={handleDownload}
// //           variant="contained"
// //           startIcon={<CloudDownload />}
// //         >
// //           Download
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // const cleanSkill = (skill) => {
// //   return skill.replace(/[\[\]"]/g, "");
// // };

// // const SkillDonutChart = ({ data, colors }) => {
// //   const theme = useTheme();
// //   const chartSeries = data.map((item) => item.count);
// //   const chartOptions = {
// //     chart: { type: "donut", background: "transparent" },
// //     plotOptions: {
// //       pie: {
// //         donut: {
// //           size: "70%",
// //           labels: {
// //             show: true,
// //             total: {
// //               show: true,
// //               label: "Total Skills",
// //               color: theme.palette.text.secondary,
// //               formatter: (w) =>
// //                 w.globals.seriesTotals.reduce((a, b) => a + b, 0),
// //             },
// //           },
// //         },
// //       },
// //     },
// //     dataLabels: { enabled: false },
// //     legend: { show: false },
// //     colors: colors,
// //     tooltip: { y: { formatter: (val) => `${val} candidates` } },
// //     theme: {
// //       mode: theme.palette.mode,
// //     },
// //     stroke: {
// //         colors: [theme.palette.background.paper],
// //     },
// //   };
// //   return (
// //     <ReactApexChart
// //       options={chartOptions}
// //       series={chartSeries}
// //       type="donut"
// //       height={420}
// //     />
// //   );
// // };

// // const SkillList = ({ data, colors }) => {
// //   return (
// //     <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 2 }}>
// //       <List>
// //         {data.map((item, index) => (
// //           <ListItem key={item.skill} disablePadding>
// //             <Stack
// //               direction="row"
// //               alignItems="center"
// //               spacing={2}
// //               sx={{ width: "100%", py: 0.5 }}
// //             >
// //               <Box
// //                 sx={{
// //                   width: 16,
// //                   height: 16,
// //                   borderRadius: "4px",
// //                   bgcolor: colors[index % colors.length],
// //                   flexShrink: 0,
// //                 }}
// //               />
// //               <ListItemText
// //                 primary={
// //                   <Typography variant="body2" color="text.primary" noWrap>
// //                     {cleanSkill(item.skill)}
// //                   </Typography>
// //                 }
// //               />
// //               <Typography
// //                 variant="body2"
// //                 color="text.secondary"
// //                 fontWeight="bold"
// //               >
// //                 {item.count}
// //               </Typography>
// //             </Stack>
// //           </ListItem>
// //         ))}
// //       </List>
// //     </Box>
// //   );
// // };

// // const ApplicationTrendChart = ({ data, height = 450 }) => {
// //   const theme = useTheme();

// //   if (
// //     !data ||
// //     !data.datasets ||
// //     !data.datasets[0] ||
// //     !data.datasets[0].data ||
// //     data.datasets[0].data.length === 0
// //   ) {
// //     return (
// //       <Box
// //         sx={{
// //           height,
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           bgcolor: (theme) => alpha(theme.palette.divider, 0.04),
// //           borderRadius: 2,
// //           border: (theme) => `1px dashed ${theme.palette.divider}`,
// //           m: 3,
// //         }}
// //       >
// //         <Typography variant="body2" color="text.secondary">
// //           No trend data available.
// //         </Typography>
// //       </Box>
// //     );
// //   }

// //   const chartSeries = [
// //     {
// //       name: "Applications",
// //       data: data.datasets[0].data,
// //     },
// //   ];

// //   const chartOptions = {
// //     chart: {
// //       type: "area",
// //       height: height,
// //       toolbar: {
// //         show: false,
// //       },
// //       zoom: {
// //         enabled: false,
// //       },
// //       background: "transparent",
// //     },
// //     colors: [theme.palette.primary.main],
// //     dataLabels: {
// //       enabled: false,
// //     },
// //     stroke: {
// //       curve: "smooth",
// //       width: 3,
// //       lineCap: "round",
// //     },
// //     fill: {
// //       type: "gradient",
// //       gradient: {
// //         shadeIntensity: 1,
// //         opacityFrom: 0.4,
// //         opacityTo: 0.1,
// //         stops: [0, 90, 100],
// //       },
// //     },
// //     grid: {
// //       show: true,
// //       borderColor: theme.palette.divider,
// //       strokeDashArray: 4,
// //       xaxis: {
// //         lines: {
// //           show: false,
// //         },
// //       },
// //       yaxis: {
// //         lines: {
// //           show: true,
// //         },
// //       },
// //     },
// //     xaxis: {
// //       categories: data.labels,
// //       axisBorder: {
// //         show: false,
// //       },
// //       axisTicks: {
// //         show: false,
// //       },
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //           fontWeight: 500,
// //         },
// //       },
// //     },
// //     yaxis: {
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //         },
// //         formatter: function (val) {
// //           return val.toFixed(0);
// //         },
// //       },
// //     },
// //     tooltip: {
// //       x: {
// //         format: "MMM yyyy",
// //       },
// //       y: {
// //         formatter: (val) => `${val} applications`,
// //       },
// //       theme: theme.palette.mode,
// //       marker: {
// //         show: true,
// //       },
// //     },
// //   };

// //   return (
// //     <ReactApexChart
// //       options={chartOptions}
// //       series={chartSeries}
// //       type="area"
// //       height={height}
// //     />
// //   );
// // };

// // function TabPanel(props) {
// //   const { children, value, index, ...other } = props;
// //   return (
// //     <div
// //       role="tabpanel"
// //       hidden={value !== index}
// //       id={`analytics-tabpanel-${index}`}
// //       aria-labelledby={`analytics-tab-${index}`}
// //       {...other}
// //     >
// //       {value === index && (
// //         <Fade in={value === index} timeout={500}>
// //           <Box sx={{ pt: 4 }}>{children}</Box>
// //         </Fade>
// //       )}
// //     </div>
// //   );
// // }

// // const getStatusColor = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return "success";
// //     case "interviewed":
// //       return "primary";
// //     case "shortlisted":
// //       return "info";
// //     case "applied":
// //     case "matched":
// //       return "warning";
// //     default:
// //       return "default";
// //   }
// // };

// // const getStatusIcon = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return <CheckCircle />;
// //     case "interviewed":
// //       return <People />;
// //     case "shortlisted":
// //       return <Star />;
// //     case "applied":
// //     case "matched":
// //       return <WorkOutline />;
// //     default:
// //       return <HelpOutline />;
// //   }
// // };

// // const OverviewTab = ({ loading, data }) => {
// //   const theme = useTheme();

// //   const applicationTrendsData = {
// //     labels: data.application_trend?.map((d) => d.month) || [],
// //     datasets: [
// //       {
// //         label: "Applications",
// //         data: data.application_trend?.map((d) => d.application_count) || [],
// //         backgroundColor: theme.palette.primary.main,
// //       },
// //     ],
// //   };

// //   const statCards = [
// //     {
// //       label: "Total Applications",
// //       value: data.summary_stats?.total_applications || 0,
// //     },
// //     {
// //       label: "Total Interviews",
// //       value: data.summary_stats?.total_interviews || 0,
// //     },
// //     {
// //       label: "Total Hires",
// //       value: data.summary_stats?.total_hires || 0,
// //     },
// //     {
// //       label: "Acceptance Rate",
// //       value: data.summary_stats?.acceptance_rate || "0%",
// //     },
// //   ];

// //   return (
// //     <Stack spacing={4}>
// //       <Grid container spacing={{ xs: 2, md: 3 }}>
// //         {loading
// //           ? [...Array(4)].map((_, index) => (
// //               <Grid item xs={12} sm={6} md={3} key={index}>
// //                 <Skeleton
// //                   variant="rectangular"
// //                   width="100%"
// //                   height={140}
// //                   sx={{ borderRadius: "12px" }}
// //                 />
// //               </Grid>
// //             ))
// //           : statCards.map((card, index) => (
// //               <Box key={index} sx={{ flex: 1, minWidth: 0 }}>

// //                 <Box
// //                    sx={{
// //                         width: "100%",
// //                         height: 140,
// //                         backgroundColor: "primary.main", // Use theme color
// //                         borderRadius: "12px",
// //                         boxShadow: theme.shadows[3],
// //                         position: "relative",
// //                         overflow: "hidden",
// //                         p: { xs: 1.5, sm: 2, md: 2.5 },
// //                         display: "flex",
// //                         flexDirection: "column",
// //                         justifyContent: "space-between",
// //                       }}
// //                 >
// //                   <Box
// //                     sx={{
// //                       position: "absolute",
// //                       top: 0,
// //                       right: 0,
// //                       width: "100%",
// //                       height: "100%",
// //                       zIndex: 0,
// //                     }}
// //                   >
// //                     <svg
// //                        width="100%" height="100%" viewBox="0 0 280 140"
// //                           preserveAspectRatio="none"
// //                           style={{ position: "absolute", right: 0, top: 0 }}
// //                     >
// //                       <path
// //                         d="M200 0 L280 0 L280 140 C 250 140, 230 105, 230 70 C 230 35, 250 0, 200 0 Z"
// //                         fill={theme.palette.accent.main}
// //                       />
// //                     </svg>
// //                   </Box>
// //                   <Box sx={{ position: "relative", zIndex: 1 }}>
// //                     <Typography
// //                       sx={{
// //                         fontSize: { xs: "0.7rem", sm: "0.75rem" },
// //                         fontWeight: 600,
// //                         color: alpha(
// //                           theme.palette.primary.contrastText,
// //                           0.85
// //                         ),
// //                         textTransform: "uppercase",
// //                         lineHeight: 1.2,
// //                       }}
// //                     >
// //                       {card.label}
// //                     </Typography>
// //                   </Box>
// //                   <Box sx={{ position: "relative", zIndex: 1 }}>
// //                     <Typography
// //                       sx={{
// //                         fontSize: {
// //                           xs: "1.75rem",
// //                           sm: "2rem",
// //                           md: "2.25rem",
// //                         },
// //                         fontWeight: "bold",
// //                         color: "primary.contrastText",
// //                         lineHeight: 1,
// //                       }}
// //                     >
// //                       {card.value}
// //                     </Typography>
// //                   </Box>
// //                 </Box>
// //               </Box>
// //             ))}
// //       </Grid>

// //       <Card
// //         sx={{
// //           backgroundColor: "mint.main",
// //           transition: "all 0.3s ease",
// //           "&:hover": { boxShadow: theme.shadows[8] },
// //         }}
// //       >
// //         <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
// //           <Box sx={{ p: { xs: 2, sm: 3 }, pb: 0 }}>
// //             {loading ? (
// //               <Skeleton variant="text" width="60%" height={32} />
// //             ) : (
// //               <Typography
// //                 variant="h6"
// //                 fontWeight="bold"
// //                 color="text.primary"
// //               >
// //                 Application Trends
// //               </Typography>
// //             )}
// //           </Box>
// //           {loading ? (
// //             <Box sx={{ p: { xs: 2, sm: 3 } }}>
// //               <Skeleton
// //                 variant="rectangular"
// //                 height={400}
// //                 sx={{ borderRadius: 2 }}
// //               />
// //             </Box>
// //           ) : (
// //             <ApplicationTrendChart data={applicationTrendsData} />
// //           )}
// //         </CardContent>
// //       </Card>
// //     </Stack>
// //   );
// // };

// // const RecentActivityTab = ({ loading, data }) => {
// //   const theme = useTheme();

// //   const getActivityIcon = (activityString) => {
// //     const lowerCaseActivity = activityString.toLowerCase();
// //     if (lowerCaseActivity.includes("hired")) return <CheckCircle />;
// //     if (lowerCaseActivity.includes("interview")) return <People />;
// //     if (lowerCaseActivity.includes("applied")) return <WorkOutline />;
// //     return <RateReview />;
// //   };

// //   return (
// //     <Card
// //       sx={{
// //         backgroundColor: "mint.main",
// //         transition: "all 0.3s ease",
// //         "&:hover": { boxShadow: theme.shadows[8] },
// //       }}
// //     >
// //       <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //         {loading ? (
// //           <Skeleton variant="text" width="50%" height={32} />
// //         ) : (
// //           <Typography
// //             variant="h6"
// //             fontWeight="bold"
// //             gutterBottom
// //             color="text.primary"
// //           >
// //             Recent Activity
// //           </Typography>
// //         )}
// //         <List sx={{ mt: 2 }}>
// //           {loading
// //             ? Array.from(new Array(5)).map((_, index) => (
// //                 <ListItem key={index} sx={{ px: 0, py: 1.5 }}>
// //                   <ListItemAvatar>
// //                     <Skeleton variant="circular" width={48} height={48} />
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={<Skeleton variant="text" width="80%" />}
// //                     secondary={<Skeleton variant="text" width="60%" />}
// //                   />
// //                 </ListItem>
// //               ))
// //             : data?.map((activity, index) => (
// //                 <ListItem
// //                   key={`${activity.candidate_name}-${index}`}
// //                   sx={{
// //                     px: 0,
// //                     py: 1.5,
// //                     borderRadius: 2,
// //                     transition: "all 0.2s ease",
// //                     "&:hover": {
// //                       bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
// //                     },
// //                   }}
// //                 >
// //                   <ListItemAvatar>
// //                     <Avatar
// //                       sx={{
// //                         bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
// //                         color: "primary.main",
// //                         width: 48,
// //                         height: 48,
// //                         boxShadow: theme.shadows[2],
// //                       }}
// //                     >
// //                       {getActivityIcon(activity.activity)}
// //                     </Avatar>
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={
// //                       <Typography
// //                         variant="body2"
// //                         fontWeight="600"
// //                         color="text.primary"
// //                       >
// //                         {activity.candidate_name}
// //                       </Typography>
// //                     }
// //                     secondary={
// //                       <Typography variant="caption" color="text.secondary">
// //                         {activity.activity} • {activity.time_ago}
// //                       </Typography>
// //                     }
// //                   />
// //                 </ListItem>
// //               ))}
// //         </List>
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // const TrendsTab = ({ loading, data }) => {
// //   const theme = useTheme();

// //   const funnelData = [
// //     {
// //       icon: <WorkOutline color="primary" />,
// //       title: "Applications",
// //       value: data?.hiring_funnel?.applications || 0,
// //       color: theme.palette.primary.main,
// //     },
// //     {
// //       icon: <People color="secondary" />,
// //       title: "Interviews",
// //       value: data?.hiring_funnel?.interviews || 0,
// //       conversion: data?.hiring_funnel?.interview_conversion_rate || "0%",
// //       color: theme.palette.secondary.main,
// //     },
// //     {
// //       icon: <CheckCircle color="success" />,
// //       title: "Hires",
// //       value: data?.hiring_funnel?.hires || 0,
// //       conversion: data?.hiring_funnel?.hire_conversion_rate || "0%",
// //       color: theme.palette.success.main,
// //     },
// //   ];

// //   const kpiData = [
// //     {
// //       icon: <AccessTime />,
// //       title: "Average Time to Hire",
// //       value: data?.key_performance_metrics?.average_time_to_hire || "N/A",
// //       color: theme.palette.primary,
// //     },
// //     {
// //       icon: <MonetizationOn />,
// //       title: "Cost Per Hire",
// //       value: data?.key_performance_metrics?.cost_per_hire || "N/A",
// //       color: theme.palette.success,
// //     },
// //     {
// //       icon: <RateReview />,
// //       title: "Offer Acceptance Rate",
// //       value: data?.key_performance_metrics?.offer_acceptance_rate || "N/A",
// //       color: theme.palette.secondary,
// //     },
// //   ];

// //   return (
// //     <Grid container spacing={4}>
// //       <Grid item xs={12} lg={5}>
// //         <Card
// //           sx={{
// //             height: "100%",
// //             width:"600px",// <-- ADD THIS
// //             backgroundColor: "mint.main",
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //             <Typography
// //               variant="h6"
// //               fontWeight="bold"
// //               gutterBottom
// //               color="text.primary"
// //             >
// //               Hiring Funnel
// //             </Typography>
// //             {loading ? (
// //               <Stack spacing={4} sx={{ mt: 3 }}>
// //                 <Skeleton
// //                   variant="rectangular"
// //                   height={60}
// //                   sx={{ borderRadius: 2 }}
// //                 />
// //                 <Skeleton
// //                   variant="rectangular"
// //                   height={60}
// //                   sx={{ borderRadius: 2 }}
// //                 />
// //                 <Skeleton
// //                   variant="rectangular"
// //                   height={60}
// //                   sx={{ borderRadius: 2 }}
// //                 />
// //               </Stack>
// //             ) : (
// //               <Stack spacing={2} sx={{ mt: 4 }}>
// //                 {funnelData.map((step, index) => (
// //                   <Grow in timeout={500 + index * 200} key={step.title}>
// //                     <Box>
// //                       <Paper
// //                         variant="outlined"
// //                         sx={{
// //                           p: 2,
// //                           display: "flex",
// //                           alignItems: "center",
// //                           borderRadius: 2,
// //                           borderColor: alpha(step.color, 0.3),
// //                           background: `linear-gradient(to right, ${alpha(
// //                             step.color,
// //                             0.1
// //                           )}, transparent)`,
// //                         }}
// //                       >
// //                         <Avatar
// //                           sx={{
// //                             bgcolor: alpha(step.color, 0.15),
// //                             color: step.color,
// //                             mr: 2,
// //                           }}
// //                         >
// //                           {step.icon}
// //                         </Avatar>
// //                         <Box sx={{ flexGrow: 1 }}>
// //                           <Typography variant="body2" color="text.secondary">
// //                             {step.title}
// //                           </Typography>
// //                           <Typography variant="h5" fontWeight="bold">
// //                             {step.value}
// //                           </Typography>
// //                         </Box>
// //                         {step.conversion && (
// //                           <Box sx={{ textAlign: "right" }}>
// //                             <Typography
// //                               variant="caption"
// //                               color="text.secondary"
// //                             >
// //                               Conversion
// //                             </Typography>
// //                             <Typography
// //                               variant="body1"
// //                               fontWeight="bold"
// //                               color={step.color}
// //                             >
// //                               {step.conversion}
// //                             </Typography>
// //                           </Box>
// //                         )}
// //                       </Paper>
// //                       {index < funnelData.length - 1 && (
// //                         <Box display="flex" justifyContent="center" my={1}>
// //                           <ArrowDownward sx={{ color: "divider" }} />
// //                         </Box>
// //                       )}
// //                     </Box>
// //                   </Grow>
// //                 ))}
// //               </Stack>
// //             )}
// //           </CardContent>
// //         </Card>
// //       </Grid>

// //       <Grid item xs={12} lg={7}>
// //         <Card
// //           sx={{
// //             height: "100%", // <-- ADD THIS
// //             width:"700px",
// //             backgroundColor: "mint.main",
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //             <Typography
// //               variant="h6"
// //               fontWeight="bold"
// //               gutterBottom
// //               color="text.primary"
// //             >
// //               Key Performance Metrics
// //             </Typography>
// //             <Grid container spacing={3} sx={{ mt: 2, height: "100%" }}>
// //               {loading
// //                 ? Array.from(new Array(3)).map((_, index) => (
// //                     <Grid item xs={12} sm={4} key={index}>
// //                       <Skeleton
// //                         variant="rectangular"
// //                         height={150}
// //                         sx={{ borderRadius: 2 }}
// //                       />
// //                     </Grid>
// //                   ))
// //                 : kpiData.map((kpi, index) => (
// //                     <Grid item xs={12} sm={4} key={kpi.title}>
// //                       <Grow in timeout={500 + index * 200}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{
// //                             p: { xs: 2, sm: 3 },
// //                             borderRadius: 2,
// //                             textAlign: "center",
// //                             height: "100%",
// //                             display: "flex",
// //                             flexDirection: "column",
// //                             justifyContent: "center",
// //                             borderColor: alpha(kpi.color.main, 0.3),
// //                             backgroundColor: alpha(kpi.color.main, 0.05),
// //                           }}
// //                         >
// //                           <Avatar
// //                             sx={{
// //                               bgcolor: alpha(kpi.color.main, 0.1),
// //                               color: kpi.color.main,
// //                               width: 56,
// //                               height: 56,
// //                               mx: "auto",
// //                               mb: 1.5,
// //                             }}
// //                           >
// //                             {kpi.icon}
// //                           </Avatar>
// //                           <Typography
// //                             variant="body2"
// //                             fontWeight="600"
// //                             color="text.primary"
// //                           >
// //                             {kpi.title}
// //                           </Typography>
// //                           <Typography
// //                             variant="h4"
// //                             fontWeight="bold"
// //                             color="text.primary"
// //                             sx={{ mt: 1 }}
// //                           >
// //                             {kpi.value}
// //                           </Typography>
// //                         </Paper>
// //                       </Grow>
// //                     </Grid>
// //                   ))}
// //             </Grid>
// //           </CardContent>
// //         </Card>
// //       </Grid>
// //     </Grid>
// //   );
// // };

// // const DemographicsTab = ({
// //   loading,
// //   data,
// //   skillChartRef,
// //   locationTableRef,
// //   timeRange,
// //   handleTimeRangeChange,
// //   jobFilter,
// //   handleJobFilterChange,
// //   filterOptions,
// //   onExportClick,
// // }) => {
// //   const theme = useTheme();
// //   const colorPalette = useMemo(() => {
// //     if (!data || !data.skill_distribution) {
// //       return [];
// //     }
// //     return generateUniqueColors(data.skill_distribution.length);
// //   }, [data.skill_distribution]);

// //   return (
// //     <Stack spacing={4}>
// //       <Paper
// //         elevation={0}
// //         sx={{
// //           p: 2,
// //           backgroundColor: "mint.main",
// //           border: (theme) => `1px solid ${theme.palette.divider}`,
// //         }}
// //       >
// //         <Stack
// //           direction={{ xs: "column", md: "row" }}
// //           spacing={2}
// //           alignItems="center"
// //           justifyContent="flex-end"
// //         >
// //           <FormControl size="small" sx={{ width: { xs: "100%", md: "auto" } }}>
// //             <Select
// //               value={timeRange}
// //               onChange={handleTimeRangeChange}
// //               sx={{
// //                 minWidth: 140,
// //               }}
// //             >
// //               <MenuItem value="last30days">Last Month</MenuItem>
// //               <MenuItem value="last3months">Last 3 Months</MenuItem>
// //               <MenuItem value="last6months">Last 6 Months</MenuItem>
// //               <MenuItem value="lastyear">Last Year</MenuItem>
// //             </Select>
// //           </FormControl>
// //           <FormControl size="small" sx={{ width: { xs: "100%", md: "auto" } }}>
// //             <Select
// //               value={jobFilter}
// //               onChange={handleJobFilterChange}
// //               sx={{
// //                  minWidth: 180,
// //               }}
// //             >
// //               {filterOptions.job_roles.map((job) => (
// //                 <MenuItem
// //                   key={job || "all-jobs"}
// //                   value={
// //                     job === "All Jobs" || !job ? "all" : job
// //                   }
// //                 >
// //                   {job || "All Jobs"}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <Button
// //             variant="outlined"
// //             startIcon={<CloudDownload />}
// //             size="medium"
// //             onClick={onExportClick}
// //             sx={{
// //               width: { xs: "100%", md: "auto" },
// //             }}
// //           >
// //             Export Report
// //           </Button>
// //         </Stack>
// //       </Paper>
// //       <Grid container spacing={4}>
// //         <Grid item xs={12} lg={7}>
// //           <Card
// //             ref={skillChartRef}
// //             sx={{
// //               height: "100%", // <-- ADD THIS
// //               width:"100%",
// //               backgroundColor: "mint.main",
// //             }}
// //           >
// //             <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //               <Typography
// //                 variant="h6"
// //                 gutterBottom
// //                 fontWeight="bold"
// //                 color="text.primary"
// //               >
// //                 Skill Distribution
// //               </Typography>
// //               {loading ? (
// //                 <Skeleton variant="rectangular" height={450} />
// //               ) : (
// //                 <Grid
// //                   container
// //                   spacing={2}
// //                   alignItems="center"
// //                   sx={{ mt: 1 }}
// //                 >
// //                   <Grid item xs={12} md={8}>
// //                     <SkillDonutChart
// //                       data={data.skill_distribution}
// //                       colors={colorPalette}
// //                     />
// //                   </Grid>
// //                   <Grid item xs={12} md={4}>
// //                     <SkillList
// //                       data={data.skill_distribution}
// //                       colors={colorPalette}
// //                     />
// //                   </Grid>
// //                 </Grid>
// //               )}
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} lg={5}>
// //           <Card
// //             ref={locationTableRef}
// //             sx={{
// //               height: "100%", // <-- ADD THIS
// //               width:"700px",
// //               backgroundColor: "mint.main",
// //             }}
// //           >
// //             <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //               <Typography
// //                 variant="h6"
// //                 gutterBottom
// //                 fontWeight="bold"
// //                 color="text.primary"
// //               >
// //                 Candidate Locations
// //               </Typography>
// //               <TableContainer sx={{ mt: 3, maxHeight: 450 }}>
// //                 <Table stickyHeader>
// //                   <TableHead>
// //                     <TableRow>
// //                       <TableCell>
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Location
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell align="right">
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Candidates
// //                         </Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   </TableHead>
// //                   <TableBody>
// //                     {loading
// //                       ? Array.from(new Array(5)).map((_, index) => (
// //                           <TableRow key={index}>
// //                             <TableCell>
// //                               <Skeleton variant="text" />
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Skeleton
// //                                 variant="rounded"
// //                                 width={40}
// //                                 height={24}
// //                               />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))
// //                       : data.candidate_locations.map((loc) => (
// //                           <TableRow
// //                             key={loc.location}
// //                             sx={{
// //                               "&:hover": {
// //                                 bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
// //                               },
// //                             }}
// //                           >
// //                             <TableCell component="th" scope="row">
// //                               <Typography variant="body2" fontWeight="500">
// //                                 {loc.location}
// //                               </Typography>
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Chip
// //                                 label={loc.candidates}
// //                                 size="small"
// //                                 color="primary"
// //                                 variant="outlined"
// //                               />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))}
// //                   </TableBody>
// //                 </Table>
// //               </TableContainer>
// //             </CardContent>
// //           </Card>
// //         </Grid>
// //       </Grid>
// //     </Stack>
// //   );
// // };

// // const CandidatesTab = ({
// //   loading,
// //   candidates,
// //   totalCandidates,
// //   page,
// //   rowsPerPage,
// //   handleChangePage,
// //   handleChangeRowsPerPage,
// // }) => {
// //   const theme = useTheme();
// //   const getExperienceTooltip = (experienceArray) => {
// //     if (!Array.isArray(experienceArray) || experienceArray.length === 0) {
// //       return "No experience details available.";
// //     }
// //     return experienceArray
// //       .map(
// //         (exp) =>
// //           `${exp.title || "N/A"} at ${exp.company || "N/A"} (${
// //             exp.duration || "N/A"
// //           })`
// //       )
// //       .join("\n");
// //   };

// //   return (
// //     <Card
// //       sx={{
// //         backgroundColor: "mint.main",
// //       }}
// //     >
// //       <CardContent sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
// //         <Typography
// //           variant="h6"
// //           gutterBottom
// //           fontWeight="bold"
// //           color="text.primary"
// //         >
// //           Top Candidates
// //         </Typography>
// //         <TableContainer sx={{ mt: 3 }}>
// //           <Table sx={{ minWidth: 650 }} aria-label="top candidates table">
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell>
// //                   Candidate
// //                 </TableCell>
// //                 <TableCell>
// //                   Experience
// //                 </TableCell>
// //                 <TableCell>
// //                   Top Skills
// //                 </TableCell>
// //                 <TableCell>
// //                   Match Score
// //                 </TableCell>
// //                 <TableCell>
// //                   Status
// //                 </TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {loading
// //                 ? Array.from(new Array(rowsPerPage)).map((_, index) => (
// //                     <TableRow key={index}>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton variant="circular" width={48} height={48} />
// //                           <Stack spacing={0.5}>
// //                             <Skeleton variant="text" width={120} />
// //                             <Skeleton variant="text" width={100} />
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton variant="text" width={100} />
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" spacing={0.5} flexWrap="wrap">
// //                           <Skeleton
// //                             variant="rounded"
// //                             width={60}
// //                             height={24}
// //                           />
// //                           <Skeleton
// //                             variant="rounded"
// //                             width={70}
// //                             height={24}
// //                           />
// //                           <Skeleton
// //                             variant="rounded"
// //                             width={50}
// //                             height={24}
// //                           />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton
// //                             variant="rectangular"
// //                             width={100}
// //                             height={8}
// //                             sx={{ borderRadius: 1 }}
// //                           />
// //                           <Skeleton variant="text" width={30} />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton
// //                           variant="rounded"
// //                           width={90}
// //                           height={28}
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))
// //                 : candidates.map((candidate) => (
// //                     <TableRow
// //                       key={candidate.candidate_id}
// //                       hover
// //                       sx={{
// //                         "&:hover": {
// //                           bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
// //                         },
// //                       }}
// //                     >
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Avatar
// //                             src={candidate.avatar}
// //                             sx={{ width: 48, height: 48 }}
// //                           />
// //                           <Stack>
// //                             <Typography variant="body2" fontWeight="600">
// //                               {candidate.candidate_name}
// //                             </Typography>
// //                             <Stack
// //                               direction="row"
// //                               alignItems="center"
// //                               spacing={0.5}
// //                             >
// //                               <LocationOn
// //                                 sx={{
// //                                   fontSize: 16,
// //                                   color: "text.secondary",
// //                                 }}
// //                               />
// //                               <Typography
// //                                 variant="caption"
// //                                 color="text.secondary"
// //                               >
// //                                 {candidate.location}
// //                               </Typography>
// //                             </Stack>
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={
// //                             <div style={{ whiteSpace: "pre-line" }}>
// //                               {getExperienceTooltip(candidate.experience)}
// //                             </div>
// //                           }
// //                           arrow
// //                         >
// //                           <Typography
// //                             variant="body2"
// //                             sx={{ cursor: "pointer" }}
// //                           >
// //                             {(candidate.experience &&
// //                               candidate.experience[0]?.duration) ||
// //                               "N/A"}
// //                           </Typography>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={
// //                             Array.isArray(candidate.skills)
// //                               ? candidate.skills.join(", ")
// //                               : ""
// //                           }
// //                           arrow
// //                           placement="top"
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={0.5}
// //                             flexWrap="wrap"
// //                             sx={{ cursor: "pointer", gap: 0.5 }}
// //                           >
// //                             {Array.isArray(candidate.skills) &&
// //                               candidate.skills.slice(0, 3).map((skill) => (
// //                                 <Chip
// //                                   key={skill}
// //                                   label={skill}
// //                                   size="small"
// //                                   variant="outlined"
// //                                 />
// //                               ))}
// //                           </Stack>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <LinearProgress
// //                             variant="determinate"
// //                             value={candidate.match_score}
// //                             sx={{
// //                               width: 100,
// //                               height: 8,
// //                               borderRadius: 1,
// //                             }}
// //                           />
// //                           <Typography
// //                             variant="body2"
// //                             color="text.secondary"
// //                             fontWeight="500"
// //                           >
// //                             {candidate.match_score}%
// //                           </Typography>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Chip
// //                           icon={getStatusIcon(candidate.status)}
// //                           label={
// //                             candidate.status.charAt(0).toUpperCase() +
// //                             candidate.status.slice(1)
// //                           }
// //                           color={getStatusColor(candidate.status)}
// //                           size="small"
// //                           variant="filled"
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //         <TablePagination
// //           rowsPerPageOptions={[5, 10, 25]}
// //           component="div"
// //           count={totalCandidates}
// //           rowsPerPage={rowsPerPage}
// //           page={page}
// //           onPageChange={handleChangePage}
// //           onRowsPerPageChange={handleChangeRowsPerPage}
// //         />
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // function EmployerAnalytics() {
// //   const theme = useTheme();
// //   const [tabValue, setTabValue] = useState(0);
// //   const [timeRange, setTimeRange] = useState("last30days");
// //   const [jobFilter, setJobFilter] = useState("all");
// //   const [loading, setLoading] = useState(true);
// //   const [candidatesData, setCandidatesData] = useState([]);
// //   const [overviewData, setOverviewData] = useState({
// //     summary_stats: {
// //       total_applications: 0,
// //       total_interviews: 0,
// //       total_hires: 0,
// //       acceptance_rate: "0%",
// //     },
// //     application_trend: [],
// //     recent_activity: [],
// //   });
// //   const [demographicsData, setDemographicsData] = useState({
// //     skill_distribution: [],
// //     candidate_locations: [],
// //   });
// //   const [trendsData, setTrendsData] = useState(null);
// //   const [filterOptions, setFilterOptions] = useState({
// //     job_roles: ["All Jobs"],
// //     time_ranges: [
// //       "Last Month",
// //       "Last 3 Months",
// //       "Last 6 Months",
// //       "Last Year",
// //     ],
// //   });
// //   const [page, setPage] = useState(0);
// //   const [rowsPerPage, setRowsPerPage] = useState(5);
// //   const [isExportModalOpen, setIsExportModalOpen] = useState(false);
// //   const skillChartRef = useRef(null);
// //   const locationTableRef = useRef(null);

// //   const safeJsonParse = (str, fallback = []) => {
// //     if (typeof str !== "string") return fallback;
// //     try {
// //       return JSON.parse(str);
// //     } catch (e) {
// //       return fallback;
// //     }
// //   };

// //   useEffect(() => {
// //     const fetchInitialData = async () => {
// //       setLoading(true);
// //       try {
// //         const [candidatesResponse, overviewResponse, trendsResponse] =
// //           await Promise.all([
// //             apiClient.get("/hiring-analytics/top-matching-candidates/"),
// //             apiClient.get("/hiring-analytics/combined-dashboard/"),
// //             apiClient.get("/employer-analytics/trends"),
// //           ]);
// //         const mappedCandidates = candidatesResponse.data.map(
// //           (apiCandidate) => ({
// //             candidate_id: apiCandidate.candidate_id,
// //             candidate_name: apiCandidate.candidate_name,
// //             skills: apiCandidate.skills || [],
// //             match_score: apiCandidate.match_score,
// //             avatar: `/placeholder.svg?height=40&width=40`,
// //             experience: safeJsonParse(apiCandidate.experience, []),
// //             location: apiCandidate.location || "N/A",
// //             status: apiCandidate.status
// //               ? apiCandidate.status.toLowerCase()
// //               : "matched",
// //           })
// //         );

// //         setCandidatesData(mappedCandidates);
// //         setOverviewData(overviewResponse.data);
// //         setTrendsData(trendsResponse.data);
// //       } catch (error) {
// //         console.error("Failed to fetch initial data:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchInitialData();
// //   }, []);

// //   useEffect(() => {
// //     const fetchDemographicsData = async () => {
// //       setLoading(true);
// //       let url = "/demographics/";
// //       if (jobFilter !== "all") {
// //         url = `/demographics/job/${encodeURIComponent(jobFilter)}/`;
// //       } else if (timeRange !== "all") {
// //         url = `/demographics/time/${timeRange}/`;
// //       }

// //       try {
// //         const response = await apiClient.get(url);
// //         setDemographicsData(response.data);
// //         if (response.data.filter_options) {
// //           setFilterOptions(response.data.filter_options);
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch demographics data:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchDemographicsData();
// //   }, [jobFilter, timeRange]);

// //   const handleTabChange = (event, newValue) => setTabValue(newValue);
// //   const handleTimeRangeChange = (event) => {
// //     setTimeRange(event.target.value);
// //     setJobFilter("all");
// //   };
// //   const handleJobFilterChange = (event) => {
// //     setJobFilter(event.target.value);
// //     setTimeRange("all");
// //   };
// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage);
// //   };
// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10));
// //     setPage(0);
// //   };

// //   return (
// //     <Layout title="Hiring Analytics">
// //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// //         <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 } }}>
// //           <Stack spacing={{ xs: 2, md: 4 }}>
// //             <Paper
// //               sx={{
// //                 p: { xs: 2, sm: 3 },
// //                 backgroundColor: "mint.main",
// //                 color: "primary.main",
// //               }}
// //             >
// //               <Typography
// //                 variant="h4"
// //                 component="h1"
// //                 fontWeight="bold"
// //                 sx={{
// //                   background: (theme) => theme.palette.primary.main,
// //                   backgroundClip: "text",
// //                   WebkitBackgroundClip: "text",
// //                   WebkitTextFillColor: "transparent",
// //                   fontSize: { xs: "1.75rem", sm: "2.5rem" },
// //                 }}
// //               >
// //                 Hiring Analytics Dashboard
// //               </Typography>
// //             </Paper>

// //             <Paper
// //               elevation={0}
// //               sx={{
// //                 backgroundColor: "background.paper",
// //                 overflow: "hidden",
// //               }}
// //             >
// //               <Tabs
// //                 value={tabValue}
// //                 onChange={handleTabChange}
// //                 indicatorColor="primary"
// //                 textColor="primary"
// //                 variant="scrollable"
// //                 scrollButtons="auto"
// //                 allowScrollButtonsMobile
// //                 sx={{
// //                   "& .MuiTab-root": {
// //                     textTransform: "none",
// //                     fontWeight: 600,
// //                     fontSize: { xs: "0.8rem", sm: "0.875rem" },
// //                   },
// //                   "& .MuiTabs-indicator": {
// //                     height: 3,
// //                     borderRadius: "3px 3px 0 0",
// //                   },
// //                 }}
// //               >
// //                 <Tab
// //                   icon={<BarChart />}
// //                   label="OVERVIEW"
// //                   iconPosition="start"
// //                 />
// //                 <Tab icon={<Timeline />} label="TRENDS" iconPosition="start" />
// //                 <Tab
// //                   icon={<PieChart />}
// //                   label="DEMOGRAPHICS"
// //                   iconPosition="start"
// //                 />
// //                 <Tab
// //                   icon={<People />}
// //                   label="CANDIDATES"
// //                   iconPosition="start"
// //                 />
// //                 <Tab
// //                   icon={<History />}
// //                   label="RECENT ACTIVITY"
// //                   iconPosition="start"
// //                 />
// //               </Tabs>
// //             </Paper>

// //             <Box>
// //               <TabPanel value={tabValue} index={0}>
// //                 <OverviewTab loading={loading} data={overviewData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={1}>
// //                 <TrendsTab loading={loading} data={trendsData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={2}>
// //                 <DemographicsTab
// //                   loading={loading}
// //                   data={demographicsData}
// //                   skillChartRef={skillChartRef}
// //                   locationTableRef={locationTableRef}
// //                   timeRange={timeRange}
// //                   handleTimeRangeChange={handleTimeRangeChange}
// //                   jobFilter={jobFilter}
// //                   handleJobFilterChange={handleJobFilterChange}
// //                   filterOptions={filterOptions}
// //                   onExportClick={() => setIsExportModalOpen(true)}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={3}>
// //                 <CandidatesTab
// //                   loading={loading}
// //                   candidates={candidatesData.slice(
// //                     page * rowsPerPage,
// //                     page * rowsPerPage + rowsPerPage
// //                   )}
// //                   totalCandidates={candidatesData.length}
// //                   page={page}
// //                   rowsPerPage={rowsPerPage}
// //                   handleChangePage={handleChangePage}
// //                   handleChangeRowsPerPage={handleChangeRowsPerPage}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={4}>
// //                 <RecentActivityTab
// //                   loading={loading}
// //                   data={overviewData.recent_activity}
// //                 />
// //               </TabPanel>
// //             </Box>
// //           </Stack>
// //         </Container>
// //       </Box>
// //       <ExportReportDialog
// //         open={isExportModalOpen}
// //         onClose={() => setIsExportModalOpen(false)}
// //         candidatesData={candidatesData}
// //         demographicsData={demographicsData}
// //         overviewData={overviewData}
// //         skillChartRef={skillChartRef}
// //         locationTableRef={locationTableRef}
// //       />
// //     </Layout>
// //   );
// // }

// // export default EmployerAnalytics;

// // "use client";

// // import React, { useState, useEffect, useRef, useMemo } from "react";
// // import {
// //   Grid,
// //   Card,
// //   CardContent,
// //   Typography,
// //   Button,
// //   Box,
// //   Chip,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Avatar,
// //   Skeleton,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   CircularProgress,
// //   Stack,
// //   Paper,
// //   useTheme,
// //   Tabs,
// //   Tab,
// //   FormControl,
// //   Select,
// //   MenuItem,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   ListItemAvatar,
// //   LinearProgress,
// //   TablePagination,
// //   Tooltip,
// //   Container,
// //   Fade,
// //   Grow,
// //   alpha,
// //   RadioGroup,
// //   FormControlLabel,
// //   Radio,
// //   FormLabel,
// // } from "@mui/material";
// // import {
// //   People,
// //   LocationOn,
// //   TrendingUp,
// //   WorkOutline,
// //   School,
// //   BarChart,
// //   PieChart,
// //   Timeline,
// //   CloudDownload,
// //   Star,
// //   CheckCircle,
// //   HelpOutline,
// //   MonetizationOn,
// //   AccessTime,
// //   RateReview,
// //   History,
// //   ArrowDownward,
// // } from "@mui/icons-material";
// // import * as htmlToImage from "html-to-image";
// // import ReactApexChart from "react-apexcharts";
// // import Layout from "../common/Layout";
// // import apiClient from "../../context/apiClient";

// // // NOTE: No changes needed in utility functions
// // const downloadFile = ({ data, fileName, fileType }) => {
// //   const blob = new Blob([data], { type: fileType });
// //   const a = document.createElement("a");
// //   a.download = fileName;
// //   a.href = window.URL.createObjectURL(blob);
// //   const clickEvt = new MouseEvent("click", {
// //     view: window,
// //     bubbles: true,
// //     cancelable: true,
// //   });
// //   a.dispatchEvent(clickEvt);
// //   a.remove();
// // };

// // const convertToCSV = (data) => {
// //   if (!data || data.length === 0) return "";
// //   const headers = Object.keys(data[0]);
// //   const csvRows = [headers.join(",")];
// //   for (const row of data) {
// //     const values = headers.map((header) => {
// //       const escaped = ("" + row[header]).replace(/"/g, '""');
// //       return `"${escaped}"`;
// //     });
// //     csvRows.push(values.join(","));
// //   }
// //   return csvRows.join("\n");
// // };

// // const generateUniqueColors = (count) => {
// //   if (count === 0) return [];
// //   const colors = [];
// //   const hueStep = 360 / count;
// //   for (let i = 0; i < count; i++) {
// //     const hue = i * hueStep;
// //     colors.push(`hsl(${hue}, 70%, 50%)`);
// //   }
// //   return colors;
// // };

// // // NOTE: No changes needed in ExportReportDialog as it inherits styles
// // const ExportReportDialog = ({
// //   open,
// //   onClose,
// //   candidatesData,
// //   demographicsData,
// //   overviewData,
// //   skillChartRef,
// //   locationTableRef,
// // }) => {
// //   const [reportType, setReportType] = useState("demographics_skills");
// //   const [format, setFormat] = useState("png");

// //   const handleDownload = async () => {
// //     let dataToExport = [];
// //     let fileName = `${reportType}_report`;
// //     const isImageFormat = format === "png";

// //     if (isImageFormat) {
// //       const elementToCapture =
// //         reportType === "demographics_skills"
// //           ? skillChartRef.current
// //           : locationTableRef.current;
// //       if (!elementToCapture) {
// //         console.error("Target element for image capture not found.");
// //         return;
// //       }
// //       try {
// //         const dataUrl = await htmlToImage.toPng(elementToCapture);
// //         const a = document.createElement("a");
// //         a.href = dataUrl;
// //         a.download = `${reportType}_${new Date()
// //           .toISOString()
// //           .slice(0, 10)}.png`;
// //         a.click();
// //       } catch (error) {
// //         console.error("Failed to capture component as image", error);
// //       }
// //     } else {
// //       switch (reportType) {
// //         case "candidates":
// //           dataToExport = candidatesData.map((c) => ({
// //             id: c.candidate_id,
// //             name: c.candidate_name,
// //             location: c.location,
// //             status: c.status,
// //             match_score: c.match_score,
// //             skills: c.skills.join("|"),
// //             experience: c.experience
// //               .map((e) => `${e.title} at ${e.company}`)
// //               .join(" | "),
// //           }));
// //           break;
// //         case "demographics_skills":
// //           dataToExport = demographicsData.skill_distribution;
// //           fileName = "skill_distribution_report";
// //           break;
// //         case "demographics_locations":
// //           dataToExport = demographicsData.candidate_locations;
// //           fileName = "candidate_locations_report";
// //           break;
// //         case "overview":
// //           dataToExport = [overviewData.summary_stats];
// //           break;
// //         default:
// //           console.error("Invalid report type");
// //           return;
// //       }

// //       if (format === "csv") {
// //         const csvData = convertToCSV(dataToExport);
// //         downloadFile({
// //           data: csvData,
// //           fileName: `${fileName}.csv`,
// //           fileType: "text/csv",
// //         });
// //       } else if (format === "json") {
// //         downloadFile({
// //           data: JSON.stringify(dataToExport, null, 2),
// //           fileName: `${fileName}.json`,
// //           fileType: "application/json",
// //         });
// //       }
// //     }
// //     onClose();
// //   };

// //   const isVisualReport =
// //     reportType === "demographics_skills" ||
// //     reportType === "demographics_locations";

// //   return (
// //     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
// //       <DialogTitle fontWeight="bold">Export Report</DialogTitle>
// //       <DialogContent dividers>
// //         <Stack spacing={4}>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Report Type
// //             </FormLabel>
// //             <RadioGroup
// //               value={reportType}
// //               onChange={(e) => setReportType(e.target.value)}
// //             >
// //               <FormControlLabel
// //                 value="demographics_skills"
// //                 control={<Radio />}
// //                 label="Skill Distribution"
// //               />
// //               <FormControlLabel
// //                 value="demographics_locations"
// //                 control={<Radio />}
// //                 label="Candidate Locations"
// //               />
// //               <FormControlLabel
// //                 value="candidates"
// //                 control={<Radio />}
// //                 label="Top Candidates (Data Only)"
// //               />
// //               <FormControlLabel
// //                 value="overview"
// //                 control={<Radio />}
// //                 label="Hiring Stats Overview (Data Only)"
// //               />
// //             </RadioGroup>
// //           </FormControl>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Format
// //             </FormLabel>
// //             <RadioGroup
// //               row
// //               value={format}
// //               onChange={(e) => setFormat(e.target.value)}
// //             >
// //               <FormControlLabel
// //                 value="png"
// //                 control={<Radio />}
// //                 label="Image (PNG)"
// //                 disabled={!isVisualReport}
// //               />
// //               <FormControlLabel value="csv" control={<Radio />} label="CSV" />
// //               <FormControlLabel value="json" control={<Radio />} label="JSON" />
// //             </RadioGroup>
// //           </FormControl>
// //         </Stack>
// //       </DialogContent>
// //       <DialogActions sx={{ p: 2 }}>
// //         <Button onClick={onClose} color="inherit">
// //           Cancel
// //         </Button>
// //         <Button
// //           onClick={handleDownload}
// //           variant="contained"
// //           startIcon={<CloudDownload />}
// //         >
// //           Download
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // const cleanSkill = (skill) => {
// //   return skill.replace(/[\[\]"]/g, "");
// // };

// // const SkillDonutChart = ({ data, colors }) => {
// //   const theme = useTheme();
// //   const chartSeries = data.map((item) => item.count);
// //   const chartOptions = {
// //     chart: { type: "donut", background: "transparent" },
// //     plotOptions: {
// //       pie: {
// //         donut: {
// //           size: "70%",
// //           labels: {
// //             show: true,
// //             total: {
// //               show: true,
// //               label: "Total Skills",
// //               color: theme.palette.text.secondary, // NOTE: Already using theme
// //               formatter: (w) =>
// //                 w.globals.seriesTotals.reduce((a, b) => a + b, 0),
// //             },
// //           },
// //         },
// //       },
// //     },
// //     dataLabels: { enabled: false },
// //     legend: { show: false },
// //     colors: colors,
// //     tooltip: { y: { formatter: (val) => `${val} candidates` } },
// //     // CHANGED: Make labels theme-aware
// //     theme: {
// //       mode: theme.palette.mode,
// //     },
// //     stroke: {
// //         colors: [theme.palette.background.paper], // Donut segment borders
// //     },
// //   };
// //   return (
// //     <ReactApexChart
// //       options={chartOptions}
// //       series={chartSeries}
// //       type="donut"
// //       height={420}
// //     />
// //   );
// // };

// // // NOTE: No changes needed in SkillList as it inherits text colors
// // const SkillList = ({ data, colors }) => {
// //   return (
// //     <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 2 }}>
// //       <List>
// //         {data.map((item, index) => (
// //           <ListItem key={item.skill} disablePadding>
// //             <Stack
// //               direction="row"
// //               alignItems="center"
// //               spacing={2}
// //               sx={{ width: "100%", py: 0.5 }}
// //             >
// //               <Box
// //                 sx={{
// //                   width: 16,
// //                   height: 16,
// //                   borderRadius: "4px",
// //                   bgcolor: colors[index % colors.length],
// //                   flexShrink: 0,
// //                 }}
// //               />
// //               <ListItemText
// //                 primary={
// //                   <Typography variant="body2" color="text.primary" noWrap>
// //                     {cleanSkill(item.skill)}
// //                   </Typography>
// //                 }
// //               />
// //               <Typography
// //                 variant="body2"
// //                 color="text.secondary"
// //                 fontWeight="bold"
// //               >
// //                 {item.count}
// //               </Typography>
// //             </Stack>
// //           </ListItem>
// //         ))}
// //       </List>
// //     </Box>
// //   );
// // };

// // const ApplicationTrendChart = ({ data, height = 450 }) => {
// //   const theme = useTheme();

// //   if (
// //     !data ||
// //     !data.datasets ||
// //     !data.datasets[0] ||
// //     !data.datasets[0].data ||
// //     data.datasets[0].data.length === 0
// //   ) {
// //     return (
// //       <Box
// //         sx={{
// //           height,
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           // CHANGED: Use theme colors for placeholder
// //           bgcolor: (theme) => alpha(theme.palette.divider, 0.04),
// //           borderRadius: 2,
// //           border: (theme) => `1px dashed ${theme.palette.divider}`,
// //           m: 3,
// //         }}
// //       >
// //         <Typography variant="body2" color="text.secondary">
// //           No trend data available.
// //         </Typography>
// //       </Box>
// //     );
// //   }

// //   const chartSeries = [
// //     {
// //       name: "Applications",
// //       data: data.datasets[0].data,
// //     },
// //   ];

// //   const chartOptions = {
// //     chart: {
// //       type: "area",
// //       height: height,
// //       toolbar: {
// //         show: false,
// //       },
// //       zoom: {
// //         enabled: false,
// //       },
// //       background: "transparent",
// //     },
// //     colors: [theme.palette.primary.main], // NOTE: Already using theme
// //     dataLabels: {
// //       enabled: false,
// //     },
// //     stroke: {
// //       curve: "smooth",
// //       width: 3,
// //       lineCap: "round",
// //     },
// //     fill: {
// //       type: "gradient",
// //       gradient: {
// //         shadeIntensity: 1,
// //         opacityFrom: 0.4,
// //         opacityTo: 0.1,
// //         stops: [0, 90, 100],
// //       },
// //     },
// //     grid: {
// //       show: true,
// //       borderColor: theme.palette.divider, // NOTE: Already using theme
// //       strokeDashArray: 4,
// //       xaxis: {
// //         lines: {
// //           show: false,
// //         },
// //       },
// //       yaxis: {
// //         lines: {
// //           show: true,
// //         },
// //       },
// //     },
// //     xaxis: {
// //       categories: data.labels,
// //       axisBorder: {
// //         show: false,
// //       },
// //       axisTicks: {
// //         show: false,
// //       },
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary, // NOTE: Already using theme
// //           fontWeight: 500,
// //         },
// //       },
// //     },
// //     yaxis: {
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary, // NOTE: Already using theme
// //         },
// //         formatter: function (val) {
// //           return val.toFixed(0);
// //         },
// //       },
// //     },
// //     tooltip: {
// //       x: {
// //         format: "MMM yyyy",
// //       },
// //       y: {
// //         formatter: (val) => `${val} applications`,
// //       },
// //       // CHANGED: Make tooltip theme-aware
// //       theme: theme.palette.mode,
// //       marker: {
// //         show: true,
// //       },
// //     },
// //   };

// //   return (
// //     <ReactApexChart
// //       options={chartOptions}
// //       series={chartSeries}
// //       type="area"
// //       height={height}
// //     />
// //   );
// // };

// // // NOTE: No changes needed in TabPanel
// // function TabPanel(props) {
// //   const { children, value, index, ...other } = props;
// //   return (
// //     <div
// //       role="tabpanel"
// //       hidden={value !== index}
// //       id={`analytics-tabpanel-${index}`}
// //       aria-labelledby={`analytics-tab-${index}`}
// //       {...other}
// //     >
// //       {value === index && (
// //         <Fade in={value === index} timeout={500}>
// //           <Box sx={{ pt: 4 }}>{children}</Box>
// //         </Fade>
// //       )}
// //     </div>
// //   );
// // }

// // // NOTE: No changes needed in getStatusColor/Icon
// // const getStatusColor = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return "success";
// //     case "interviewed":
// //       return "primary";
// //     case "shortlisted":
// //       return "info";
// //     case "applied":
// //     case "matched":
// //       return "warning";
// //     default:
// //       return "default";
// //   }
// // };

// // const getStatusIcon = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return <CheckCircle />;
// //     case "interviewed":
// //       return <People />;
// //     case "shortlisted":
// //       return <Star />;
// //     case "applied":
// //     case "matched":
// //       return <WorkOutline />;
// //     default:
// //       return <HelpOutline />;
// //   }
// // };

// // const OverviewTab = ({ loading, data }) => {
// //   const theme = useTheme();

// //   const applicationTrendsData = {
// //     labels: data.application_trend?.map((d) => d.month) || [],
// //     datasets: [
// //       {
// //         label: "Applications",
// //         data: data.application_trend?.map((d) => d.application_count) || [],
// //         backgroundColor: theme.palette.primary.main,
// //       },
// //     ],
// //   };

// //   const statCards = [
// //     {
// //       label: "Total Applications",
// //       value: data.summary_stats?.total_applications || 0,
// //     },
// //     {
// //       label: "Total Interviews",
// //       value: data.summary_stats?.total_interviews || 0,
// //     },
// //     {
// //       label: "Total Hires",
// //       value: data.summary_stats?.total_hires || 0,
// //     },
// //     {
// //       label: "Acceptance Rate",
// //       value: data.summary_stats?.acceptance_rate || "0%",
// //     },
// //   ];

// //   return (
// //     <Stack spacing={4}>
// //       <Grid container spacing={{ xs: 2, md: 3 }}>
// //         {loading
// //           ? [...Array(4)].map((_, index) => (
// //               <Grid item xs={12} sm={6} md={3} key={index}>
// //                 <Skeleton
// //                   variant="rectangular"
// //                   width="100%"
// //                   height={140}
// //                   sx={{ borderRadius: "12px" }}
// //                 />
// //               </Grid>
// //             ))
// //           : statCards.map((card, index) => (
// //               <Grid item xs={12} sm={6} md={3} key={index}>
// //                 <Box
// //                   sx={{
// //                     width: "100%",
// //                     height: 140,
// //                     backgroundColor: "primary.main",
// //                     borderRadius: "12px",
// //                     boxShadow: theme.shadows[3],
// //                     position: "relative",
// //                     overflow: "hidden",
// //                     p: { xs: 2, md: 2.5 },
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     justifyContent: "space-between",
// //                   }}
// //                 >
// //                   <Box
// //                     sx={{
// //                       position: "absolute",
// //                       top: 0,
// //                       right: 0,
// //                       width: "100%",
// //                       height: "100%",
// //                       zIndex: 0,
// //                     }}
// //                   >
// //                     <svg
// //                       width="100%"
// //                       height="100%"
// //                       viewBox="0 0 280 140"
// //                       preserveAspectRatio="none"
// //                       style={{ position: "absolute", right: 0, top: 0 }}
// //                     >
// //                       <path
// //                         d="M200 0 L280 0 L280 140 C 250 140, 230 105, 230 70 C 230 35, 250 0, 200 0 Z"
// //                         // CHANGED: Use the custom accent color from the theme
// //                         fill={theme.palette.accent.main}
// //                       />
// //                     </svg>
// //                   </Box>
// //                   <Box sx={{ position: "relative", zIndex: 1 }}>
// //                     <Typography
// //                       sx={{
// //                         fontSize: { xs: "0.7rem", sm: "0.75rem" },
// //                         fontWeight: 600,
// //                         color: alpha(
// //                           theme.palette.primary.contrastText,
// //                           0.85
// //                         ),
// //                         textTransform: "uppercase",
// //                         lineHeight: 1.2,
// //                       }}
// //                     >
// //                       {card.label}
// //                     </Typography>
// //                   </Box>
// //                   <Box sx={{ position: "relative", zIndex: 1 }}>
// //                     <Typography
// //                       sx={{
// //                         fontSize: {
// //                           xs: "1.75rem",
// //                           sm: "2rem",
// //                           md: "2.25rem",
// //                         },
// //                         fontWeight: "bold",
// //                         color: "primary.contrastText",
// //                         lineHeight: 1,
// //                       }}
// //                     >
// //                       {card.value}
// //                     </Typography>
// //                   </Box>
// //                 </Box>
// //               </Grid>
// //             ))}
// //       </Grid>

// //       <Card
// //         sx={{
// //           // NOTE: borderRadius and boxShadows are good, no change needed.
// //           // CHANGED: Use the custom mint color from the theme
// //           backgroundColor: "mint.main",
// //           transition: "all 0.3s ease",
// //           "&:hover": { boxShadow: theme.shadows[8] },
// //         }}
// //       >
// //         <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
// //           <Box sx={{ p: { xs: 2, sm: 3 }, pb: 0 }}>
// //             {loading ? (
// //               <Skeleton variant="text" width="60%" height={32} />
// //             ) : (
// //               <Typography
// //                 variant="h6"
// //                 fontWeight="bold"
// //                 color="text.primary"
// //               >
// //                 Application Trends
// //               </Typography>
// //             )}
// //           </Box>
// //           {loading ? (
// //             <Box sx={{ p: { xs: 2, sm: 3 } }}>
// //               <Skeleton
// //                 variant="rectangular"
// //                 height={400}
// //                 sx={{ borderRadius: 2 }}
// //               />
// //             </Box>
// //           ) : (
// //             <ApplicationTrendChart data={applicationTrendsData} />
// //           )}
// //         </CardContent>
// //       </Card>
// //     </Stack>
// //   );
// // };

// // const RecentActivityTab = ({ loading, data }) => {
// //   const theme = useTheme();

// //   const getActivityIcon = (activityString) => {
// //     const lowerCaseActivity = activityString.toLowerCase();
// //     if (lowerCaseActivity.includes("hired")) return <CheckCircle />;
// //     if (lowerCaseActivity.includes("interview")) return <People />;
// //     if (lowerCaseActivity.includes("applied")) return <WorkOutline />;
// //     return <RateReview />;
// //   };

// //   return (
// //     <Card
// //       sx={{
// //         // CHANGED: Use the custom mint color
// //         backgroundColor: "mint.main",
// //         transition: "all 0.3s ease",
// //         "&:hover": { boxShadow: theme.shadows[8] },
// //       }}
// //     >
// //       <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //         {loading ? (
// //           <Skeleton variant="text" width="50%" height={32} />
// //         ) : (
// //           <Typography
// //             variant="h6"
// //             fontWeight="bold"
// //             gutterBottom
// //             color="text.primary"
// //           >
// //             Recent Activity
// //           </Typography>
// //         )}
// //         <List sx={{ mt: 2 }}>
// //           {loading
// //             ? Array.from(new Array(5)).map((_, index) => (
// //                 <ListItem key={index} sx={{ px: 0, py: 1.5 }}>
// //                   <ListItemAvatar>
// //                     <Skeleton variant="circular" width={48} height={48} />
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={<Skeleton variant="text" width="80%" />}
// //                     secondary={<Skeleton variant="text" width="60%" />}
// //                   />
// //                 </ListItem>
// //               ))
// //             : data?.map((activity, index) => (
// //                 <ListItem
// //                   key={`${activity.candidate_name}-${index}`}
// //                   sx={{
// //                     px: 0,
// //                     py: 1.5,
// //                     borderRadius: 2,
// //                     transition: "all 0.2s ease",
// //                     // NOTE: Already using theme for hover
// //                     "&:hover": {
// //                       bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
// //                     },
// //                   }}
// //                 >
// //                   <ListItemAvatar>
// //                     <Avatar
// //                       sx={{
// //                         // NOTE: Already using theme for avatar
// //                         bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
// //                         color: "primary.main",
// //                         width: 48,
// //                         height: 48,
// //                         boxShadow: theme.shadows[2],
// //                       }}
// //                     >
// //                       {getActivityIcon(activity.activity)}
// //                     </Avatar>
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={
// //                       <Typography
// //                         variant="body2"
// //                         fontWeight="600"
// //                         color="text.primary"
// //                       >
// //                         {activity.candidate_name}
// //                       </Typography>
// //                     }
// //                     secondary={
// //                       <Typography variant="caption" color="text.secondary">
// //                         {activity.activity} • {activity.time_ago}
// //                       </Typography>
// //                     }
// //                   />
// //                 </ListItem>
// //               ))}
// //         </List>
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // const TrendsTab = ({ loading, data }) => {
// //   const theme = useTheme();

// //   const funnelData = [
// //     {
// //       icon: <WorkOutline color="primary" />,
// //       title: "Applications",
// //       value: data?.hiring_funnel?.applications || 0,
// //       color: theme.palette.primary.main,
// //     },
// //     {
// //       icon: <People color="secondary" />,
// //       title: "Interviews",
// //       value: data?.hiring_funnel?.interviews || 0,
// //       conversion: data?.hiring_funnel?.interview_conversion_rate || "0%",
// //       color: theme.palette.secondary.main,
// //     },
// //     {
// //       icon: <CheckCircle color="success" />,
// //       title: "Hires",
// //       value: data?.hiring_funnel?.hires || 0,
// //       conversion: data?.hiring_funnel?.hire_conversion_rate || "0%",
// //       color: theme.palette.success.main,
// //     },
// //   ];

// //   const kpiData = [
// //     {
// //       icon: <AccessTime />,
// //       title: "Average Time to Hire",
// //       value: data?.key_performance_metrics?.average_time_to_hire || "N/A",
// //       color: theme.palette.primary,
// //     },
// //     {
// //       icon: <MonetizationOn />,
// //       title: "Cost Per Hire",
// //       value: data?.key_performance_metrics?.cost_per_hire || "N/A",
// //       color: theme.palette.success,
// //     },
// //     {
// //       icon: <RateReview />,
// //       title: "Offer Acceptance Rate",
// //       value: data?.key_performance_metrics?.offer_acceptance_rate || "N/A",
// //       color: theme.palette.secondary,
// //     },
// //   ];

// //   return (
// //     <Grid container spacing={4}>
// //       <Grid item xs={12} lg={5}>
// //         <Card
// //           sx={{
// //             height: "100%",
// //             // CHANGED: Use the custom mint color
// //             backgroundColor: "mint.main",
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //             <Typography
// //               variant="h6"
// //               fontWeight="bold"
// //               gutterBottom
// //               color="text.primary"
// //             >
// //               Hiring Funnel
// //             </Typography>
// //             {loading ? (
// //               <Stack spacing={4} sx={{ mt: 3 }}>
// //                 <Skeleton
// //                   variant="rectangular"
// //                   height={60}
// //                   sx={{ borderRadius: 2 }}
// //                 />
// //                 <Skeleton
// //                   variant="rectangular"
// //                   height={60}
// //                   sx={{ borderRadius: 2 }}
// //                 />
// //                 <Skeleton
// //                   variant="rectangular"
// //                   height={60}
// //                   sx={{ borderRadius: 2 }}
// //                 />
// //               </Stack>
// //             ) : (
// //               <Stack spacing={2} sx={{ mt: 4 }}>
// //                 {funnelData.map((step, index) => (
// //                   <Grow in timeout={500 + index * 200} key={step.title}>
// //                     <Box>
// //                       <Paper
// //                         variant="outlined"
// //                         sx={{
// //                           p: 2,
// //                           display: "flex",
// //                           alignItems: "center",
// //                           borderRadius: 2,
// //                           // NOTE: Already using theme colors correctly here
// //                           borderColor: alpha(step.color, 0.3),
// //                           background: `linear-gradient(to right, ${alpha(
// //                             step.color,
// //                             0.1
// //                           )}, transparent)`,
// //                         }}
// //                       >
// //                         <Avatar
// //                           sx={{
// //                             bgcolor: alpha(step.color, 0.15),
// //                             color: step.color,
// //                             mr: 2,
// //                           }}
// //                         >
// //                           {step.icon}
// //                         </Avatar>
// //                         <Box sx={{ flexGrow: 1 }}>
// //                           <Typography variant="body2" color="text.secondary">
// //                             {step.title}
// //                           </Typography>
// //                           <Typography variant="h5" fontWeight="bold">
// //                             {step.value}
// //                           </Typography>
// //                         </Box>
// //                         {step.conversion && (
// //                           <Box sx={{ textAlign: "right" }}>
// //                             <Typography
// //                               variant="caption"
// //                               color="text.secondary"
// //                             >
// //                               Conversion
// //                             </Typography>
// //                             <Typography
// //                               variant="body1"
// //                               fontWeight="bold"
// //                               color={step.color}
// //                             >
// //                               {step.conversion}
// //                             </Typography>
// //                           </Box>
// //                         )}
// //                       </Paper>
// //                       {index < funnelData.length - 1 && (
// //                         <Box display="flex" justifyContent="center" my={1}>
// //                            {/* CHANGED: Use a theme color */}
// //                           <ArrowDownward sx={{ color: "divider" }} />
// //                         </Box>
// //                       )}
// //                     </Box>
// //                   </Grow>
// //                 ))}
// //               </Stack>
// //             )}
// //           </CardContent>
// //         </Card>
// //       </Grid>

// //       <Grid item xs={12} lg={7}>
// //         <Card
// //           sx={{
// //             height: "100%",
// //             // CHANGED: Use the custom mint color
// //             backgroundColor: "mint.main",
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //             <Typography
// //               variant="h6"
// //               fontWeight="bold"
// //               gutterBottom
// //               color="text.primary"
// //             >
// //               Key Performance Metrics
// //             </Typography>
// //             <Grid container spacing={3} sx={{ mt: 2, height: "100%" }}>
// //               {loading
// //                 ? Array.from(new Array(3)).map((_, index) => (
// //                     <Grid item xs={12} sm={4} key={index}>
// //                       <Skeleton
// //                         variant="rectangular"
// //                         height={150}
// //                         sx={{ borderRadius: 2 }}
// //                       />
// //                     </Grid>
// //                   ))
// //                 : kpiData.map((kpi, index) => (
// //                     <Grid item xs={12} sm={4} key={kpi.title}>
// //                       <Grow in timeout={500 + index * 200}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{
// //                             p: { xs: 2, sm: 3 },
// //                             borderRadius: 2,
// //                             textAlign: "center",
// //                             height: "100%",
// //                             display: "flex",
// //                             flexDirection: "column",
// //                             justifyContent: "center",
// //                             // NOTE: Already using theme colors correctly
// //                             borderColor: alpha(kpi.color.main, 0.3),
// //                             backgroundColor: alpha(kpi.color.main, 0.05),
// //                           }}
// //                         >
// //                           <Avatar
// //                             sx={{
// //                               bgcolor: alpha(kpi.color.main, 0.1),
// //                               color: kpi.color.main,
// //                               width: 56,
// //                               height: 56,
// //                               mx: "auto",
// //                               mb: 1.5,
// //                             }}
// //                           >
// //                             {kpi.icon}
// //                           </Avatar>
// //                           <Typography
// //                             variant="body2"
// //                             fontWeight="600"
// //                             color="text.primary"
// //                           >
// //                             {kpi.title}
// //                           </Typography>
// //                           <Typography
// //                             variant="h4"
// //                             fontWeight="bold"
// //                             color="text.primary"
// //                             sx={{ mt: 1 }}
// //                           >
// //                             {kpi.value}
// //                           </Typography>
// //                         </Paper>
// //                       </Grow>
// //                     </Grid>
// //                   ))}
// //             </Grid>
// //           </CardContent>
// //         </Card>
// //       </Grid>
// //     </Grid>
// //   );
// // };

// // const DemographicsTab = ({
// //   loading,
// //   data,
// //   skillChartRef,
// //   locationTableRef,
// //   timeRange,
// //   handleTimeRangeChange,
// //   jobFilter,
// //   handleJobFilterChange,
// //   filterOptions,
// //   onExportClick,
// // }) => {
// //   const theme = useTheme();
// //   const colorPalette = useMemo(() => {
// //     if (!data || !data.skill_distribution) {
// //       return [];
// //     }
// //     return generateUniqueColors(data.skill_distribution.length);
// //   }, [data.skill_distribution]);

// //   return (
// //     <Stack spacing={4}>
// //       <Paper
// //         elevation={0}
// //         sx={{
// //           p: 2,
// //           // CHANGED: Use the custom mint color
// //           backgroundColor: "mint.main",
// //           border: (theme) => `1px solid ${theme.palette.divider}`,
// //         }}
// //       >
// //         <Stack
// //           direction={{ xs: "column", md: "row" }}
// //           spacing={2}
// //           alignItems="center"
// //           justifyContent="flex-end"
// //         >
// //           <FormControl size="small" sx={{ width: { xs: "100%", md: "auto" } }}>
// //             <Select
// //               value={timeRange}
// //               onChange={handleTimeRangeChange}
// //               sx={{
// //                 minWidth: 140,
// //                 // NOTE: backgroundColor is now handled by the global theme override
// //                 // for MuiSelect, so it can be removed from here for simplicity.
// //               }}
// //             >
// //               <MenuItem value="last30days">Last Month</MenuItem>
// //               <MenuItem value="last3months">Last 3 Months</MenuItem>
// //               <MenuItem value="last6months">Last 6 Months</MenuItem>
// //               <MenuItem value="lastyear">Last Year</MenuItem>
// //             </Select>
// //           </FormControl>
// //           <FormControl size="small" sx={{ width: { xs: "100%", md: "auto" } }}>
// //             <Select
// //               value={jobFilter}
// //               onChange={handleJobFilterChange}
// //               sx={{
// //                  minWidth: 180,
// //                 // NOTE: backgroundColor is also handled by the global theme override.
// //               }}
// //             >
// //               {filterOptions.job_roles.map((job) => (
// //                 <MenuItem
// //                   key={job || "all-jobs"}
// //                   value={
// //                     job === "All Jobs" || !job ? "all" : job
// //                   }
// //                 >
// //                   {job || "All Jobs"}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <Button
// //             variant="outlined"
// //             startIcon={<CloudDownload />}
// //             size="medium"
// //             onClick={onExportClick}
// //             sx={{
// //               // NOTE: Style is good, no change needed
// //               width: { xs: "100%", md: "auto" },
// //             }}
// //           >
// //             Export Report
// //           </Button>
// //         </Stack>
// //       </Paper>
// //       <Grid container spacing={4}>
// //         <Grid item xs={12} lg={7}>
// //           <Card
// //             ref={skillChartRef}
// //             sx={{
// //               height: "100%",
// //               // CHANGED: Use the custom mint color
// //               backgroundColor: "mint.main",
// //             }}
// //           >
// //             <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //               <Typography
// //                 variant="h6"
// //                 gutterBottom
// //                 fontWeight="bold"
// //                 color="text.primary"
// //               >
// //                 Skill Distribution
// //               </Typography>
// //               {loading ? (
// //                 <Skeleton variant="rectangular" height={450} />
// //               ) : (
// //                 <Grid
// //                   container
// //                   spacing={2}
// //                   alignItems="center"
// //                   sx={{ mt: 1 }}
// //                 >
// //                   <Grid item xs={12} md={8}>
// //                     <SkillDonutChart
// //                       data={data.skill_distribution}
// //                       colors={colorPalette}
// //                     />
// //                   </Grid>
// //                   <Grid item xs={12} md={4}>
// //                     <SkillList
// //                       data={data.skill_distribution}
// //                       colors={colorPalette}
// //                     />
// //                   </Grid>
// //                 </Grid>
// //               )}
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} lg={5}>
// //           <Card
// //             ref={locationTableRef}
// //             sx={{
// //               height: "100%",
// //               // CHANGED: Use the custom mint color
// //               backgroundColor: "mint.main",
// //             }}
// //           >
// //             <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //               <Typography
// //                 variant="h6"
// //                 gutterBottom
// //                 fontWeight="bold"
// //                 color="text.primary"
// //               >
// //                 Candidate Locations
// //               </Typography>
// //               <TableContainer sx={{ mt: 3, maxHeight: 450 }}>
// //                 <Table stickyHeader>
// //                   <TableHead>
// //                     <TableRow>
// //                       <TableCell>
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Location
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell align="right">
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Candidates
// //                         </Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   </TableHead>
// //                   <TableBody>
// //                     {loading
// //                       ? Array.from(new Array(5)).map((_, index) => (
// //                           <TableRow key={index}>
// //                             <TableCell>
// //                               <Skeleton variant="text" />
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Skeleton
// //                                 variant="rounded"
// //                                 width={40}
// //                                 height={24}
// //                               />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))
// //                       : data.candidate_locations.map((loc) => (
// //                           <TableRow
// //                             key={loc.location}
// //                             sx={{
// //                               "&:hover": {
// //                                 // NOTE: Already using theme color
// //                                 bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
// //                               },
// //                             }}
// //                           >
// //                             <TableCell component="th" scope="row">
// //                               <Typography variant="body2" fontWeight="500">
// //                                 {loc.location}
// //                               </Typography>
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Chip
// //                                 label={loc.candidates}
// //                                 size="small"
// //                                 color="primary"
// //                                 variant="outlined"
// //                               />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))}
// //                   </TableBody>
// //                 </Table>
// //               </TableContainer>
// //             </CardContent>
// //           </Card>
// //         </Grid>
// //       </Grid>
// //     </Stack>
// //   );
// // };

// // const CandidatesTab = ({
// //   loading,
// //   candidates,
// //   totalCandidates,
// //   page,
// //   rowsPerPage,
// //   handleChangePage,
// //   handleChangeRowsPerPage,
// // }) => {
// //   const theme = useTheme();
// //   const getExperienceTooltip = (experienceArray) => {
// //     if (!Array.isArray(experienceArray) || experienceArray.length === 0) {
// //       return "No experience details available.";
// //     }
// //     return experienceArray
// //       .map(
// //         (exp) =>
// //           `${exp.title || "N/A"} at ${exp.company || "N/A"} (${
// //             exp.duration || "N/A"
// //           })`
// //       )
// //       .join("\n");
// //   };

// //   return (
// //     <Card
// //       sx={{
// //         // CHANGED: Use the custom mint color
// //         backgroundColor: "mint.main",
// //       }}
// //     >
// //       <CardContent sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
// //         <Typography
// //           variant="h6"
// //           gutterBottom
// //           fontWeight="bold"
// //           color="text.primary"
// //         >
// //           Top Candidates
// //         </Typography>
// //         <TableContainer sx={{ mt: 3 }}>
// //           <Table sx={{ minWidth: 650 }} aria-label="top candidates table">
// //             <TableHead>
// //               {/* NOTE: TableHead background is handled by the global theme override */}
// //               <TableRow>
// //                 <TableCell>
// //                   Candidate
// //                 </TableCell>
// //                 <TableCell>
// //                   Experience
// //                 </TableCell>
// //                 <TableCell>
// //                   Top Skills
// //                 </TableCell>
// //                 <TableCell>
// //                   Match Score
// //                 </TableCell>
// //                 <TableCell>
// //                   Status
// //                 </TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {loading
// //                 ? Array.from(new Array(rowsPerPage)).map((_, index) => (
// //                     <TableRow key={index}>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton variant="circular" width={48} height={48} />
// //                           <Stack spacing={0.5}>
// //                             <Skeleton variant="text" width={120} />
// //                             <Skeleton variant="text" width={100} />
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton variant="text" width={100} />
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" spacing={0.5} flexWrap="wrap">
// //                           <Skeleton
// //                             variant="rounded"
// //                             width={60}
// //                             height={24}
// //                           />
// //                           <Skeleton
// //                             variant="rounded"
// //                             width={70}
// //                             height={24}
// //                           />
// //                           <Skeleton
// //                             variant="rounded"
// //                             width={50}
// //                             height={24}
// //                           />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton
// //                             variant="rectangular"
// //                             width={100}
// //                             height={8}
// //                             sx={{ borderRadius: 1 }}
// //                           />
// //                           <Skeleton variant="text" width={30} />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton
// //                           variant="rounded"
// //                           width={90}
// //                           height={28}
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))
// //                 : candidates.map((candidate) => (
// //                     <TableRow
// //                       key={candidate.candidate_id}
// //                       hover
// //                       sx={{
// //                         "&:hover": {
// //                           // NOTE: Already using theme color
// //                           bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
// //                         },
// //                       }}
// //                     >
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Avatar
// //                             src={candidate.avatar}
// //                             sx={{ width: 48, height: 48 }}
// //                           />
// //                           <Stack>
// //                             <Typography variant="body2" fontWeight="600">
// //                               {candidate.candidate_name}
// //                             </Typography>
// //                             <Stack
// //                               direction="row"
// //                               alignItems="center"
// //                               spacing={0.5}
// //                             >
// //                               <LocationOn
// //                                 sx={{
// //                                   fontSize: 16,
// //                                   color: "text.secondary",
// //                                 }}
// //                               />
// //                               <Typography
// //                                 variant="caption"
// //                                 color="text.secondary"
// //                               >
// //                                 {candidate.location}
// //                               </Typography>
// //                             </Stack>
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={
// //                             <div style={{ whiteSpace: "pre-line" }}>
// //                               {getExperienceTooltip(candidate.experience)}
// //                             </div>
// //                           }
// //                           arrow
// //                         >
// //                           <Typography
// //                             variant="body2"
// //                             sx={{ cursor: "pointer" }}
// //                           >
// //                             {(candidate.experience &&
// //                               candidate.experience[0]?.duration) ||
// //                               "N/A"}
// //                           </Typography>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={
// //                             Array.isArray(candidate.skills)
// //                               ? candidate.skills.join(", ")
// //                               : ""
// //                           }
// //                           arrow
// //                           placement="top"
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={0.5}
// //                             flexWrap="wrap"
// //                             sx={{ cursor: "pointer", gap: 0.5 }}
// //                           >
// //                             {Array.isArray(candidate.skills) &&
// //                               candidate.skills.slice(0, 3).map((skill) => (
// //                                 <Chip
// //                                   key={skill}
// //                                   label={skill}
// //                                   size="small"
// //                                   variant="outlined"
// //                                 />
// //                               ))}
// //                           </Stack>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <LinearProgress
// //                             variant="determinate"
// //                             value={candidate.match_score}
// //                             sx={{
// //                               width: 100,
// //                               height: 8,
// //                               borderRadius: 1,
// //                             }}
// //                           />
// //                           <Typography
// //                             variant="body2"
// //                             color="text.secondary"
// //                             fontWeight="500"
// //                           >
// //                             {candidate.match_score}%
// //                           </Typography>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Chip
// //                           icon={getStatusIcon(candidate.status)}
// //                           label={
// //                             candidate.status.charAt(0).toUpperCase() +
// //                             candidate.status.slice(1)
// //                           }
// //                           color={getStatusColor(candidate.status)}
// //                           size="small"
// //                           variant="filled"
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //         <TablePagination
// //           rowsPerPageOptions={[5, 10, 25]}
// //           component="div"
// //           count={totalCandidates}
// //           rowsPerPage={rowsPerPage}
// //           page={page}
// //           onPageChange={handleChangePage}
// //           onRowsPerPageChange={handleChangeRowsPerPage}
// //         />
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // function EmployerAnalytics() {
// //   const theme = useTheme();
// //   const [tabValue, setTabValue] = useState(0);
// //   const [timeRange, setTimeRange] = useState("last30days");
// //   const [jobFilter, setJobFilter] = useState("all");
// //   const [loading, setLoading] = useState(true);
// //   const [candidatesData, setCandidatesData] = useState([]);
// //   const [overviewData, setOverviewData] = useState({
// //     summary_stats: {
// //       total_applications: 0,
// //       total_interviews: 0,
// //       total_hires: 0,
// //       acceptance_rate: "0%",
// //     },
// //     application_trend: [],
// //     recent_activity: [],
// //   });
// //   const [demographicsData, setDemographicsData] = useState({
// //     skill_distribution: [],
// //     candidate_locations: [],
// //   });
// //   const [trendsData, setTrendsData] = useState(null);
// //   const [filterOptions, setFilterOptions] = useState({
// //     job_roles: ["All Jobs"],
// //     time_ranges: [
// //       "Last Month",
// //       "Last 3 Months",
// //       "Last 6 Months",
// //       "Last Year",
// //     ],
// //   });
// //   const [page, setPage] = useState(0);
// //   const [rowsPerPage, setRowsPerPage] = useState(5);
// //   const [isExportModalOpen, setIsExportModalOpen] = useState(false);
// //   const skillChartRef = useRef(null);
// //   const locationTableRef = useRef(null);

// //   const safeJsonParse = (str, fallback = []) => {
// //     if (typeof str !== "string") return fallback;
// //     try {
// //       return JSON.parse(str);
// //     } catch (e) {
// //       return fallback;
// //     }
// //   };

// //   useEffect(() => {
// //     const fetchInitialData = async () => {
// //       setLoading(true);
// //       try {
// //         const [candidatesResponse, overviewResponse, trendsResponse] =
// //           await Promise.all([
// //             apiClient.get("/hiring-analytics/top-matching-candidates/"),
// //             apiClient.get("/hiring-analytics/combined-dashboard/"),
// //             apiClient.get("/employer-analytics/trends"),
// //           ]);
// //         const mappedCandidates = candidatesResponse.data.map(
// //           (apiCandidate) => ({
// //             candidate_id: apiCandidate.candidate_id,
// //             candidate_name: apiCandidate.candidate_name,
// //             skills: apiCandidate.skills || [],
// //             match_score: apiCandidate.match_score,
// //             avatar: `/placeholder.svg?height=40&width=40`,
// //             experience: safeJsonParse(apiCandidate.experience, []),
// //             location: apiCandidate.location || "N/A",
// //             status: apiCandidate.status
// //               ? apiCandidate.status.toLowerCase()
// //               : "matched",
// //           })
// //         );

// //         setCandidatesData(mappedCandidates);
// //         setOverviewData(overviewResponse.data);
// //         setTrendsData(trendsResponse.data);
// //       } catch (error) {
// //         console.error("Failed to fetch initial data:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchInitialData();
// //   }, []);

// //   useEffect(() => {
// //     const fetchDemographicsData = async () => {
// //       setLoading(true);
// //       let url = "/demographics/";
// //       if (jobFilter !== "all") {
// //         url = `/demographics/job/${encodeURIComponent(jobFilter)}/`;
// //       } else if (timeRange !== "all") {
// //         url = `/demographics/time/${timeRange}/`;
// //       }

// //       try {
// //         const response = await apiClient.get(url);
// //         setDemographicsData(response.data);
// //         if (response.data.filter_options) {
// //           setFilterOptions(response.data.filter_options);
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch demographics data:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchDemographicsData();
// //   }, [jobFilter, timeRange]);

// //   const handleTabChange = (event, newValue) => setTabValue(newValue);
// //   const handleTimeRangeChange = (event) => {
// //     setTimeRange(event.target.value);
// //     setJobFilter("all");
// //   };
// //   const handleJobFilterChange = (event) => {
// //     setJobFilter(event.target.value);
// //     setTimeRange("all");
// //   };
// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage);
// //   };
// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10));
// //     setPage(0);
// //   };

// //   return (
// //     <Layout title="Hiring Analytics">
// //       {/* CHANGED: Use theme's default background color */}
// //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// //         <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 } }}>
// //           <Stack spacing={{ xs: 2, md: 4 }}>
// //             <Paper
// //               sx={{
// //                 p: { xs: 2, sm: 3 },
// //                  // CHANGED: Use the custom mint color and primary text color from the theme
// //                 backgroundColor: "mint.main",
// //                 color: "primary.main",
// //               }}
// //             >
// //               <Typography
// //                 variant="h4"
// //                 component="h1"
// //                 fontWeight="bold"
// //                 sx={{
// //                   // CHANGED: Use the theme's primary color for the gradient
// //                   background: (theme) => theme.palette.primary.main,
// //                   backgroundClip: "text",
// //                   WebkitBackgroundClip: "text",
// //                   WebkitTextFillColor: "transparent",
// //                   fontSize: { xs: "1.75rem", sm: "2.5rem" },
// //                 }}
// //               >
// //                 Hiring Analytics Dashboard
// //               </Typography>
// //             </Paper>

// //             <Paper
// //               elevation={0}
// //               sx={{
// //                 // NOTE: The border is already theme-aware.
// //                 // Your global MuiPaper override will handle the rest.
// //                 // CHANGED: Use a theme-aware background color. `background.paper` is standard for this.
// //                 backgroundColor: "background.paper",
// //                 overflow: "hidden",
// //               }}
// //             >
// //               <Tabs
// //                 value={tabValue}
// //                 onChange={handleTabChange}
// //                 indicatorColor="primary"
// //                 textColor="primary"
// //                 variant="scrollable"
// //                 scrollButtons="auto"
// //                 allowScrollButtonsMobile
// //                 // NOTE: sx styles for Tabs are theme-aware and don't need changing
// //                 sx={{
// //                   "& .MuiTab-root": {
// //                     textTransform: "none",
// //                     fontWeight: 600,
// //                     fontSize: { xs: "0.8rem", sm: "0.875rem" },
// //                   },
// //                   "& .MuiTabs-indicator": {
// //                     height: 3,
// //                     borderRadius: "3px 3px 0 0",
// //                   },
// //                 }}
// //               >
// //                 <Tab
// //                   icon={<BarChart />}
// //                   label="OVERVIEW"
// //                   iconPosition="start"
// //                 />
// //                 <Tab icon={<Timeline />} label="TRENDS" iconPosition="start" />
// //                 <Tab
// //                   icon={<PieChart />}
// //                   label="DEMOGRAPHICS"
// //                   iconPosition="start"
// //                 />
// //                 <Tab
// //                   icon={<People />}
// //                   label="CANDIDATES"
// //                   iconPosition="start"
// //                 />
// //                 <Tab
// //                   icon={<History />}
// //                   label="RECENT ACTIVITY"
// //                   iconPosition="start"
// //                 />
// //               </Tabs>
// //             </Paper>

// //             <Box>
// //               <TabPanel value={tabValue} index={0}>
// //                 <OverviewTab loading={loading} data={overviewData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={1}>
// //                 <TrendsTab loading={loading} data={trendsData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={2}>
// //                 <DemographicsTab
// //                   loading={loading}
// //                   data={demographicsData}
// //                   skillChartRef={skillChartRef}
// //                   locationTableRef={locationTableRef}
// //                   timeRange={timeRange}
// //                   handleTimeRangeChange={handleTimeRangeChange}
// //                   jobFilter={jobFilter}
// //                   handleJobFilterChange={handleJobFilterChange}
// //                   filterOptions={filterOptions}
// //                   onExportClick={() => setIsExportModalOpen(true)}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={3}>
// //                 <CandidatesTab
// //                   loading={loading}
// //                   candidates={candidatesData.slice(
// //                     page * rowsPerPage,
// //                     page * rowsPerPage + rowsPerPage
// //                   )}
// //                   totalCandidates={candidatesData.length}
// //                   page={page}
// //                   rowsPerPage={rowsPerPage}
// //                   handleChangePage={handleChangePage}
// //                   handleChangeRowsPerPage={handleChangeRowsPerPage}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={4}>
// //                 <RecentActivityTab
// //                   loading={loading}
// //                   data={overviewData.recent_activity}
// //                 />
// //               </TabPanel>
// //             </Box>
// //           </Stack>
// //         </Container>
// //       </Box>
// //       <ExportReportDialog
// //         open={isExportModalOpen}
// //         onClose={() => setIsExportModalOpen(false)}
// //         candidatesData={candidatesData}
// //         demographicsData={demographicsData}
// //         overviewData={overviewData}
// //         skillChartRef={skillChartRef}
// //         locationTableRef={locationTableRef}
// //       />
// //     </Layout>
// //   );
// // }

// // export default EmployerAnalytics;

// // "use client";

// // import React, { useState, useEffect, useRef, useMemo } from "react";
// // import {
// //   Grid,
// //   Card,
// //   CardContent,
// //   Typography,
// //   Button,
// //   Box,
// //   Chip,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Avatar,
// //   Skeleton,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   CircularProgress,
// //   Stack,
// //   Paper,
// //   useTheme,
// //   Tabs,
// //   Tab,
// //   FormControl,
// //   Select,
// //   MenuItem,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   ListItemAvatar,
// //   LinearProgress,
// //   TablePagination,
// //   Tooltip,
// //   Container,
// //   Fade,
// //   Grow,
// //   alpha,
// //   RadioGroup,
// //   FormControlLabel,
// //   Radio,
// //   FormLabel,
// // } from "@mui/material";
// // import {
// //   PostAdd,
// //   People,
// //   Visibility,
// //   Schedule,
// //   ArrowForward,
// //   Close,
// //   Edit,
// //   Save,
// //   LocationOn,
// //   TrendingUp,
// //   WorkOutline,
// //   School,
// //   BarChart,
// //   PieChart,
// //   Timeline,
// //   CloudDownload,
// //   Star,
// //   CheckCircle,
// //   HelpOutline,
// //   ArrowRightAlt,
// //   MonetizationOn,
// //   AccessTime,
// //   RateReview,
// //   History,
// //   ArrowDownward,
// // } from "@mui/icons-material";
// // import * as htmlToImage from "html-to-image";
// // import ReactApexChart from "react-apexcharts";
// // import Layout from "../common/Layout";
// // import apiClient from "../../context/apiClient";

// // const downloadFile = ({ data, fileName, fileType }) => {
// //   const blob = new Blob([data], { type: fileType });
// //   const a = document.createElement("a");
// //   a.download = fileName;
// //   a.href = window.URL.createObjectURL(blob);
// //   const clickEvt = new MouseEvent("click", {
// //     view: window,
// //     bubbles: true,
// //     cancelable: true,
// //   });
// //   a.dispatchEvent(clickEvt);
// //   a.remove();
// // };

// // const convertToCSV = (data) => {
// //   if (!data || data.length === 0) return "";
// //   const headers = Object.keys(data[0]);
// //   const csvRows = [headers.join(",")];
// //   for (const row of data) {
// //     const values = headers.map((header) => {
// //       const escaped = ("" + row[header]).replace(/"/g, '""');
// //       return `"${escaped}"`;
// //     });
// //     csvRows.push(values.join(","));
// //   }
// //   return csvRows.join("\n");
// // };

// // const generateUniqueColors = (count) => {
// //   if (count === 0) return [];
// //   const colors = [];
// //   const hueStep = 360 / count;
// //   for (let i = 0; i < count; i++) {
// //     const hue = i * hueStep;
// //     colors.push(`hsl(${hue}, 70%, 50%)`);
// //   }
// //   return colors;
// // };

// // const ExportReportDialog = ({
// //   open,
// //   onClose,
// //   candidatesData,
// //   demographicsData,
// //   overviewData,
// //   skillChartRef,
// //   locationTableRef,
// // }) => {
// //   const [reportType, setReportType] = useState("demographics_skills");
// //   const [format, setFormat] = useState("png");

// //   const handleDownload = async () => {
// //     let dataToExport = [];
// //     let fileName = `${reportType}_report`;
// //     const isImageFormat = format === "png";

// //     if (isImageFormat) {
// //       const elementToCapture =
// //         reportType === "demographics_skills"
// //           ? skillChartRef.current
// //           : locationTableRef.current;
// //       if (!elementToCapture) {
// //         console.error("Target element for image capture not found.");
// //         return;
// //       }
// //       try {
// //         const dataUrl = await htmlToImage.toPng(elementToCapture);
// //         const a = document.createElement("a");
// //         a.href = dataUrl;
// //         a.download = `${reportType}_${new Date()
// //           .toISOString()
// //           .slice(0, 10)}.png`;
// //         a.click();
// //       } catch (error) {
// //         console.error("Failed to capture component as image", error);
// //       }
// //     } else {
// //       switch (reportType) {
// //         case "candidates":
// //           dataToExport = candidatesData.map((c) => ({
// //             id: c.candidate_id,
// //             name: c.candidate_name,
// //             location: c.location,
// //             status: c.status,
// //             match_score: c.match_score,
// //             skills: c.skills.join("|"),
// //             experience: c.experience
// //               .map((e) => `${e.title} at ${e.company}`)
// //               .join(" | "),
// //           }));
// //           break;
// //         case "demographics_skills":
// //           dataToExport = demographicsData.skill_distribution;
// //           fileName = "skill_distribution_report";
// //           break;
// //         case "demographics_locations":
// //           dataToExport = demographicsData.candidate_locations;
// //           fileName = "candidate_locations_report";
// //           break;
// //         case "overview":
// //           dataToExport = [overviewData.summary_stats];
// //           break;
// //         default:
// //           console.error("Invalid report type");
// //           return;
// //       }

// //       if (format === "csv") {
// //         const csvData = convertToCSV(dataToExport);
// //         downloadFile({
// //           data: csvData,
// //           fileName: `${fileName}.csv`,
// //           fileType: "text/csv",
// //         });
// //       } else if (format === "json") {
// //         downloadFile({
// //           data: JSON.stringify(dataToExport, null, 2),
// //           fileName: `${fileName}.json`,
// //           fileType: "application/json",
// //         });
// //       }
// //     }
// //     onClose();
// //   };

// //   const isVisualReport =
// //     reportType === "demographics_skills" ||
// //     reportType === "demographics_locations";

// //   return (
// //     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
// //       <DialogTitle fontWeight="bold">Export Report</DialogTitle>
// //       <DialogContent dividers>
// //         <Stack spacing={4}>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Report Type
// //             </FormLabel>
// //             <RadioGroup
// //               value={reportType}
// //               onChange={(e) => setReportType(e.target.value)}
// //             >
// //               <FormControlLabel
// //                 value="demographics_skills"
// //                 control={<Radio />}
// //                 label="Skill Distribution"
// //               />
// //               <FormControlLabel
// //                 value="demographics_locations"
// //                 control={<Radio />}
// //                 label="Candidate Locations"
// //               />
// //               <FormControlLabel
// //                 value="candidates"
// //                 control={<Radio />}
// //                 label="Top Candidates (Data Only)"
// //               />
// //               <FormControlLabel
// //                 value="overview"
// //                 control={<Radio />}
// //                 label="Hiring Stats Overview (Data Only)"
// //               />
// //             </RadioGroup>
// //           </FormControl>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Format
// //             </FormLabel>
// //             <RadioGroup
// //               row
// //               value={format}
// //               onChange={(e) => setFormat(e.target.value)}
// //             >
// //               <FormControlLabel
// //                 value="png"
// //                 control={<Radio />}
// //                 label="Image (PNG)"
// //                 disabled={!isVisualReport}
// //               />
// //               <FormControlLabel value="csv" control={<Radio />} label="CSV" />
// //               <FormControlLabel value="json" control={<Radio />} label="JSON" />
// //             </RadioGroup>
// //           </FormControl>
// //         </Stack>
// //       </DialogContent>
// //       <DialogActions sx={{ p: 2 }}>
// //         <Button onClick={onClose} color="inherit">
// //           Cancel
// //         </Button>
// //         <Button
// //           onClick={handleDownload}
// //           variant="contained"
// //           startIcon={<CloudDownload />}
// //         >
// //           Download
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // const cleanSkill = (skill) => {
// //   return skill.replace(/[\[\]"]/g, "");
// // };

// // const SkillDonutChart = ({ data, colors }) => {
// //   const theme = useTheme();
// //   const chartSeries = data.map((item) => item.count);
// //   const chartOptions = {
// //     chart: { type: "donut", background: "transparent" },
// //     plotOptions: {
// //       pie: {
// //         donut: {
// //           size: "70%",
// //           labels: {
// //             show: true,
// //             total: {
// //               show: true,
// //               label: "Total Skills",
// //               color: theme.palette.text.secondary,
// //               formatter: (w) =>
// //                 w.globals.seriesTotals.reduce((a, b) => a + b, 0),
// //             },
// //           },
// //         },
// //       },
// //     },
// //     dataLabels: { enabled: false },
// //     legend: { show: false },
// //     colors: colors,
// //     tooltip: { y: { formatter: (val) => `${val} candidates` } },
// //   };
// //   return (
// //     <ReactApexChart
// //       options={chartOptions}
// //       series={chartSeries}
// //       type="donut"
// //       height={420}
// //     />
// //   );
// // };

// // const SkillList = ({ data, colors }) => {
// //   return (
// //     <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 2 }}>
// //       <List>
// //         {data.map((item, index) => (
// //           <ListItem key={item.skill} disablePadding>
// //             <Stack
// //               direction="row"
// //               alignItems="center"
// //               spacing={2}
// //               sx={{ width: "100%", py: 0.5 }}
// //             >
// //               <Box
// //                 sx={{
// //                   width: 16,
// //                   height: 16,
// //                   borderRadius: "4px",
// //                   bgcolor: colors[index % colors.length],
// //                   flexShrink: 0,
// //                 }}
// //               />
// //               <ListItemText
// //                 primary={
// //                   <Typography variant="body2" color="text.primary" noWrap>
// //                     {cleanSkill(item.skill)}
// //                   </Typography>
// //                 }
// //               />
// //               <Typography
// //                 variant="body2"
// //                 color="text.secondary"
// //                 fontWeight="bold"
// //               >
// //                 {item.count}
// //               </Typography>
// //             </Stack>
// //           </ListItem>
// //         ))}
// //       </List>
// //     </Box>
// //   );
// // };

// // const ApplicationTrendChart = ({ data, height = 450 }) => {
// //   const theme = useTheme();

// //   if (
// //     !data ||
// //     !data.datasets ||
// //     !data.datasets[0] ||
// //     !data.datasets[0].data ||
// //     data.datasets[0].data.length === 0
// //   ) {
// //     return (
// //       <Box
// //         sx={{
// //           height,
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           bgcolor: alpha(theme.palette.grey[100], 0.3),
// //           borderRadius: 2,
// //           border: `1px dashed ${theme.palette.grey[300]}`,
// //           m: 3,
// //         }}
// //       >
// //         <Typography variant="body2" color="text.secondary">
// //           No trend data available.
// //         </Typography>
// //       </Box>
// //     );
// //   }

// //   const chartSeries = [
// //     {
// //       name: "Applications",
// //       data: data.datasets[0].data,
// //     },
// //   ];

// //   const chartOptions = {
// //     chart: {
// //       type: "area",
// //       height: height,
// //       toolbar: {
// //         show: false,
// //       },
// //       zoom: {
// //         enabled: false,
// //       },
// //       background: "transparent",
// //     },
// //     colors: [theme.palette.primary.main],
// //     dataLabels: {
// //       enabled: false,
// //     },
// //     stroke: {
// //       curve: "smooth",
// //       width: 3,
// //       lineCap: "round",
// //     },
// //     fill: {
// //       type: "gradient",
// //       gradient: {
// //         shadeIntensity: 1,
// //         opacityFrom: 0.4,
// //         opacityTo: 0.1,
// //         stops: [0, 90, 100],
// //       },
// //     },
// //     grid: {
// //       show: true,
// //       borderColor: theme.palette.divider,
// //       strokeDashArray: 4,
// //       xaxis: {
// //         lines: {
// //           show: false,
// //         },
// //       },
// //       yaxis: {
// //         lines: {
// //           show: true,
// //         },
// //       },
// //     },
// //     xaxis: {
// //       categories: data.labels,
// //       axisBorder: {
// //         show: false,
// //       },
// //       axisTicks: {
// //         show: false,
// //       },
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //           fontWeight: 500,
// //         },
// //       },
// //     },
// //     yaxis: {
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //         },
// //         formatter: function (val) {
// //           return val.toFixed(0);
// //         },
// //       },
// //     },
// //     tooltip: {
// //       x: {
// //         format: "MMM yyyy",
// //       },
// //       y: {
// //         formatter: (val) => `${val} applications`,
// //       },
// //       theme: "light",
// //       marker: {
// //         show: true,
// //       },
// //     },
// //   };

// //   return (
// //     <ReactApexChart
// //       options={chartOptions}
// //       series={chartSeries}
// //       type="area"
// //       height={height}
// //     />
// //   );
// // };

// // function TabPanel(props) {
// //   const { children, value, index, ...other } = props;
// //   return (
// //     <div
// //       role="tabpanel"
// //       hidden={value !== index}
// //       id={`analytics-tabpanel-${index}`}
// //       aria-labelledby={`analytics-tab-${index}`}
// //       {...other}
// //     >
// //       {value === index && (
// //         <Fade in={value === index} timeout={500}>
// //           <Box sx={{ pt: 4 }}>{children}</Box>
// //         </Fade>
// //       )}
// //     </div>
// //   );
// // }

// // const getStatusColor = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return "success";
// //     case "interviewed":
// //       return "primary";
// //     case "shortlisted":
// //       return "info";
// //     case "applied":
// //     case "matched":
// //       return "warning";
// //     default:
// //       return "default";
// //   }
// // };

// // const getStatusIcon = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return <CheckCircle />;
// //     case "interviewed":
// //       return <People />;
// //     case "shortlisted":
// //       return <Star />;
// //     case "applied":
// //     case "matched":
// //       return <WorkOutline />;
// //     default:
// //       return <HelpOutline />;
// //   }
// // };

// // const OverviewTab = ({ loading, data }) => {
// //   const theme = useTheme();

// //   const applicationTrendsData = {
// //     labels: data.application_trend?.map((d) => d.month) || [],
// //     datasets: [
// //       {
// //         label: "Applications",
// //         data: data.application_trend?.map((d) => d.application_count) || [],
// //         backgroundColor: theme.palette.primary.main,
// //       },
// //     ],
// //   };

// //   const statCards = [
// //     {
// //       label: "Total Applications",
// //       value: data.summary_stats?.total_applications || 0,
// //     },
// //     {
// //       label: "Total Interviews",
// //       value: data.summary_stats?.total_interviews || 0,
// //     },
// //     {
// //       label: "Total Hires",
// //       value: data.summary_stats?.total_hires || 0,
// //     },
// //     {
// //       label: "Acceptance Rate",
// //       value: data.summary_stats?.acceptance_rate || "0%",
// //     },
// //   ];

// //   return (
// //     <Stack spacing={4}>
// //       <Box
// //         sx={{
// //           display: "flex",
// //           flexDirection: { xs: "column", sm: "row" },
// //           gap: { xs: 2, md: 3 },
// //         }}
// //       >
// //         {loading
// //           ? [...Array(4)].map((_, index) => (
// //               <Box key={index} sx={{ flex: 1, minWidth: 0 }}>
// //                 <Skeleton
// //                   variant="rectangular"
// //                   width="100%"
// //                   height={140}
// //                   sx={{ borderRadius: "12px" }}
// //                 />
// //               </Box>
// //             ))
// //           : statCards.map((card, index) => (
// //               <Box key={index} sx={{ flex: 1, minWidth: 0 }}>
// //                 <Box
// //                   sx={{
// //                     width: "100%",
// //                     height: 140,
// //                     backgroundColor: "primary.main",
// //                     borderRadius: "12px",
// //                     boxShadow: theme.shadows[3],
// //                     position: "relative",
// //                     overflow: "hidden",
// //                     p: { xs: 1.5, sm: 2, md: 2.5 },
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     justifyContent: "space-between",
// //                   }}
// //                 >
// //                   <Box
// //                     sx={{
// //                       position: "absolute",
// //                       top: 0,
// //                       right: 0,
// //                       width: "100%",
// //                       height: "100%",
// //                       zIndex: 0,
// //                     }}
// //                   >
// //                     <svg
// //                       width="100%"
// //                       height="100%"
// //                       viewBox="0 0 280 140"
// //                       preserveAspectRatio="none"
// //                       style={{ position: "absolute", right: 0, top: 0 }}
// //                     >
// //                       <path
// //                         d="M200 0 L280 0 L280 140 C 250 140, 230 105, 230 70 C 230 35, 250 0, 200 0 Z"
// //                         fill={
// //                           theme.palette.accent?.main ||
// //                           theme.palette.secondary.light
// //                         }
// //                       />
// //                     </svg>
// //                   </Box>
// //                   <Box sx={{ position: "relative", zIndex: 1 }}>
// //                     <Typography
// //                       sx={{
// //                         fontSize: { xs: "0.65rem", sm: "0.75rem" },
// //                         fontWeight: 600,
// //                         color: alpha(
// //                           theme.palette.primary.contrastText,
// //                           0.8
// //                         ),
// //                         textTransform: "uppercase",
// //                         lineHeight: 1.2,
// //                       }}
// //                     >
// //                       {card.label}
// //                     </Typography>
// //                   </Box>
// //                   <Box sx={{ position: "relative", zIndex: 1 }}>
// //                     <Typography
// //                       sx={{
// //                         fontSize: { xs: "1.75rem", md: "2.25rem" },
// //                         fontWeight: "bold",
// //                         color: "primary.contrastText",
// //                         lineHeight: 1,
// //                       }}
// //                     >
// //                       {card.value}
// //                     </Typography>
// //                   </Box>
// //                 </Box>
// //               </Box>
// //             ))}
// //       </Box>

// //       <Card
// //         sx={{
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[4],
// //           width: "100%",
// //           backgroundColor: "#F1FFFA",
// //           transition: "all 0.3s ease",
// //           "&:hover": { boxShadow: theme.shadows[8] },
// //         }}
// //       >
// //         <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
// //           <Box sx={{ p: 3, pb: 0 }}>
// //             {loading ? (
// //               <Skeleton variant="text" width="60%" height={32} />
// //             ) : (
// //               <Typography
// //                 variant="h6"
// //                 fontWeight="bold"
// //                 color="text.primary"
// //               >
// //                 Application Trends
// //               </Typography>
// //             )}
// //           </Box>
// //           {loading ? (
// //             <Box sx={{ p: 3 }}>
// //               <Skeleton
// //                 variant="rectangular"
// //                 height={400}
// //                 sx={{ borderRadius: 2 }}
// //               />
// //             </Box>
// //           ) : (
// //             <ApplicationTrendChart data={applicationTrendsData} />
// //           )}
// //         </CardContent>
// //       </Card>
// //     </Stack>
// //   );
// // };

// // const RecentActivityTab = ({ loading, data }) => {
// //   const theme = useTheme();

// //   const getActivityIcon = (activityString) => {
// //     const lowerCaseActivity = activityString.toLowerCase();
// //     if (lowerCaseActivity.includes("hired")) return <CheckCircle />;
// //     if (lowerCaseActivity.includes("interview")) return <People />;
// //     if (lowerCaseActivity.includes("applied")) return <WorkOutline />;
// //     return <RateReview />;
// //   };

// //   return (
// //     <Card
// //       sx={{
// //         borderRadius: 3,
// //         boxShadow: theme.shadows[4],
// //         width: "100%",
// //         backgroundColor: "#F1FFFA",
// //         transition: "all 0.3s ease",
// //         "&:hover": { boxShadow: theme.shadows[8] },
// //       }}
// //     >
// //       <CardContent sx={{ p: 3 }}>
// //         {loading ? (
// //           <Skeleton variant="text" width="50%" height={32} />
// //         ) : (
// //           <Typography
// //             variant="h6"
// //             fontWeight="bold"
// //             gutterBottom
// //             color="text.primary"
// //           >
// //             Recent Activity
// //           </Typography>
// //         )}
// //         <List sx={{ mt: 2 }}>
// //           {loading
// //             ? Array.from(new Array(5)).map((_, index) => (
// //                 <ListItem key={index} sx={{ px: 0, py: 1.5 }}>
// //                   <ListItemAvatar>
// //                     <Skeleton variant="circular" width={48} height={48} />
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={<Skeleton variant="text" width="80%" />}
// //                     secondary={<Skeleton variant="text" width="60%" />}
// //                   />
// //                 </ListItem>
// //               ))
// //             : data?.map((activity, index) => (
// //                 <ListItem
// //                   key={`${activity.candidate_name}-${index}`}
// //                   sx={{
// //                     px: 0,
// //                     py: 1.5,
// //                     borderRadius: 2,
// //                     transition: "all 0.2s ease",
// //                     "&:hover": {
// //                       bgcolor: alpha(theme.palette.primary.main, 0.04),
// //                     },
// //                   }}
// //                 >
// //                   <ListItemAvatar>
// //                     <Avatar
// //                       sx={{
// //                         bgcolor: alpha(theme.palette.primary.main, 0.1),
// //                         color: theme.palette.primary.main,
// //                         width: 48,
// //                         height: 48,
// //                         boxShadow: theme.shadows[2],
// //                       }}
// //                     >
// //                       {getActivityIcon(activity.activity)}
// //                     </Avatar>
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={
// //                       <Typography
// //                         variant="body2"
// //                         fontWeight="600"
// //                         color="text.primary"
// //                       >
// //                         {activity.candidate_name}
// //                       </Typography>
// //                     }
// //                     secondary={
// //                       <Typography variant="caption" color="text.secondary">
// //                         {activity.activity} • {activity.time_ago}
// //                       </Typography>
// //                     }
// //                   />
// //                 </ListItem>
// //               ))}
// //         </List>
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // const TrendsTab = ({ loading, data }) => {
// //   const theme = useTheme();

// //   const funnelData = [
// //     {
// //       icon: <WorkOutline color="primary" />,
// //       title: "Applications",
// //       value: data?.hiring_funnel?.applications || 0,
// //       color: theme.palette.primary.main,
// //     },
// //     {
// //       icon: <People color="secondary" />,
// //       title: "Interviews",
// //       value: data?.hiring_funnel?.interviews || 0,
// //       conversion: data?.hiring_funnel?.interview_conversion_rate || "0%",
// //       color: theme.palette.secondary.main,
// //     },
// //     {
// //       icon: <CheckCircle color="success" />,
// //       title: "Hires",
// //       value: data?.hiring_funnel?.hires || 0,
// //       conversion: data?.hiring_funnel?.hire_conversion_rate || "0%",
// //       color: theme.palette.success.main,
// //     },
// //   ];

// //   const kpiData = [
// //     {
// //       icon: <AccessTime />,
// //       title: "Average Time to Hire",
// //       value: data?.key_performance_metrics?.average_time_to_hire || "N/A",
// //       color: theme.palette.primary,
// //     },
// //     {
// //       icon: <MonetizationOn />,
// //       title: "Cost Per Hire",
// //       value: data?.key_performance_metrics?.cost_per_hire || "N/A",
// //       color: theme.palette.success,
// //     },
// //     {
// //       icon: <RateReview />,
// //       title: "Offer Acceptance Rate",
// //       value: data?.key_performance_metrics?.offer_acceptance_rate || "N/A",
// //       color: theme.palette.secondary,
// //     },
// //   ];

// //   return (
// //     <Grid container spacing={4}>
// //       <Grid item xs={12} lg={5}>
// //         <Card
// //           sx={{
// //             borderRadius: 3,
// //             boxShadow: theme.shadows[4],
// //             height: "100%",
// //             width: "520px",
// //             backgroundColor: "#F1FFFA",
// //             p: 2,
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent>
// //             <Typography
// //               variant="h6"
// //               fontWeight="bold"
// //               gutterBottom
// //               color="text.primary"
// //             >
// //               Hiring Funnel
// //             </Typography>
// //             {loading ? (
// //               <Stack spacing={4} sx={{ mt: 3 }}>
// //                 <Skeleton
// //                   variant="rectangular"
// //                   height={60}
// //                   sx={{ borderRadius: 2 }}
// //                 />
// //                 <Skeleton
// //                   variant="rectangular"
// //                   height={60}
// //                   sx={{ borderRadius: 2 }}
// //                 />
// //                 <Skeleton
// //                   variant="rectangular"
// //                   height={60}
// //                   sx={{ borderRadius: 2 }}
// //                 />
// //               </Stack>
// //             ) : (
// //               <Stack spacing={2} sx={{ mt: 4 }}>
// //                 {funnelData.map((step, index) => (
// //                   <Grow in timeout={500 + index * 200} key={step.title}>
// //                     <Box>
// //                       <Paper
// //                         variant="outlined"
// //                         sx={{
// //                           p: 2,
// //                           display: "flex",
// //                           alignItems: "center",
// //                           borderRadius: 2,
// //                           borderColor: alpha(step.color, 0.3),
// //                           background: `linear-gradient(to right, ${alpha(
// //                             step.color,
// //                             0.1
// //                           )}, transparent)`,
// //                         }}
// //                       >
// //                         <Avatar
// //                           sx={{
// //                             bgcolor: alpha(step.color, 0.15),
// //                             color: step.color,
// //                             mr: 2,
// //                           }}
// //                         >
// //                           {step.icon}
// //                         </Avatar>
// //                         <Box sx={{ flexGrow: 1 }}>
// //                           <Typography variant="body2" color="text.secondary">
// //                             {step.title}
// //                           </Typography>
// //                           <Typography variant="h5" fontWeight="bold">
// //                             {step.value}
// //                           </Typography>
// //                         </Box>
// //                         {step.conversion && (
// //                           <Box sx={{ textAlign: "right" }}>
// //                             <Typography
// //                               variant="caption"
// //                               color="text.secondary"
// //                             >
// //                               Conversion
// //                             </Typography>
// //                             <Typography
// //                               variant="body1"
// //                               fontWeight="bold"
// //                               color={step.color}
// //                             >
// //                               {step.conversion}
// //                             </Typography>
// //                           </Box>
// //                         )}
// //                       </Paper>
// //                       {index < funnelData.length - 1 && (
// //                         <Box display="flex" justifyContent="center" my={1}>
// //                           <ArrowDownward sx={{ color: "grey.400" }} />
// //                         </Box>
// //                       )}
// //                     </Box>
// //                   </Grow>
// //                 ))}
// //               </Stack>
// //             )}
// //           </CardContent>
// //         </Card>
// //       </Grid>

// //       <Grid item xs={12} lg={7}>
// //         <Card
// //           sx={{
// //             borderRadius: 3,
// //             boxShadow: theme.shadows[4],
// //             height: "100%",
// //             backgroundColor: "#F1FFFA",
// //             p: 2,
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent>
// //             <Typography
// //               variant="h6"
// //               fontWeight="bold"
// //               gutterBottom
// //               color="text.primary"
// //             >
// //               Key Performance Metrics
// //             </Typography>
// //             <Grid container spacing={3} sx={{ mt: 2, height: "100%" }}>
// //               {loading
// //                 ? Array.from(new Array(3)).map((_, index) => (
// //                     <Grid item xs={12} sm={4} key={index}>
// //                       <Skeleton
// //                         variant="rectangular"
// //                         height={150}
// //                         sx={{ borderRadius: 2 }}
// //                       />
// //                     </Grid>
// //                   ))
// //                 : kpiData.map((kpi, index) => (
// //                     <Grid item xs={12} sm={4} key={kpi.title}>
// //                       <Grow in timeout={500 + index * 200}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{
// //                             p: 3,
// //                             borderRadius: 2,
// //                             textAlign: "center",
// //                             height: "100%",
// //                             display: "flex",
// //                             flexDirection: "column",
// //                             justifyContent: "center",
// //                             borderColor: alpha(kpi.color.main, 0.3),
// //                             backgroundColor: alpha(kpi.color.main, 0.05),
// //                           }}
// //                         >
// //                           <Avatar
// //                             sx={{
// //                               bgcolor: alpha(kpi.color.main, 0.1),
// //                               color: kpi.color.main,
// //                               width: 56,
// //                               height: 56,
// //                               mx: "auto",
// //                               mb: 1.5,
// //                             }}
// //                           >
// //                             {kpi.icon}
// //                           </Avatar>
// //                           <Typography
// //                             variant="body2"
// //                             fontWeight="600"
// //                             color="text.primary"
// //                           >
// //                             {kpi.title}
// //                           </Typography>
// //                           <Typography
// //                             variant="h4"
// //                             fontWeight="bold"
// //                             color="text.primary"
// //                             sx={{ mt: 1 }}
// //                           >
// //                             {kpi.value}
// //                           </Typography>
// //                         </Paper>
// //                       </Grow>
// //                     </Grid>
// //                   ))}
// //             </Grid>
// //           </CardContent>
// //         </Card>
// //       </Grid>
// //     </Grid>
// //   );
// // };

// // const DemographicsTab = ({
// //   loading,
// //   data,
// //   skillChartRef,
// //   locationTableRef,
// //   timeRange,
// //   handleTimeRangeChange,
// //   jobFilter,
// //   handleJobFilterChange,
// //   filterOptions,
// //   onExportClick,
// // }) => {
// //   const theme = useTheme();
// //   const colorPalette = useMemo(() => {
// //     if (!data || !data.skill_distribution) {
// //       return [];
// //     }
// //     return generateUniqueColors(data.skill_distribution.length);
// //   }, [data.skill_distribution]);

// //   return (
// //     <Stack spacing={4}>
// //       <Paper
// //         elevation={0}
// //         sx={{
// //           p: 2,
// //           borderRadius: 3,
// //           backgroundColor: "#F1FFFA",
// //           border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
// //         }}
// //       >
// //         <Stack
// //           direction={{ xs: "column", md: "row" }}
// //           spacing={2}
// //           alignItems="center"
// //           justifyContent="flex-end"
// //         >
// //           <FormControl size="small">
// //             <Select
// //               value={timeRange}
// //               onChange={handleTimeRangeChange}
// //               sx={{
// //                 borderRadius: 2,
// //                 backgroundColor: "#F1FFFA",
// //                 minWidth: 140,
// //               }}
// //             >
// //               <MenuItem value="last30days">Last Month</MenuItem>
// //               <MenuItem value="last3months">Last 3 Months</MenuItem>
// //               <MenuItem value="last6months">Last 6 Months</MenuItem>
// //               <MenuItem value="lastyear">Last Year</MenuItem>
// //             </Select>
// //           </FormControl>
// //           <FormControl size="small">
// //             <Select
// //               value={jobFilter}
// //               onChange={handleJobFilterChange}
// //               sx={{
// //                 borderRadius: 2,
// //                 backgroundColor: "#F1FFFA",
// //                 minWidth: 180,
// //               }}
// //             >
// //               {filterOptions.job_roles.map((job) => (
// //                 <MenuItem
// //                   key={job || "all-jobs"}
// //                   value={
// //                     job === "All Jobs" || !job ? "all" : job
// //                   }
// //                 >
// //                   {job || "All Jobs"}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <Button
// //             variant="outlined"
// //             startIcon={<CloudDownload />}
// //             size="medium"
// //             onClick={onExportClick}
// //             sx={{
// //               borderRadius: 2,
// //               textTransform: "none",
// //               fontWeight: 600,
// //             }}
// //           >
// //             Export Report
// //           </Button>
// //         </Stack>
// //       </Paper>
// //       <Grid container spacing={4}>
// //         <Grid item xs={12} lg={8}>
// //           <Card
// //             ref={skillChartRef}
// //             sx={{
// //               borderRadius: 3,
// //               boxShadow: theme.shadows[4],
// //               height: "100%",
// //               backgroundColor: "#F1FFFA",
// //             }}
// //           >
// //             <CardContent sx={{ p: 3 }}>
// //               <Typography
// //                 variant="h6"
// //                 gutterBottom
// //                 fontWeight="bold"
// //                 color="text.primary"
// //               >
// //                 Skill Distribution
// //               </Typography>
// //               {loading ? (
// //                 <Skeleton variant="rectangular" height={450} />
// //               ) : (
// //                 <Grid
// //                   container
// //                   spacing={2}
// //                   alignItems="center"
// //                   sx={{ mt: 1 }}
// //                 >
// //                   <Grid item xs={12} sm={8}>
// //                     <SkillDonutChart
// //                       data={data.skill_distribution}
// //                       colors={colorPalette}
// //                     />
// //                   </Grid>
// //                   <Grid item xs={12} sm={4}>
// //                     <SkillList
// //                       data={data.skill_distribution}
// //                       colors={colorPalette}
// //                     />
// //                   </Grid>
// //                 </Grid>
// //               )}
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} lg={4}>
// //           <Card
// //             ref={locationTableRef}
// //             sx={{
// //               borderRadius: 3,
// //               boxShadow: theme.shadows[4],
// //               height: "100%",
// //               width: "550px",
// //               backgroundColor: "#F1FFFA",
// //             }}
// //           >
// //             <CardContent sx={{ p: 4 }}>
// //               <Typography
// //                 variant="h6"
// //                 gutterBottom
// //                 fontWeight="bold"
// //                 color="text.primary"
// //               >
// //                 Candidate Locations
// //               </Typography>
// //               <TableContainer sx={{ mt: 3 }}>
// //                 <Table>
// //                   <TableHead>
// //                     <TableRow>
// //                       <TableCell>
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Location
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell align="right">
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Candidates
// //                         </Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   </TableHead>
// //                   <TableBody>
// //                     {loading
// //                       ? Array.from(new Array(5)).map((_, index) => (
// //                           <TableRow key={index}>
// //                             <TableCell>
// //                               <Skeleton variant="text" />
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Skeleton
// //                                 variant="rounded"
// //                                 width={40}
// //                                 height={24}
// //                               />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))
// //                       : data.candidate_locations.map((loc) => (
// //                           <TableRow
// //                             key={loc.location}
// //                             sx={{
// //                               "&:hover": {
// //                                 bgcolor: alpha(theme.palette.primary.main, 0.04),
// //                               },
// //                             }}
// //                           >
// //                             <TableCell component="th" scope="row">
// //                               <Typography variant="body2" fontWeight="500">
// //                                 {loc.location}
// //                               </Typography>
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Chip
// //                                 label={loc.candidates}
// //                                 size="small"
// //                                 color="primary"
// //                                 variant="outlined"
// //                               />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))}
// //                   </TableBody>
// //                 </Table>
// //               </TableContainer>
// //             </CardContent>
// //           </Card>
// //         </Grid>
// //       </Grid>
// //     </Stack>
// //   );
// // };

// // const CandidatesTab = ({
// //   loading,
// //   candidates,
// //   totalCandidates,
// //   page,
// //   rowsPerPage,
// //   handleChangePage,
// //   handleChangeRowsPerPage,
// // }) => {
// //   const theme = useTheme();
// //   const getExperienceTooltip = (experienceArray) => {
// //     if (!Array.isArray(experienceArray) || experienceArray.length === 0) {
// //       return "No experience details available.";
// //     }
// //     return experienceArray
// //       .map(
// //         (exp) =>
// //           `${exp.title || "N/A"} at ${exp.company || "N/A"} (${
// //             exp.duration || "N/A"
// //           })`
// //       )
// //       .join("\n");
// //   };

// //   return (
// //     <Card
// //       sx={{
// //         borderRadius: 3,
// //         boxShadow: theme.shadows[4],
// //         backgroundColor: "#F1FFFA",
// //       }}
// //     >
// //       <CardContent sx={{ p: 4 }}>
// //         <Typography
// //           variant="h6"
// //           gutterBottom
// //           fontWeight="bold"
// //           color="text.primary"
// //         >
// //           Top Candidates
// //         </Typography>
// //         <TableContainer sx={{ mt: 3 }}>
// //           <Table sx={{ minWidth: 650 }} aria-label="top candidates table">
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Candidate
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Experience
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Top Skills
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Match Score
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Status
// //                   </Typography>
// //                 </TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {loading
// //                 ? Array.from(new Array(rowsPerPage)).map((_, index) => (
// //                     <TableRow key={index}>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton variant="circular" width={48} height={48} />
// //                           <Stack spacing={0.5}>
// //                             <Skeleton variant="text" width={120} />
// //                             <Skeleton variant="text" width={100} />
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton variant="text" width={100} />
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" spacing={0.5} flexWrap="wrap">
// //                           <Skeleton
// //                             variant="rounded"
// //                             width={60}
// //                             height={24}
// //                           />
// //                           <Skeleton
// //                             variant="rounded"
// //                             width={70}
// //                             height={24}
// //                           />
// //                           <Skeleton
// //                             variant="rounded"
// //                             width={50}
// //                             height={24}
// //                           />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton
// //                             variant="rectangular"
// //                             width={100}
// //                             height={8}
// //                             sx={{ borderRadius: 1 }}
// //                           />
// //                           <Skeleton variant="text" width={30} />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton
// //                           variant="rounded"
// //                           width={90}
// //                           height={28}
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))
// //                 : candidates.map((candidate) => (
// //                     <TableRow
// //                       key={candidate.candidate_id}
// //                       hover
// //                       sx={{
// //                         "&:hover": {
// //                           bgcolor: alpha(theme.palette.primary.main, 0.04),
// //                         },
// //                       }}
// //                     >
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Avatar
// //                             src={candidate.avatar}
// //                             sx={{ width: 48, height: 48 }}
// //                           />
// //                           <Stack>
// //                             <Typography variant="body2" fontWeight="600">
// //                               {candidate.candidate_name}
// //                             </Typography>
// //                             <Stack
// //                               direction="row"
// //                               alignItems="center"
// //                               spacing={0.5}
// //                             >
// //                               <LocationOn
// //                                 sx={{
// //                                   fontSize: 16,
// //                                   color: "text.secondary",
// //                                 }}
// //                               />
// //                               <Typography
// //                                 variant="caption"
// //                                 color="text.secondary"
// //                               >
// //                                 {candidate.location}
// //                               </Typography>
// //                             </Stack>
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={
// //                             <div style={{ whiteSpace: "pre-line" }}>
// //                               {getExperienceTooltip(candidate.experience)}
// //                             </div>
// //                           }
// //                           arrow
// //                         >
// //                           <Typography variant="body2" sx={{ cursor: "pointer" }}>
// //                             {(candidate.experience &&
// //                               candidate.experience[0]?.duration) ||
// //                               "N/A"}
// //                           </Typography>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={
// //                             Array.isArray(candidate.skills)
// //                               ? candidate.skills.join(", ")
// //                               : ""
// //                           }
// //                           arrow
// //                           placement="top"
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={0.5}
// //                             flexWrap="wrap"
// //                             sx={{ cursor: "pointer" }}
// //                           >
// //                             {Array.isArray(candidate.skills) &&
// //                               candidate.skills.slice(0, 3).map((skill) => (
// //                                 <Chip
// //                                   key={skill}
// //                                   label={skill}
// //                                   size="small"
// //                                   variant="outlined"
// //                                 />
// //                               ))}
// //                           </Stack>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <LinearProgress
// //                             variant="determinate"
// //                             value={candidate.match_score}
// //                             sx={{
// //                               width: 100,
// //                               height: 8,
// //                               borderRadius: 1,
// //                             }}
// //                           />
// //                           <Typography
// //                             variant="body2"
// //                             color="text.secondary"
// //                             fontWeight="500"
// //                           >
// //                             {candidate.match_score}%
// //                           </Typography>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Chip
// //                           icon={getStatusIcon(candidate.status)}
// //                           label={
// //                             candidate.status.charAt(0).toUpperCase() +
// //                             candidate.status.slice(1)
// //                           }
// //                           color={getStatusColor(candidate.status)}
// //                           size="small"
// //                           variant="filled"
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //         <TablePagination
// //           rowsPerPageOptions={[5, 10, 25]}
// //           component="div"
// //           count={totalCandidates}
// //           rowsPerPage={rowsPerPage}
// //           page={page}
// //           onPageChange={handleChangePage}
// //           onRowsPerPageChange={handleChangeRowsPerPage}
// //         />
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // function EmployerAnalytics() {
// //   const theme = useTheme();
// //   const [tabValue, setTabValue] = useState(0);
// //   const [timeRange, setTimeRange] = useState("last30days");
// //   const [jobFilter, setJobFilter] = useState("all");
// //   const [loading, setLoading] = useState(true);
// //   const [candidatesData, setCandidatesData] = useState([]);
// //   const [overviewData, setOverviewData] = useState({
// //     summary_stats: {
// //       total_applications: 0,
// //       total_interviews: 0,
// //       total_hires: 0,
// //       acceptance_rate: "0%",
// //     },
// //     application_trend: [],
// //     recent_activity: [],
// //   });
// //   const [demographicsData, setDemographicsData] = useState({
// //     skill_distribution: [],
// //     candidate_locations: [],
// //   });
// //   const [trendsData, setTrendsData] = useState(null);
// //   const [filterOptions, setFilterOptions] = useState({
// //     job_roles: ["All Jobs"],
// //     time_ranges: [
// //       "Last Month",
// //       "Last 3 Months",
// //       "Last 6 Months",
// //       "Last Year",
// //     ],
// //   });
// //   const [page, setPage] = useState(0);
// //   const [rowsPerPage, setRowsPerPage] = useState(5);
// //   const [isExportModalOpen, setIsExportModalOpen] = useState(false);
// //   const skillChartRef = useRef(null);
// //   const locationTableRef = useRef(null);

// //   const safeJsonParse = (str, fallback = []) => {
// //     if (typeof str !== "string") return fallback;
// //     try {
// //       return JSON.parse(str);
// //     } catch (e) {
// //       return fallback;
// //     }
// //   };

// //   useEffect(() => {
// //     const fetchInitialData = async () => {
// //       setLoading(true);
// //       try {
// //         const [candidatesResponse, overviewResponse, trendsResponse] =
// //           await Promise.all([
// //             apiClient.get("/hiring-analytics/top-matching-candidates/"),
// //             apiClient.get("/hiring-analytics/combined-dashboard/"),
// //             apiClient.get("/employer-analytics/trends"),
// //           ]);
// //         const mappedCandidates = candidatesResponse.data.map(
// //           (apiCandidate) => ({
// //             candidate_id: apiCandidate.candidate_id,
// //             candidate_name: apiCandidate.candidate_name,
// //             skills: apiCandidate.skills || [],
// //             match_score: apiCandidate.match_score,
// //             avatar: `/placeholder.svg?height=40&width=40`,
// //             experience: safeJsonParse(apiCandidate.experience, []),
// //             location: apiCandidate.location || "N/A",
// //             status: apiCandidate.status
// //               ? apiCandidate.status.toLowerCase()
// //               : "matched",
// //           })
// //         );

// //         setCandidatesData(mappedCandidates);
// //         setOverviewData(overviewResponse.data);
// //         setTrendsData(trendsResponse.data);
// //       } catch (error) {
// //         console.error("Failed to fetch initial data:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchInitialData();
// //   }, []);

// //   useEffect(() => {
// //     const fetchDemographicsData = async () => {
// //       setLoading(true);
// //       let url = "/demographics/";
// //       if (jobFilter !== "all") {
// //         url = `/demographics/job/${encodeURIComponent(jobFilter)}/`;
// //       } else if (timeRange !== "all") {
// //         url = `/demographics/time/${timeRange}/`;
// //       }

// //       try {
// //         const response = await apiClient.get(url);
// //         setDemographicsData(response.data);
// //         if (response.data.filter_options) {
// //           setFilterOptions(response.data.filter_options);
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch demographics data:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchDemographicsData();
// //   }, [jobFilter, timeRange]);

// //   const handleTabChange = (event, newValue) => setTabValue(newValue);
// //   const handleTimeRangeChange = (event) => {
// //     setTimeRange(event.target.value);
// //     setJobFilter("all");
// //   };
// //   const handleJobFilterChange = (event) => {
// //     setJobFilter(event.target.value);
// //     setTimeRange("all");
// //   };
// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage);
// //   };
// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10));
// //     setPage(0);
// //   };

// //   return (
// //     <Layout title="Hiring Analytics">
// //       <Box sx={{ bgcolor: "#f8fafc", minHeight: "100vh" }}>
// //         <Container maxWidth="xl" sx={{ py: 4 }}>
// //           <Stack spacing={4}>
// //             <Paper
// //               sx={{
// //                 p: { xs: 2, sm: 3 },
// //                 borderRadius: 3,
// //                 backgroundColor: "#F1FFFA",
// //                 color: "#4D3CC3",
// //                 width: "100%",
// //               }}
// //             >
// //               <Typography
// //                 variant="h3"
// //                 component="h1"
// //                 fontWeight="bold"
// //                 sx={{
// //                   background: "#4F46BA",
// //                   backgroundClip: "text",
// //                   WebkitBackgroundClip: "text",
// //                   WebkitTextFillColor: "transparent",
// //                 }}
// //               >
// //                 Hiring Analytics Dashboard
// //               </Typography>
// //             </Paper>

// //             <Paper
// //               elevation={0}
// //               sx={{
// //                 borderRadius: 3,
// //                 border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
// //                 boxShadow: theme.shadows[2],
// //                 overflow: "hidden",
// //                 backgroundColor: "#F1FFFA",
// //                 width: "100%",
// //               }}
// //             >
// //               <Tabs
// //                 value={tabValue}
// //                 onChange={handleTabChange}
// //                 indicatorColor="primary"
// //                 textColor="primary"
// //                 variant="standard"
// //                 centered
// //                 sx={{
// //                   "& .MuiTab-root": {
// //                     textTransform: "none",
// //                     fontWeight: 600,
// //                   },
// //                   "& .MuiTabs-indicator": {
// //                     height: 3,
// //                     borderRadius: "3px 3px 0 0",
// //                   },
// //                 }}
// //               >
// //                 <Tab
// //                   icon={<BarChart />}
// //                   label="OVERVIEW"
// //                   iconPosition="start"
// //                 />
// //                 <Tab icon={<Timeline />} label="TRENDS" iconPosition="start" />
// //                 <Tab
// //                   icon={<PieChart />}
// //                   label="DEMOGRAPHICS"
// //                   iconPosition="start"
// //                 />
// //                 <Tab
// //                   icon={<People />}
// //                   label="CANDIDATES"
// //                   iconPosition="start"
// //                 />
// //                 <Tab
// //                   icon={<History />}
// //                   label="RECENT ACTIVITY"
// //                   iconPosition="start"
// //                 />
// //               </Tabs>
// //             </Paper>

// //             <Box>
// //               <TabPanel value={tabValue} index={0}>
// //                 <OverviewTab loading={loading} data={overviewData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={1}>
// //                 <TrendsTab loading={loading} data={trendsData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={2}>
// //                 <DemographicsTab
// //                   loading={loading}
// //                   data={demographicsData}
// //                   skillChartRef={skillChartRef}
// //                   locationTableRef={locationTableRef}
// //                   timeRange={timeRange}
// //                   handleTimeRangeChange={handleTimeRangeChange}
// //                   jobFilter={jobFilter}
// //                   handleJobFilterChange={handleJobFilterChange}
// //                   filterOptions={filterOptions}
// //                   onExportClick={() => setIsExportModalOpen(true)}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={3}>
// //                 <CandidatesTab
// //                   loading={loading}
// //                   candidates={candidatesData.slice(
// //                     page * rowsPerPage,
// //                     page * rowsPerPage + rowsPerPage
// //                   )}
// //                   totalCandidates={candidatesData.length}
// //                   page={page}
// //                   rowsPerPage={rowsPerPage}
// //                   handleChangePage={handleChangePage}
// //                   handleChangeRowsPerPage={handleChangeRowsPerPage}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={4}>
// //                 <RecentActivityTab
// //                   loading={loading}
// //                   data={overviewData.recent_activity}
// //                 />
// //               </TabPanel>
// //             </Box>
// //           </Stack>
// //         </Container>
// //       </Box>
// //       <ExportReportDialog
// //         open={isExportModalOpen}
// //         onClose={() => setIsExportModalOpen(false)}
// //         candidatesData={candidatesData}
// //         demographicsData={demographicsData}
// //         overviewData={overviewData}
// //         skillChartRef={skillChartRef}
// //         locationTableRef={locationTableRef}
// //       />
// //     </Layout>
// //   );
// // }

// // export default EmployerAnalytics;

// // import { useState, useEffect, useRef, useMemo } from "react"
// // import {
// //   Box,
// //   Typography,
// //   Grid,
// //   Card,
// //   CardContent,
// //   Paper,
// //   Tabs,
// //   Tab,
// //   FormControl,
// //   Select,
// //   MenuItem,
// //   Button,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   ListItemAvatar,
// //   Avatar,
// //   Chip,
// //   ListItemIcon,
// //   LinearProgress,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Skeleton,
// //   TablePagination,
// //   Tooltip,
// //   Stack,
// //   Container,
// //   Fade,
// //   Grow,
// //   useTheme,
// //   alpha,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   RadioGroup,
// //   FormControlLabel,
// //   Radio,
// //   FormLabel,
// // } from "@mui/material"
// // import {
// //   TrendingUp,
// //   People,
// //   WorkOutline,
// //   School,
// //   BarChart,
// //   PieChart,
// //   Timeline,
// //   CloudDownload,
// //   Star,
// //   LocationOn,
// //   CheckCircle,
// //   HelpOutline,
// //   ArrowRightAlt,
// //   MonetizationOn,
// //   AccessTime,
// //   RateReview,
// //   History,
// //   ArrowDownward,
// // } from "@mui/icons-material"
// // import * as htmlToImage from "html-to-image"
// // import ReactApexChart from "react-apexcharts"
// // import Layout from "../common/Layout"
// // import apiClient from "../../context/apiClient"

// // const downloadFile = ({ data, fileName, fileType }) => {
// //   const blob = new Blob([data], { type: fileType })
// //   const a = document.createElement("a")
// //   a.download = fileName
// //   a.href = window.URL.createObjectURL(blob)
// //   const clickEvt = new MouseEvent("click", {
// //     view: window,
// //     bubbles: true,
// //     cancelable: true,
// //   })
// //   a.dispatchEvent(clickEvt)
// //   a.remove()
// // }

// // const convertToCSV = (data) => {
// //   if (!data || data.length === 0) return ""
// //   const headers = Object.keys(data[0])
// //   const csvRows = [headers.join(",")]
// //   for (const row of data) {
// //     const values = headers.map((header) => {
// //       const escaped = ("" + row[header]).replace(/"/g, '""')
// //       return `"${escaped}"`
// //     })
// //     csvRows.push(values.join(","))
// //   }
// //   return csvRows.join("\n")
// // }

// // const generateUniqueColors = (count) => {
// //   if (count === 0) return []
// //   const colors = []
// //   const hueStep = 360 / count
// //   for (let i = 0; i < count; i++) {
// //     const hue = i * hueStep
// //     colors.push(`hsl(${hue}, 70%, 50%)`)
// //   }
// //   return colors
// // }

// // const ExportReportDialog = ({
// //   open,
// //   onClose,
// //   candidatesData,
// //   demographicsData,
// //   overviewData,
// //   skillChartRef,
// //   locationTableRef,
// // }) => {
// //   const [reportType, setReportType] = useState("demographics_skills")
// //   const [format, setFormat] = useState("png")

// //   const handleDownload = async () => {
// //     let dataToExport = []
// //     let fileName = `${reportType}_report`
// //     const isImageFormat = format === "png"

// //     if (isImageFormat) {
// //       const elementToCapture = reportType === "demographics_skills" ? skillChartRef.current : locationTableRef.current
// //       if (!elementToCapture) {
// //         console.error("Target element for image capture not found.")
// //         return
// //       }
// //       try {
// //         const dataUrl = await htmlToImage.toPng(elementToCapture)
// //         const a = document.createElement("a")
// //         a.href = dataUrl
// //         a.download = `${reportType}_${new Date().toISOString().slice(0, 10)}.png`
// //         a.click()
// //       } catch (error) {
// //         console.error("Failed to capture component as image", error)
// //       }
// //     } else {
// //       switch (reportType) {
// //         case "candidates":
// //           dataToExport = candidatesData.map((c) => ({
// //             id: c.candidate_id,
// //             name: c.candidate_name,
// //             location: c.location,
// //             status: c.status,
// //             match_score: c.match_score,
// //             skills: c.skills.join("|"),
// //             experience: c.experience.map((e) => `${e.title} at ${e.company}`).join(" | "),
// //           }))
// //           break
// //         case "demographics_skills":
// //           dataToExport = demographicsData.skill_distribution
// //           fileName = "skill_distribution_report"
// //           break
// //         case "demographics_locations":
// //           dataToExport = demographicsData.candidate_locations
// //           fileName = "candidate_locations_report"
// //           break
// //         case "overview":
// //           dataToExport = [overviewData.summary_stats]
// //           break
// //         default:
// //           console.error("Invalid report type")
// //           return
// //       }

// //       if (format === "csv") {
// //         const csvData = convertToCSV(dataToExport)
// //         downloadFile({
// //           data: csvData,
// //           fileName: `${fileName}.csv`,
// //           fileType: "text/csv",
// //         })
// //       } else if (format === "json") {
// //         downloadFile({
// //           data: JSON.stringify(dataToExport, null, 2),
// //           fileName: `${fileName}.json`,
// //           fileType: "application/json",
// //         })
// //       }
// //     }
// //     onClose()
// //   }

// //   const isVisualReport = reportType === "demographics_skills" || reportType === "demographics_locations"

// //   return (
// //     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
// //       <DialogTitle fontWeight="bold">Export Report</DialogTitle>
// //       <DialogContent dividers>
// //         <Stack spacing={4}>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Report Type
// //             </FormLabel>
// //             <RadioGroup value={reportType} onChange={(e) => setReportType(e.target.value)}>
// //               <FormControlLabel value="demographics_skills" control={<Radio />} label="Skill Distribution" />
// //               <FormControlLabel value="demographics_locations" control={<Radio />} label="Candidate Locations" />
// //               <FormControlLabel value="candidates" control={<Radio />} label="Top Candidates (Data Only)" />
// //               <FormControlLabel value="overview" control={<Radio />} label="Hiring Stats Overview (Data Only)" />
// //             </RadioGroup>
// //           </FormControl>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Format
// //             </FormLabel>
// //             <RadioGroup row value={format} onChange={(e) => setFormat(e.target.value)}>
// //               <FormControlLabel value="png" control={<Radio />} label="Image (PNG)" disabled={!isVisualReport} />
// //               <FormControlLabel value="csv" control={<Radio />} label="CSV" />
// //               <FormControlLabel value="json" control={<Radio />} label="JSON" />
// //             </RadioGroup>
// //           </FormControl>
// //         </Stack>
// //       </DialogContent>
// //       <DialogActions sx={{ p: 2 }}>
// //         <Button onClick={onClose} color="inherit">
// //           Cancel
// //         </Button>
// //         <Button onClick={handleDownload} variant="contained" startIcon={<CloudDownload />}>
// //           Download
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   )
// // }

// // const cleanSkill = (skill) => {
// //   return skill.replace(/[\[\]"]/g, "")
// // }

// // const SkillDonutChart = ({ data, colors }) => {
// //   const theme = useTheme()
// //   const chartSeries = data.map((item) => item.count)
// //   const chartOptions = {
// //     chart: { type: "donut", background: "transparent" },
// //     plotOptions: {
// //       pie: {
// //         donut: {
// //           size: "70%",
// //           labels: {
// //             show: true,
// //             total: {
// //               show: true,
// //               label: "Total Skills",
// //               color: theme.palette.text.secondary,
// //               formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0),
// //             },
// //           },
// //         },
// //       },
// //     },
// //     dataLabels: { enabled: false },
// //     legend: { show: false },
// //     colors: colors,
// //     tooltip: { y: { formatter: (val) => `${val} candidates` } },
// //   }
// //   return <ReactApexChart options={chartOptions} series={chartSeries} type="donut" height={420} />
// // }

// // const SkillList = ({ data, colors }) => {
// //   return (
// //     <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 2 }}>
// //       <List>
// //         {data.map((item, index) => (
// //           <ListItem key={item.skill} disablePadding>
// //             <Stack direction="row" alignItems="center" spacing={2} sx={{ width: "100%", py: 0.5 }}>
// //               <Box
// //                 sx={{
// //                   width: 16,
// //                   height: 16,
// //                   borderRadius: "4px",
// //                   bgcolor: colors[index % colors.length],
// //                   flexShrink: 0,
// //                 }}
// //               />
// //               <ListItemText
// //                 primary={
// //                   <Typography variant="body2" color="text.primary" noWrap>
// //                     {cleanSkill(item.skill)}
// //                   </Typography>
// //                 }
// //               />
// //               <Typography variant="body2" color="text.secondary" fontWeight="bold">
// //                 {item.count}
// //               </Typography>
// //             </Stack>
// //           </ListItem>
// //         ))}
// //       </List>
// //     </Box>
// //   )
// // }

// // const ApplicationTrendChart = ({ data, height = 450 }) => {
// //   const theme = useTheme()

// //   if (!data || !data.datasets || !data.datasets[0] || !data.datasets[0].data || data.datasets[0].data.length === 0) {
// //     return (
// //       <Box
// //         sx={{
// //           height,
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           bgcolor: alpha(theme.palette.grey[100], 0.3),
// //           borderRadius: 2,
// //           border: `1px dashed ${theme.palette.grey[300]}`,
// //           m: 3,
// //         }}
// //       >
// //         <Typography variant="body2" color="text.secondary">
// //           No trend data available.
// //         </Typography>
// //       </Box>
// //     )
// //   }

// //   const chartSeries = [
// //     {
// //       name: "Applications",
// //       data: data.datasets[0].data,
// //     },
// //   ]

// //   const chartOptions = {
// //     chart: {
// //       type: "area",
// //       height: height,
// //       toolbar: {
// //         show: false,
// //       },
// //       zoom: {
// //         enabled: false,
// //       },
// //       background: "transparent",
// //     },
// //     colors: [theme.palette.primary.main],
// //     dataLabels: {
// //       enabled: false,
// //     },
// //     stroke: {
// //       curve: "smooth",
// //       width: 3,
// //       lineCap: "round",
// //     },
// //     fill: {
// //       type: "gradient",
// //       gradient: {
// //         shadeIntensity: 1,
// //         opacityFrom: 0.4,
// //         opacityTo: 0.1,
// //         stops: [0, 90, 100],
// //       },
// //     },
// //     grid: {
// //       show: true,
// //       borderColor: theme.palette.divider,
// //       strokeDashArray: 4,
// //       xaxis: {
// //         lines: {
// //           show: false,
// //         },
// //       },
// //       yaxis: {
// //         lines: {
// //           show: true,
// //         },
// //       },
// //     },
// //     xaxis: {
// //       categories: data.labels,
// //       axisBorder: {
// //         show: false,
// //       },
// //       axisTicks: {
// //         show: false,
// //       },
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //           fontWeight: 500,
// //         },
// //       },
// //     },
// //     yaxis: {
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //         },
// //         formatter: function (val) {
// //           return val.toFixed(0)
// //         },
// //       },
// //     },
// //     tooltip: {
// //       x: {
// //         format: "MMM yyyy",
// //       },
// //       y: {
// //         formatter: (val) => `${val} applications`,
// //       },
// //       theme: "light",
// //       marker: {
// //         show: true,
// //       },
// //     },
// //   }

// //   return <ReactApexChart options={chartOptions} series={chartSeries} type="area" height={height} />
// // }

// // function TabPanel(props) {
// //   const { children, value, index, ...other } = props
// //   return (
// //     <div
// //       role="tabpanel"
// //       hidden={value !== index}
// //       id={`analytics-tabpanel-${index}`}
// //       aria-labelledby={`analytics-tab-${index}`}
// //       {...other}
// //     >
// //       {value === index && (
// //         <Fade in={value === index} timeout={500}>
// //           <Box sx={{ pt: 4 }}>{children}</Box>
// //         </Fade>
// //       )}
// //     </div>
// //   )
// // }

// // const getStatusColor = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return "success"
// //     case "interviewed":
// //       return "primary"
// //     case "shortlisted":
// //       return "info"
// //     case "applied":
// //     case "matched":
// //       return "warning"
// //     default:
// //       return "default"
// //   }
// // }

// // const getStatusIcon = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return <CheckCircle />
// //     case "interviewed":
// //       return <People />
// //     case "shortlisted":
// //       return <Star />
// //     case "applied":
// //     case "matched":
// //       return <WorkOutline />
// //     default:
// //       return <HelpOutline />
// //   }
// // }

// // const StatCard = ({ title, value, icon, gradient, loading }) => {
// //   const theme = useTheme()
// //   if (loading) {
// //     return (
// //       <Card
// //         sx={{
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[1],
// //           height: "100%",
// //         }}
// //       >
// //         <CardContent sx={{ p: 3 }}>
// //           <Stack direction="row" justifyContent="space-between" alignItems="center">
// //             <Stack spacing={1}>
// //               <Skeleton variant="text" width="80%" height={20} />
// //               <Skeleton variant="text" width="50%" height={40} />
// //             </Stack>
// //             <Skeleton variant="circular" width={64} height={64} />
// //           </Stack>
// //         </CardContent>
// //       </Card>
// //     )
// //   }
// //   return (
// //     <Grow in timeout={300}>
// //       <Card
// //         sx={{
// //           background: gradient,
// //           color: "white",
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[8],
// //           height: "100%",
// //           transition: "all 0.3s ease",
// //           "&:hover": {
// //             transform: "translateY(-4px)",
// //             boxShadow: theme.shadows[12],
// //           },
// //         }}
// //       >
// //         <CardContent sx={{ p: 3 }}>
// //           <Stack direction="row" justifyContent="space-between" alignItems="center">
// //             <Stack spacing={1}>
// //               <Typography variant="subtitle2" sx={{ opacity: 0.9, fontWeight: 600 }}>
// //                 {title}
// //               </Typography>
// //               <Typography variant="h3" fontWeight="bold" sx={{ lineHeight: 1.2 }}>
// //                 {value}
// //               </Typography>
// //             </Stack>
// //             <Avatar
// //               sx={{
// //                 bgcolor: "rgba(255,255,255,0.2)",
// //                 width: 64,
// //                 height: 64,
// //                 backdropFilter: "blur(10px)",
// //               }}
// //             >
// //               {icon}
// //             </Avatar>
// //           </Stack>
// //         </CardContent>
// //       </Card>
// //     </Grow>
// //   )
// // }

// // const OverviewTab = ({ loading, data }) => {
// //   const theme = useTheme()

// //   const applicationTrendsData = {
// //     labels: data.application_trend?.map((d) => d.month) || [],
// //     datasets: [
// //       {
// //         label: "Applications",
// //         data: data.application_trend?.map((d) => d.application_count) || [],
// //         backgroundColor: theme.palette.primary.main,
// //       },
// //     ],
// //   }

// //   const statCards = [
// //     {
// //       title: "Total Applications",
// //       value: data.summary_stats?.total_applications || 0,
// //       icon: <WorkOutline sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
// //     },
// //     {
// //       title: "Total Interviews",
// //       value: data.summary_stats?.total_interviews || 0,
// //       icon: <People sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
// //     },
// //     {
// //       title: "Total Hires",
// //       value: data.summary_stats?.total_hires || 0,
// //       icon: <School sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
// //     },
// //     {
// //       title: "Acceptance Rate",
// //       value: data.summary_stats?.acceptance_rate || "0%",
// //       icon: <TrendingUp sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
// //     },
// //   ]

// //   return (
// //     <Stack spacing={4}>
// //       <Box
// //         sx={{
// //           display: "grid",
// //           gap: 3,
// //           gridTemplateColumns: {
// //             xs: "repeat(1, 1fr)",
// //             sm: "repeat(2, 1fr)",
// //             md: "repeat(4, 1fr)",
// //           },
// //         }}
// //       >
// //         {statCards.map((card, index) => (
// //           <StatCard {...card} loading={loading} key={index} />
// //         ))}
// //       </Box>

// //       <Card
// //         sx={{
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[4],
// //           width: "100%",
// //           backgroundColor: "#F1FFFA",
// //           transition: "all 0.3s ease",
// //           "&:hover": { boxShadow: theme.shadows[8] },
// //         }}
// //       >
// //         <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
// //           <Box sx={{ p: 3, pb: 0 }}>
// //             {loading ? (
// //               <Skeleton variant="text" width="60%" height={32} />
// //             ) : (
// //               <Typography variant="h6" fontWeight="bold" color="text.primary">
// //                 Application Trends
// //               </Typography>
// //             )}
// //           </Box>
// //           {loading ? (
// //             <Box sx={{ p: 3 }}>
// //               <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
// //             </Box>
// //           ) : (
// //             <ApplicationTrendChart data={applicationTrendsData} />
// //           )}
// //         </CardContent>
// //       </Card>
// //     </Stack>
// //   )
// // }

// // const RecentActivityTab = ({ loading, data }) => {
// //   const theme = useTheme()

// //   const getActivityIcon = (activityString) => {
// //     const lowerCaseActivity = activityString.toLowerCase()
// //     if (lowerCaseActivity.includes("hired")) return <CheckCircle />
// //     if (lowerCaseActivity.includes("interview")) return <People />
// //     if (lowerCaseActivity.includes("applied")) return <WorkOutline />
// //     return <RateReview />
// //   }

// //   return (
// //     <Card
// //       sx={{
// //         borderRadius: 3,
// //         boxShadow: theme.shadows[4],
// //         width: "100%",
// //         backgroundColor: "#F1FFFA",
// //         transition: "all 0.3s ease",
// //         "&:hover": { boxShadow: theme.shadows[8] },
// //       }}
// //     >
// //       <CardContent sx={{ p: 3 }}>
// //         {loading ? (
// //           <Skeleton variant="text" width="50%" height={32} />
// //         ) : (
// //           <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
// //             Recent Activity
// //           </Typography>
// //         )}
// //         <List sx={{ mt: 2 }}>
// //           {loading
// //             ? Array.from(new Array(5)).map((_, index) => (
// //                 <ListItem key={index} sx={{ px: 0, py: 1.5 }}>
// //                   <ListItemAvatar>
// //                     <Skeleton variant="circular" width={48} height={48} />
// //                   </ListItemAvatar>
// //                   <ListItemText primary={<Skeleton variant="text" width="80%" />} secondary={<Skeleton variant="text" width="60%" />} />
// //                 </ListItem>
// //               ))
// //             : data?.map((activity, index) => (
// //                 <ListItem
// //                   key={`${activity.candidate_name}-${index}`}
// //                   sx={{
// //                     px: 0,
// //                     py: 1.5,
// //                     borderRadius: 2,
// //                     transition: "all 0.2s ease",
// //                     "&:hover": {
// //                       bgcolor: alpha(theme.palette.primary.main, 0.04),
// //                     },
// //                   }}
// //                 >
// //                   <ListItemAvatar>
// //                     <Avatar
// //                       sx={{
// //                         bgcolor: alpha(theme.palette.primary.main, 0.1),
// //                         color: theme.palette.primary.main,
// //                         width: 48,
// //                         height: 48,
// //                         boxShadow: theme.shadows[2],
// //                       }}
// //                     >
// //                       {getActivityIcon(activity.activity)}
// //                     </Avatar>
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={
// //                       <Typography variant="body2" fontWeight="600" color="text.primary">
// //                         {activity.candidate_name}
// //                       </Typography>
// //                     }
// //                     secondary={
// //                       <Typography variant="caption" color="text.secondary">
// //                         {activity.activity} • {activity.time_ago}
// //                       </Typography>
// //                     }
// //                   />
// //                 </ListItem>
// //               ))}
// //         </List>
// //       </CardContent>
// //     </Card>
// //   )
// // }

// // const TrendsTab = ({ loading, data }) => {
// //   const theme = useTheme()

// //   const funnelData = [
// //     {
// //       icon: <WorkOutline color="primary" />,
// //       title: "Applications",
// //       value: data?.hiring_funnel?.applications || 0,
// //       color: theme.palette.primary.main,
// //     },
// //     {
// //       icon: <People color="secondary" />,
// //       title: "Interviews",
// //       value: data?.hiring_funnel?.interviews || 0,
// //       conversion: data?.hiring_funnel?.interview_conversion_rate || "0%",
// //       color: theme.palette.secondary.main,
// //     },
// //     {
// //       icon: <CheckCircle color="success" />,
// //       title: "Hires",
// //       value: data?.hiring_funnel?.hires || 0,
// //       conversion: data?.hiring_funnel?.hire_conversion_rate || "0%",
// //       color: theme.palette.success.main,
// //     },
// //   ]

// //   const kpiData = [
// //     {
// //       icon: <AccessTime />,
// //       title: "Average Time to Hire",
// //       value: data?.key_performance_metrics?.average_time_to_hire || "N/A",
// //       color: theme.palette.primary,
// //     },
// //     {
// //       icon: <MonetizationOn />,
// //       title: "Cost Per Hire",
// //       value: data?.key_performance_metrics?.cost_per_hire || "N/A",
// //       color: theme.palette.success,
// //     },
// //     {
// //       icon: <RateReview />,
// //       title: "Offer Acceptance Rate",
// //       value: data?.key_performance_metrics?.offer_acceptance_rate || "N/A",
// //       color: theme.palette.secondary,
// //     },
// //   ]

// //   return (
// //     <Grid container spacing={4}>
// //       <Grid item xs={12} lg={5}>
// //         <Card
// //           sx={{
// //             borderRadius: 3,
// //             boxShadow: theme.shadows[4],
// //             height: "100%",
// //             width: "520px",
// //             backgroundColor: "#F1FFFA",
// //             p: 2,
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent>
// //             <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
// //               Hiring Funnel
// //             </Typography>
// //             {loading ? (
// //               <Stack spacing={4} sx={{ mt: 3 }}>
// //                 <Skeleton variant="rectangular" height={60} sx={{ borderRadius: 2 }} />
// //                 <Skeleton variant="rectangular" height={60} sx={{ borderRadius: 2 }} />
// //                 <Skeleton variant="rectangular" height={60} sx={{ borderRadius: 2 }} />
// //               </Stack>
// //             ) : (
// //               <Stack spacing={2} sx={{ mt: 4 }}>
// //                 {funnelData.map((step, index) => (
// //                   <Grow in timeout={500 + index * 200} key={step.title}>
// //                     <Box>
// //                       <Paper
// //                         variant="outlined"
// //                         sx={{
// //                           p: 2,
// //                           display: "flex",
// //                           alignItems: "center",
// //                           borderRadius: 2,
// //                           borderColor: alpha(step.color, 0.3),
// //                           background: `linear-gradient(to right, ${alpha(step.color, 0.1)}, transparent)`,
// //                         }}
// //                       >
// //                         <Avatar sx={{ bgcolor: alpha(step.color, 0.15), color: step.color, mr: 2 }}>
// //                           {step.icon}
// //                         </Avatar>
// //                         <Box sx={{ flexGrow: 1 }}>
// //                           <Typography variant="body2" color="text.secondary">
// //                             {step.title}
// //                           </Typography>
// //                           <Typography variant="h5" fontWeight="bold">
// //                             {step.value}
// //                           </Typography>
// //                         </Box>
// //                         {step.conversion && (
// //                           <Box sx={{ textAlign: "right" }}>
// //                             <Typography variant="caption" color="text.secondary">
// //                               Conversion
// //                             </Typography>
// //                             <Typography variant="body1" fontWeight="bold" color={step.color}>
// //                               {step.conversion}
// //                             </Typography>
// //                           </Box>
// //                         )}
// //                       </Paper>
// //                       {index < funnelData.length - 1 && (
// //                         <Box display="flex" justifyContent="center" my={1}>
// //                           <ArrowDownward sx={{ color: "grey.400" }} />
// //                         </Box>
// //                       )}
// //                     </Box>
// //                   </Grow>
// //                 ))}
// //               </Stack>
// //             )}
// //           </CardContent>
// //         </Card>
// //       </Grid>

// //       <Grid item xs={12} lg={7}>
// //         <Card
// //           sx={{
// //             borderRadius: 3,
// //             boxShadow: theme.shadows[4],
// //             height: "100%",
// //             backgroundColor: "#F1FFFA",
// //             p: 2,
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent>
// //             <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
// //               Key Performance Metrics
// //             </Typography>
// //             <Grid container spacing={3} sx={{ mt: 2, height: "100%" }}>
// //               {loading
// //                 ? Array.from(new Array(3)).map((_, index) => (
// //                     <Grid item xs={12} sm={4} key={index}>
// //                       <Skeleton variant="rectangular" height={150} sx={{ borderRadius: 2 }} />
// //                     </Grid>
// //                   ))
// //                 : kpiData.map((kpi, index) => (
// //                     <Grid item xs={12} sm={4} key={kpi.title}>
// //                       <Grow in timeout={500 + index * 200}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{
// //                             p: 3,
// //                             borderRadius: 2,
// //                             textAlign: "center",
// //                             height: "100%",
// //                             display: "flex",
// //                             flexDirection: "column",
// //                             justifyContent: "center",
// //                             borderColor: alpha(kpi.color.main, 0.3),
// //                             backgroundColor: alpha(kpi.color.main, 0.05),
// //                           }}
// //                         >
// //                           <Avatar
// //                             sx={{
// //                               bgcolor: alpha(kpi.color.main, 0.1),
// //                               color: kpi.color.main,
// //                               width: 56,
// //                               height: 56,
// //                               mx: "auto",
// //                               mb: 1.5,
// //                             }}
// //                           >
// //                             {kpi.icon}
// //                           </Avatar>
// //                           <Typography variant="body2" fontWeight="600" color="text.primary">
// //                             {kpi.title}
// //                           </Typography>
// //                           <Typography variant="h4" fontWeight="bold" color="text.primary" sx={{ mt: 1 }}>
// //                             {kpi.value}
// //                           </Typography>
// //                         </Paper>
// //                       </Grow>
// //                     </Grid>
// //                   ))}
// //             </Grid>
// //           </CardContent>
// //         </Card>
// //       </Grid>
// //     </Grid>
// //   )
// // }

// // const DemographicsTab = ({
// //   loading,
// //   data,
// //   skillChartRef,
// //   locationTableRef,
// //   timeRange,
// //   handleTimeRangeChange,
// //   jobFilter,
// //   handleJobFilterChange,
// //   filterOptions,
// //   onExportClick,
// // }) => {
// //   const theme = useTheme()
// //   const colorPalette = useMemo(() => {
// //     if (!data || !data.skill_distribution) {
// //       return []
// //     }
// //     return generateUniqueColors(data.skill_distribution.length)
// //   }, [data.skill_distribution])

// //   return (
// //     <Stack spacing={4}>
// //       <Paper
// //         elevation={0}
// //         sx={{
// //           p: 2,
// //           borderRadius: 3,
// //           backgroundColor: "#F1FFFA",
// //           border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
// //         }}
// //       >
// //         <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center" justifyContent="flex-end">
// //           <FormControl size="small">
// //             <Select
// //               value={timeRange}
// //               onChange={handleTimeRangeChange}
// //               sx={{
// //                 borderRadius: 2,
// //                 backgroundColor: "#F1FFFA",
// //                 minWidth: 140,
// //               }}
// //             >
// //               <MenuItem value="last30days">Last Month</MenuItem>
// //               <MenuItem value="last3months">Last 3 Months</MenuItem>
// //               <MenuItem value="last6months">Last 6 Months</MenuItem>
// //               <MenuItem value="lastyear">Last Year</MenuItem>
// //             </Select>
// //           </FormControl>
// //           <FormControl size="small">
// //             <Select
// //               value={jobFilter}
// //               onChange={handleJobFilterChange}
// //               sx={{
// //                 borderRadius: 2,
// //                 backgroundColor: "#F1FFFA",
// //                 minWidth: 180,
// //               }}
// //             >
// //               {filterOptions.job_roles.map((job) => (
// //                 <MenuItem key={job || "all-jobs"} value={job === "All Jobs" || !job ? "all" : job}>
// //                   {job || "All Jobs"}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <Button
// //             variant="outlined"
// //             startIcon={<CloudDownload />}
// //             size="medium"
// //             onClick={onExportClick}
// //             sx={{
// //               borderRadius: 2,
// //               textTransform: "none",
// //               fontWeight: 600,
// //             }}
// //           >
// //             Export Report
// //           </Button>
// //         </Stack>
// //       </Paper>
// //       <Grid container spacing={4}>
// //         <Grid item xs={12} lg={8}>
// //           <Card
// //             ref={skillChartRef}
// //             sx={{
// //               borderRadius: 3,
// //               boxShadow: theme.shadows[4],
// //               height: "100%",
// //               backgroundColor: "#F1FFFA",
// //             }}
// //           >
// //             <CardContent sx={{ p: 3 }}>
// //               <Typography variant="h6" gutterBottom fontWeight="bold" color="text.primary">
// //                 Skill Distribution
// //               </Typography>
// //               {loading ? (
// //                 <Skeleton variant="rectangular" height={450} />
// //               ) : (
// //                 <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
// //                   <Grid item xs={12} sm={8}>
// //                     <SkillDonutChart data={data.skill_distribution} colors={colorPalette} />
// //                   </Grid>
// //                   <Grid item xs={12} sm={4}>
// //                     <SkillList data={data.skill_distribution} colors={colorPalette} />
// //                   </Grid>
// //                 </Grid>
// //               )}
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} lg={4}>
// //           <Card
// //             ref={locationTableRef}
// //             sx={{
// //               borderRadius: 3,
// //               boxShadow: theme.shadows[4],
// //               height: "100%",
// //               width: "550px",
// //               backgroundColor: "#F1FFFA",
// //             }}
// //           >
// //             <CardContent sx={{ p: 4 }}>
// //               <Typography variant="h6" gutterBottom fontWeight="bold" color="text.primary">
// //                 Candidate Locations
// //               </Typography>
// //               <TableContainer sx={{ mt: 3 }}>
// //                 <Table>
// //                   <TableHead>
// //                     <TableRow>
// //                       <TableCell>
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Location
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell align="right">
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Candidates
// //                         </Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   </TableHead>
// //                   <TableBody>
// //                     {loading
// //                       ? Array.from(new Array(5)).map((_, index) => (
// //                           <TableRow key={index}>
// //                             <TableCell>
// //                               <Skeleton variant="text" />
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Skeleton variant="rounded" width={40} height={24} />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))
// //                       : data.candidate_locations.map((loc) => (
// //                           <TableRow
// //                             key={loc.location}
// //                             sx={{ "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.04) } }}
// //                           >
// //                             <TableCell component="th" scope="row">
// //                               <Typography variant="body2" fontWeight="500">
// //                                 {loc.location}
// //                               </Typography>
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Chip label={loc.candidates} size="small" color="primary" variant="outlined" />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))}
// //                   </TableBody>
// //                 </Table>
// //               </TableContainer>
// //             </CardContent>
// //           </Card>
// //         </Grid>
// //       </Grid>
// //     </Stack>
// //   )
// // }

// // const CandidatesTab = ({
// //   loading,
// //   candidates,
// //   totalCandidates,
// //   page,
// //   rowsPerPage,
// //   handleChangePage,
// //   handleChangeRowsPerPage,
// // }) => {
// //   const theme = useTheme()
// //   const getExperienceTooltip = (experienceArray) => {
// //     if (!Array.isArray(experienceArray) || experienceArray.length === 0) {
// //       return "No experience details available."
// //     }
// //     return experienceArray
// //       .map((exp) => `${exp.title || "N/A"} at ${exp.company || "N/A"} (${exp.duration || "N/A"})`)
// //       .join("\n")
// //   }

// //   return (
// //     <Card
// //       sx={{
// //         borderRadius: 3,
// //         boxShadow: theme.shadows[4],
// //         backgroundColor: "#F1FFFA",
// //       }}
// //     >
// //       <CardContent sx={{ p: 4 }}>
// //         <Typography variant="h6" gutterBottom fontWeight="bold" color="text.primary">
// //           Top Candidates
// //         </Typography>
// //         <TableContainer sx={{ mt: 3 }}>
// //           <Table sx={{ minWidth: 650 }} aria-label="top candidates table">
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Candidate
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Experience
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Top Skills
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Match Score
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Status
// //                   </Typography>
// //                 </TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {loading
// //                 ? Array.from(new Array(rowsPerPage)).map((_, index) => (
// //                     <TableRow key={index}>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton variant="circular" width={48} height={48} />
// //                           <Stack spacing={0.5}>
// //                             <Skeleton variant="text" width={120} />
// //                             <Skeleton variant="text" width={100} />
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton variant="text" width={100} />
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" spacing={0.5} flexWrap="wrap">
// //                           <Skeleton variant="rounded" width={60} height={24} />
// //                           <Skeleton variant="rounded" width={70} height={24} />
// //                           <Skeleton variant="rounded" width={50} height={24} />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton variant="rectangular" width={100} height={8} sx={{ borderRadius: 1 }} />
// //                           <Skeleton variant="text" width={30} />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton variant="rounded" width={90} height={28} />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))
// //                 : candidates.map((candidate) => (
// //                     <TableRow
// //                       key={candidate.candidate_id}
// //                       hover
// //                       sx={{ "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.04) } }}
// //                     >
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Avatar src={candidate.avatar} sx={{ width: 48, height: 48 }} />
// //                           <Stack>
// //                             <Typography variant="body2" fontWeight="600">
// //                               {candidate.candidate_name}
// //                             </Typography>
// //                             <Stack direction="row" alignItems="center" spacing={0.5}>
// //                               <LocationOn sx={{ fontSize: 16, color: "text.secondary" }} />
// //                               <Typography variant="caption" color="text.secondary">
// //                                 {candidate.location}
// //                               </Typography>
// //                             </Stack>
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={
// //                             <div style={{ whiteSpace: "pre-line" }}>{getExperienceTooltip(candidate.experience)}</div>
// //                           }
// //                           arrow
// //                         >
// //                           <Typography variant="body2" sx={{ cursor: "pointer" }}>
// //                             {(candidate.experience && candidate.experience[0]?.duration) || "N/A"}
// //                           </Typography>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={Array.isArray(candidate.skills) ? candidate.skills.join(", ") : ""}
// //                           arrow
// //                           placement="top"
// //                         >
// //                           <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ cursor: "pointer" }}>
// //                             {Array.isArray(candidate.skills) &&
// //                               candidate.skills.slice(0, 3).map((skill) => (
// //                                 <Chip key={skill} label={skill} size="small" variant="outlined" />
// //                               ))}
// //                           </Stack>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <LinearProgress
// //                             variant="determinate"
// //                             value={candidate.match_score}
// //                             sx={{
// //                               width: 100,
// //                               height: 8,
// //                               borderRadius: 1,
// //                             }}
// //                           />
// //                           <Typography variant="body2" color="text.secondary" fontWeight="500">
// //                             {candidate.match_score}%
// //                           </Typography>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Chip
// //                           icon={getStatusIcon(candidate.status)}
// //                           label={candidate.status.charAt(0).toUpperCase() + candidate.status.slice(1)}
// //                           color={getStatusColor(candidate.status)}
// //                           size="small"
// //                           variant="filled"
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //         <TablePagination
// //           rowsPerPageOptions={[5, 10, 25]}
// //           component="div"
// //           count={totalCandidates}
// //           rowsPerPage={rowsPerPage}
// //           page={page}
// //           onPageChange={handleChangePage}
// //           onRowsPerPageChange={handleChangeRowsPerPage}
// //         />
// //       </CardContent>
// //     </Card>
// //   )
// // }

// // function EmployerAnalytics() {
// //   const theme = useTheme()
// //   const [tabValue, setTabValue] = useState(0)
// //   const [timeRange, setTimeRange] = useState("last30days")
// //   const [jobFilter, setJobFilter] = useState("all")
// //   const [loading, setLoading] = useState(true)
// //   const [candidatesData, setCandidatesData] = useState([])
// //   const [overviewData, setOverviewData] = useState({
// //     summary_stats: { total_applications: 0, total_interviews: 0, total_hires: 0, acceptance_rate: "0%" },
// //     application_trend: [],
// //     recent_activity: [],
// //   })
// //   const [demographicsData, setDemographicsData] = useState({
// //     skill_distribution: [],
// //     candidate_locations: [],
// //   })
// //   const [trendsData, setTrendsData] = useState(null)
// //   const [filterOptions, setFilterOptions] = useState({
// //     job_roles: ["All Jobs"],
// //     time_ranges: ["Last Month", "Last 3 Months", "Last 6 Months", "Last Year"],
// //   })
// //   const [page, setPage] = useState(0)
// //   const [rowsPerPage, setRowsPerPage] = useState(5)
// //   const [isExportModalOpen, setIsExportModalOpen] = useState(false)
// //   const skillChartRef = useRef(null)
// //   const locationTableRef = useRef(null)

// //   const safeJsonParse = (str, fallback = []) => {
// //     if (typeof str !== "string") return fallback
// //     try {
// //       return JSON.parse(str)
// //     } catch (e) {
// //       return fallback
// //     }
// //   }

// //   useEffect(() => {
// //     const fetchInitialData = async () => {
// //       setLoading(true)
// //       try {
// //         const [candidatesResponse, overviewResponse, trendsResponse] = await Promise.all([
// //           apiClient.get("/hiring-analytics/top-matching-candidates/"),
// //           apiClient.get("/hiring-analytics/combined-dashboard/"),
// //           apiClient.get("/employer-analytics/trends"),
// //         ])
// //         const mappedCandidates = candidatesResponse.data.map((apiCandidate) => ({
// //           candidate_id: apiCandidate.candidate_id,
// //           candidate_name: apiCandidate.candidate_name,
// //           skills: apiCandidate.skills || [],
// //           match_score: apiCandidate.match_score,
// //           avatar: `/placeholder.svg?height=40&width=40`,
// //           experience: safeJsonParse(apiCandidate.experience, []),
// //           location: apiCandidate.location || "N/A",
// //           status: apiCandidate.status ? apiCandidate.status.toLowerCase() : "matched",
// //         }))

// //         setCandidatesData(mappedCandidates)
// //         setOverviewData(overviewResponse.data)
// //         setTrendsData(trendsResponse.data)
// //       } catch (error) {
// //         console.error("Failed to fetch initial data:", error)
// //       } finally {
// //         setLoading(false)
// //       }
// //     }
// //     fetchInitialData()
// //   }, [])

// //   useEffect(() => {
// //     const fetchDemographicsData = async () => {
// //       setLoading(true)
// //       let url = "/demographics/"
// //       if (jobFilter !== "all") {
// //         url = `/demographics/job/${encodeURIComponent(jobFilter)}/`
// //       } else if (timeRange !== "all") {
// //         url = `/demographics/time/${timeRange}/`
// //       }

// //       try {
// //         const response = await apiClient.get(url)
// //         setDemographicsData(response.data)
// //         if (response.data.filter_options) {
// //           setFilterOptions(response.data.filter_options)
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch demographics data:", error)
// //       } finally {
// //         setLoading(false)
// //       }
// //     }

// //     fetchDemographicsData()
// //   }, [jobFilter, timeRange])

// //   const handleTabChange = (event, newValue) => setTabValue(newValue)
// //   const handleTimeRangeChange = (event) => {
// //     setTimeRange(event.target.value)
// //     setJobFilter("all")
// //   }
// //   const handleJobFilterChange = (event) => {
// //     setJobFilter(event.target.value)
// //     setTimeRange("all")
// //   }
// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage)
// //   }
// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10))
// //     setPage(0)
// //   }

// //   return (
// //     <Layout title="Hiring Analytics">
// //       <Box sx={{ bgcolor: "#f8fafc", minHeight: "100vh" }}>
// //         <Container maxWidth="xl" sx={{ py: 4 }}>
// //           <Stack spacing={4}>
// //             <Paper
// //               sx={{
// //                 p: { xs: 2, sm: 3 },
// //                 borderRadius: 3,
// //                 backgroundColor: "#F1FFFA",
// //                 color: "#4D3CC3",
// //                 width: "100%",
// //               }}
// //             >
// //               <Typography
// //                 variant="h3"
// //                 component="h1"
// //                 fontWeight="bold"
// //                 sx={{
// //                   background: "#4F46BA",
// //                   backgroundClip: "text",
// //                   WebkitBackgroundClip: "text",
// //                   WebkitTextFillColor: "transparent",
// //                 }}
// //               >
// //                 Hiring Analytics Dashboard
// //               </Typography>
// //             </Paper>

// //             <Paper
// //               elevation={0}
// //               sx={{
// //                 borderRadius: 3,
// //                 border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
// //                 boxShadow: theme.shadows[2],
// //                 overflow: "hidden",
// //                 backgroundColor: "#F1FFFA",
// //                 width: "100%",
// //               }}
// //             >
// //               <Tabs
// //                 value={tabValue}
// //                 onChange={handleTabChange}
// //                 indicatorColor="primary"
// //                 textColor="primary"
// //                 variant="standard"
// //                 centered
// //                 sx={{
// //                   "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
// //                   "& .MuiTabs-indicator": { height: 3, borderRadius: "3px 3px 0 0" },
// //                 }}
// //               >
// //                 <Tab icon={<BarChart />} label="OVERVIEW" iconPosition="start" />
// //                 <Tab icon={<Timeline />} label="TRENDS" iconPosition="start" />
// //                 <Tab icon={<PieChart />} label="DEMOGRAPHICS" iconPosition="start" />
// //                 <Tab icon={<People />} label="CANDIDATES" iconPosition="start" />
// //                 <Tab icon={<History />} label="RECENT ACTIVITY" iconPosition="start" />
// //               </Tabs>
// //             </Paper>

// //             <Box>
// //               <TabPanel value={tabValue} index={0}>
// //                 <OverviewTab loading={loading} data={overviewData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={1}>
// //                 <TrendsTab loading={loading} data={trendsData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={2}>
// //                 <DemographicsTab
// //                   loading={loading}
// //                   data={demographicsData}
// //                   skillChartRef={skillChartRef}
// //                   locationTableRef={locationTableRef}
// //                   timeRange={timeRange}
// //                   handleTimeRangeChange={handleTimeRangeChange}
// //                   jobFilter={jobFilter}
// //                   handleJobFilterChange={handleJobFilterChange}
// //                   filterOptions={filterOptions}
// //                   onExportClick={() => setIsExportModalOpen(true)}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={3}>
// //                 <CandidatesTab
// //                   loading={loading}
// //                   candidates={candidatesData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
// //                   totalCandidates={candidatesData.length}
// //                   page={page}
// //                   rowsPerPage={rowsPerPage}
// //                   handleChangePage={handleChangePage}
// //                   handleChangeRowsPerPage={handleChangeRowsPerPage}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={4}>
// //                 <RecentActivityTab loading={loading} data={overviewData.recent_activity} />
// //               </TabPanel>
// //             </Box>
// //           </Stack>
// //         </Container>
// //       </Box>
// //       <ExportReportDialog
// //         open={isExportModalOpen}
// //         onClose={() => setIsExportModalOpen(false)}
// //         candidatesData={candidatesData}
// //         demographicsData={demographicsData}
// //         overviewData={overviewData}
// //         skillChartRef={skillChartRef}
// //         locationTableRef={locationTableRef}
// //       />
// //     </Layout>
// //   )
// // }

// // export default EmployerAnalytics

// // import { useState, useEffect, useRef, useMemo } from "react"
// // import {
// //   Box,
// //   Typography,
// //   Grid,
// //   Card,
// //   CardContent,
// //   Paper,
// //   Tabs,
// //   Tab,
// //   FormControl,
// //   Select,
// //   MenuItem,
// //   Button,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   ListItemAvatar,
// //   Avatar,
// //   Chip,
// //   ListItemIcon,
// //   LinearProgress,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Skeleton,
// //   TablePagination,
// //   Tooltip,
// //   Stack,
// //   Container,
// //   Fade,
// //   Grow,
// //   useTheme,
// //   alpha,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   RadioGroup,
// //   FormControlLabel,
// //   Radio,
// //   FormLabel,
// // } from "@mui/material"
// // import {
// //   TrendingUp,
// //   People,
// //   WorkOutline,
// //   School,
// //   BarChart,
// //   PieChart,
// //   Timeline,
// //   CloudDownload,
// //   Star,
// //   LocationOn,
// //   CheckCircle,
// //   HelpOutline,
// //   ArrowRightAlt,
// //   MonetizationOn,
// //   AccessTime,
// //   RateReview,
// //   History,
// //   ArrowDownward, // Added for the new Trends tab UI
// // } from "@mui/icons-material"
// // import * as htmlToImage from "html-to-image"
// // import ReactApexChart from "react-apexcharts"
// // import Layout from "../common/Layout"
// // import apiClient from "../../context/apiClient"

// // const downloadFile = ({ data, fileName, fileType }) => {
// //   const blob = new Blob([data], { type: fileType })
// //   const a = document.createElement("a")
// //   a.download = fileName
// //   a.href = window.URL.createObjectURL(blob)
// //   const clickEvt = new MouseEvent("click", {
// //     view: window,
// //     bubbles: true,
// //     cancelable: true,
// //   })
// //   a.dispatchEvent(clickEvt)
// //   a.remove()
// // }

// // const convertToCSV = (data) => {
// //   if (!data || data.length === 0) return ""
// //   const headers = Object.keys(data[0])
// //   const csvRows = [headers.join(",")]
// //   for (const row of data) {
// //     const values = headers.map((header) => {
// //       const escaped = ("" + row[header]).replace(/"/g, '""')
// //       return `"${escaped}"`
// //     })
// //     csvRows.push(values.join(","))
// //   }
// //   return csvRows.join("\n")
// // }

// // const generateUniqueColors = (count) => {
// //   if (count === 0) return []
// //   const colors = []
// //   const hueStep = 360 / count
// //   for (let i = 0; i < count; i++) {
// //     const hue = i * hueStep
// //     colors.push(`hsl(${hue}, 70%, 50%)`)
// //   }
// //   return colors
// // }

// // const ExportReportDialog = ({
// //   open,
// //   onClose,
// //   candidatesData,
// //   demographicsData,
// //   overviewData,
// //   skillChartRef,
// //   locationTableRef,
// // }) => {
// //   const [reportType, setReportType] = useState("demographics_skills")
// //   const [format, setFormat] = useState("png")

// //   const handleDownload = async () => {
// //     let dataToExport = []
// //     let fileName = `${reportType}_report`
// //     const isImageFormat = format === "png"

// //     if (isImageFormat) {
// //       const elementToCapture = reportType === "demographics_skills" ? skillChartRef.current : locationTableRef.current
// //       if (!elementToCapture) {
// //         console.error("Target element for image capture not found.")
// //         return
// //       }
// //       try {
// //         const dataUrl = await htmlToImage.toPng(elementToCapture)
// //         const a = document.createElement("a")
// //         a.href = dataUrl
// //         a.download = `${reportType}_${new Date().toISOString().slice(0, 10)}.png`
// //         a.click()
// //       } catch (error) {
// //         console.error("Failed to capture component as image", error)
// //       }
// //     } else {
// //       switch (reportType) {
// //         case "candidates":
// //           dataToExport = candidatesData.map((c) => ({
// //             id: c.candidate_id,
// //             name: c.candidate_name,
// //             location: c.location,
// //             status: c.status,
// //             match_score: c.match_score,
// //             skills: c.skills.join("|"),
// //             experience: c.experience.map((e) => `${e.title} at ${e.company}`).join(" | "),
// //           }))
// //           break
// //         case "demographics_skills":
// //           dataToExport = demographicsData.skill_distribution
// //           fileName = "skill_distribution_report"
// //           break
// //         case "demographics_locations":
// //           dataToExport = demographicsData.candidate_locations
// //           fileName = "candidate_locations_report"
// //           break
// //         case "overview":
// //           dataToExport = [overviewData.summary_stats]
// //           break
// //         default:
// //           console.error("Invalid report type")
// //           return
// //       }

// //       if (format === "csv") {
// //         const csvData = convertToCSV(dataToExport)
// //         downloadFile({
// //           data: csvData,
// //           fileName: `${fileName}.csv`,
// //           fileType: "text/csv",
// //         })
// //       } else if (format === "json") {
// //         downloadFile({
// //           data: JSON.stringify(dataToExport, null, 2),
// //           fileName: `${fileName}.json`,
// //           fileType: "application/json",
// //         })
// //       }
// //     }
// //     onClose()
// //   }

// //   const isVisualReport = reportType === "demographics_skills" || reportType === "demographics_locations"

// //   return (
// //     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
// //       <DialogTitle fontWeight="bold">Export Report</DialogTitle>
// //       <DialogContent dividers>
// //         <Stack spacing={4}>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Report Type
// //             </FormLabel>
// //             <RadioGroup value={reportType} onChange={(e) => setReportType(e.target.value)}>
// //               <FormControlLabel value="demographics_skills" control={<Radio />} label="Skill Distribution" />
// //               <FormControlLabel value="demographics_locations" control={<Radio />} label="Candidate Locations" />
// //               <FormControlLabel value="candidates" control={<Radio />} label="Top Candidates (Data Only)" />
// //               <FormControlLabel value="overview" control={<Radio />} label="Hiring Stats Overview (Data Only)" />
// //             </RadioGroup>
// //           </FormControl>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Format
// //             </FormLabel>
// //             <RadioGroup row value={format} onChange={(e) => setFormat(e.target.value)}>
// //               <FormControlLabel value="png" control={<Radio />} label="Image (PNG)" disabled={!isVisualReport} />
// //               <FormControlLabel value="csv" control={<Radio />} label="CSV" />
// //               <FormControlLabel value="json" control={<Radio />} label="JSON" />
// //             </RadioGroup>
// //           </FormControl>
// //         </Stack>
// //       </DialogContent>
// //       <DialogActions sx={{ p: 2 }}>
// //         <Button onClick={onClose} color="inherit">
// //           Cancel
// //         </Button>
// //         <Button onClick={handleDownload} variant="contained" startIcon={<CloudDownload />}>
// //           Download
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   )
// // }

// // const cleanSkill = (skill) => {
// //   return skill.replace(/[\[\]"]/g, "")
// // }

// // const SkillDonutChart = ({ data, colors }) => {
// //   const theme = useTheme()
// //   const chartSeries = data.map((item) => item.count)
// //   const chartOptions = {
// //     chart: { type: "donut", background: "transparent" },
// //     plotOptions: {
// //       pie: {
// //         donut: {
// //           size: "70%",
// //           labels: {
// //             show: true,
// //             total: {
// //               show: true,
// //               label: "Total Skills",
// //               color: theme.palette.text.secondary,
// //               formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0),
// //             },
// //           },
// //         },
// //       },
// //     },
// //     dataLabels: { enabled: false },
// //     legend: { show: false },
// //     colors: colors,
// //     tooltip: { y: { formatter: (val) => `${val} candidates` } },
// //   }
// //   return <ReactApexChart options={chartOptions} series={chartSeries} type="donut" height={420} />
// // }

// // const SkillList = ({ data, colors }) => {
// //   return (
// //     <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 2 }}>
// //       <List>
// //         {data.map((item, index) => (
// //           <ListItem key={item.skill} disablePadding>
// //             <Stack direction="row" alignItems="center" spacing={2} sx={{ width: "100%", py: 0.5 }}>
// //               <Box
// //                 sx={{
// //                   width: 16,
// //                   height: 16,
// //                   borderRadius: "4px",
// //                   bgcolor: colors[index % colors.length],
// //                   flexShrink: 0,
// //                 }}
// //               />
// //               <ListItemText
// //                 primary={
// //                   <Typography variant="body2" color="text.primary" noWrap>
// //                     {cleanSkill(item.skill)}
// //                   </Typography>
// //                 }
// //               />
// //               <Typography variant="body2" color="text.secondary" fontWeight="bold">
// //                 {item.count}
// //               </Typography>
// //             </Stack>
// //           </ListItem>
// //         ))}
// //       </List>
// //     </Box>
// //   )
// // }

// // const ApplicationTrendChart = ({ data, height = 450 }) => {
// //   const theme = useTheme()

// //   if (!data || !data.datasets || !data.datasets[0] || !data.datasets[0].data || data.datasets[0].data.length === 0) {
// //     return (
// //       <Box
// //         sx={{
// //           height,
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           bgcolor: alpha(theme.palette.grey[100], 0.3),
// //           borderRadius: 2,
// //           border: `1px dashed ${theme.palette.grey[300]}`,
// //           m: 3,
// //         }}
// //       >
// //         <Typography variant="body2" color="text.secondary">
// //           No trend data available.
// //         </Typography>
// //       </Box>
// //     )
// //   }

// //   const chartSeries = [
// //     {
// //       name: "Applications",
// //       data: data.datasets[0].data,
// //     },
// //   ]

// //   const chartOptions = {
// //     chart: {
// //       type: "area",
// //       height: height,
// //       toolbar: {
// //         show: false,
// //       },
// //       zoom: {
// //         enabled: false,
// //       },
// //       background: "transparent",
// //     },
// //     colors: [theme.palette.primary.main],
// //     dataLabels: {
// //       enabled: false,
// //     },
// //     stroke: {
// //       curve: "smooth",
// //       width: 3,
// //       lineCap: "round",
// //     },
// //     fill: {
// //       type: "gradient",
// //       gradient: {
// //         shadeIntensity: 1,
// //         opacityFrom: 0.4,
// //         opacityTo: 0.1,
// //         stops: [0, 90, 100],
// //       },
// //     },
// //     grid: {
// //       show: true,
// //       borderColor: theme.palette.divider,
// //       strokeDashArray: 4,
// //       xaxis: {
// //         lines: {
// //           show: false,
// //         },
// //       },
// //       yaxis: {
// //         lines: {
// //           show: true,
// //         },
// //       },
// //     },
// //     xaxis: {
// //       categories: data.labels,
// //       axisBorder: {
// //         show: false,
// //       },
// //       axisTicks: {
// //         show: false,
// //       },
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //           fontWeight: 500,
// //         },
// //       },
// //     },
// //     yaxis: {
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //         },
// //         formatter: function (val) {
// //           return val.toFixed(0)
// //         },
// //       },
// //     },
// //     tooltip: {
// //       x: {
// //         format: "MMM yyyy",
// //       },
// //       y: {
// //         formatter: (val) => `${val} applications`,
// //       },
// //       theme: "light",
// //       marker: {
// //         show: true,
// //       },
// //     },
// //   }

// //   return <ReactApexChart options={chartOptions} series={chartSeries} type="area" height={height} />
// // }

// // function TabPanel(props) {
// //   const { children, value, index, ...other } = props
// //   return (
// //     <div
// //       role="tabpanel"
// //       hidden={value !== index}
// //       id={`analytics-tabpanel-${index}`}
// //       aria-labelledby={`analytics-tab-${index}`}
// //       {...other}
// //     >
// //       {value === index && (
// //         <Fade in={value === index} timeout={500}>
// //           <Box sx={{ pt: 4 }}>{children}</Box>
// //         </Fade>
// //       )}
// //     </div>
// //   )
// // }

// // const getStatusColor = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return "success"
// //     case "interviewed":
// //       return "primary"
// //     case "shortlisted":
// //       return "info"
// //     case "applied":
// //     case "matched":
// //       return "warning"
// //     default:
// //       return "default"
// //   }
// // }

// // const getStatusIcon = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return <CheckCircle />
// //     case "interviewed":
// //       return <People />
// //     case "shortlisted":
// //       return <Star />
// //     case "applied":
// //     case "matched":
// //       return <WorkOutline />
// //     default:
// //       return <HelpOutline />
// //   }
// // }

// // const StatCard = ({ title, value, icon, gradient, loading }) => {
// //   const theme = useTheme()
// //   if (loading) {
// //     return (
// //       <Card
// //         sx={{
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[1],
// //           height: "100%",
// //         }}
// //       >
// //         <CardContent sx={{ p: 3 }}>
// //           <Stack direction="row" justifyContent="space-between" alignItems="center">
// //             <Stack spacing={1}>
// //               <Skeleton variant="text" width="80%" height={20} />
// //               <Skeleton variant="text" width="50%" height={40} />
// //             </Stack>
// //             <Skeleton variant="circular" width={64} height={64} />
// //           </Stack>
// //         </CardContent>
// //       </Card>
// //     )
// //   }
// //   return (
// //     <Grow in timeout={300}>
// //       <Card
// //         sx={{
// //           background: gradient,
// //           color: "white",
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[8],
// //           height: "100%",
// //           transition: "all 0.3s ease",
// //           "&:hover": {
// //             transform: "translateY(-4px)",
// //             boxShadow: theme.shadows[12],
// //           },
// //         }}
// //       >
// //         <CardContent sx={{ p: 3 }}>
// //           <Stack direction="row" justifyContent="space-between" alignItems="center">
// //             <Stack spacing={1}>
// //               <Typography variant="subtitle2" sx={{ opacity: 0.9, fontWeight: 600 }}>
// //                 {title}
// //               </Typography>
// //               <Typography variant="h3" fontWeight="bold" sx={{ lineHeight: 1.2 }}>
// //                 {value}
// //               </Typography>
// //             </Stack>
// //             <Avatar
// //               sx={{
// //                 bgcolor: "rgba(255,255,255,0.2)",
// //                 width: 64,
// //                 height: 64,
// //                 backdropFilter: "blur(10px)",
// //               }}
// //             >
// //               {icon}
// //             </Avatar>
// //           </Stack>
// //         </CardContent>
// //       </Card>
// //     </Grow>
// //   )
// // }

// // const OverviewTab = ({ loading, data }) => {
// //   const theme = useTheme()

// //   const applicationTrendsData = {
// //     labels: data.application_trend?.map((d) => d.month) || [],
// //     datasets: [
// //       {
// //         label: "Applications",
// //         data: data.application_trend?.map((d) => d.application_count) || [],
// //         backgroundColor: theme.palette.primary.main,
// //       },
// //     ],
// //   }

// //   const statCards = [
// //     {
// //       title: "Total Applications",
// //       value: data.summary_stats?.total_applications || 0,
// //       icon: <WorkOutline sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
// //     },
// //     {
// //       title: "Total Interviews",
// //       value: data.summary_stats?.total_interviews || 0,
// //       icon: <People sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
// //     },
// //     {
// //       title: "Total Hires",
// //       value: data.summary_stats?.total_hires || 0,
// //       icon: <School sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
// //     },
// //     {
// //       title: "Acceptance Rate",
// //       value: data.summary_stats?.acceptance_rate || "0%",
// //       icon: <TrendingUp sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
// //     },
// //   ]

// //   return (
// //     <Stack spacing={4}>
// //       <Grid container spacing={3}>
// //         {statCards.map((card, index) => (
// //           <Grid item xs={12} sm={6} md={3} key={index}>
// //             <StatCard {...card} loading={loading} />
// //           </Grid>
// //         ))}
// //       </Grid>

// //       <Card
// //         sx={{
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[4],
// //           width: "100%",
// //           backgroundColor: "#F1FFFA",
// //           transition: "all 0.3s ease",
// //           "&:hover": { boxShadow: theme.shadows[8] },
// //         }}
// //       >
// //         <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
// //           <Box sx={{ p: 3, pb: 0 }}>
// //             {loading ? (
// //               <Skeleton variant="text" width="60%" height={32} />
// //             ) : (
// //               <Typography variant="h6" fontWeight="bold" color="text.primary">
// //                 Application Trends
// //               </Typography>
// //             )}
// //           </Box>
// //           {loading ? (
// //             <Box sx={{ p: 3 }}>
// //               <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
// //             </Box>
// //           ) : (
// //             <ApplicationTrendChart data={applicationTrendsData} />
// //           )}
// //         </CardContent>
// //       </Card>
// //     </Stack>
// //   )
// // }

// // const RecentActivityTab = ({ loading, data }) => {
// //   const theme = useTheme()

// //   const getActivityIcon = (activityString) => {
// //     const lowerCaseActivity = activityString.toLowerCase()
// //     if (lowerCaseActivity.includes("hired")) return <CheckCircle />
// //     if (lowerCaseActivity.includes("interview")) return <People />
// //     if (lowerCaseActivity.includes("applied")) return <WorkOutline />
// //     return <RateReview />
// //   }

// //   return (
// //     <Card
// //       sx={{
// //         borderRadius: 3,
// //         boxShadow: theme.shadows[4],
// //         width: "100%",
// //         backgroundColor: "#F1FFFA",
// //         transition: "all 0.3s ease",
// //         "&:hover": { boxShadow: theme.shadows[8] },
// //       }}
// //     >
// //       <CardContent sx={{ p: 3 }}>
// //         {loading ? (
// //           <Skeleton variant="text" width="50%" height={32} />
// //         ) : (
// //           <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
// //             Recent Activity
// //           </Typography>
// //         )}
// //         <List sx={{ mt: 2 }}>
// //           {loading
// //             ? Array.from(new Array(5)).map((_, index) => (
// //                 <ListItem key={index} sx={{ px: 0, py: 1.5 }}>
// //                   <ListItemAvatar>
// //                     <Skeleton variant="circular" width={48} height={48} />
// //                   </ListItemAvatar>
// //                   <ListItemText primary={<Skeleton variant="text" width="80%" />} secondary={<Skeleton variant="text" width="60%" />} />
// //                 </ListItem>
// //               ))
// //             : data?.map((activity, index) => (
// //                 <ListItem
// //                   key={`${activity.candidate_name}-${index}`}
// //                   sx={{
// //                     px: 0,
// //                     py: 1.5,
// //                     borderRadius: 2,
// //                     transition: "all 0.2s ease",
// //                     "&:hover": {
// //                       bgcolor: alpha(theme.palette.primary.main, 0.04),
// //                     },
// //                   }}
// //                 >
// //                   <ListItemAvatar>
// //                     <Avatar
// //                       sx={{
// //                         bgcolor: alpha(theme.palette.primary.main, 0.1),
// //                         color: theme.palette.primary.main,
// //                         width: 48,
// //                         height: 48,
// //                         boxShadow: theme.shadows[2],
// //                       }}
// //                     >
// //                       {getActivityIcon(activity.activity)}
// //                     </Avatar>
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={
// //                       <Typography variant="body2" fontWeight="600" color="text.primary">
// //                         {activity.candidate_name}
// //                       </Typography>
// //                     }
// //                     secondary={
// //                       <Typography variant="caption" color="text.secondary">
// //                         {activity.activity} • {activity.time_ago}
// //                       </Typography>
// //                     }
// //                   />
// //                 </ListItem>
// //               ))}
// //         </List>
// //       </CardContent>
// //     </Card>
// //   )
// // }

// // const TrendsTab = ({ loading, data }) => {
// //   const theme = useTheme()

// //   const funnelData = [
// //     {
// //       icon: <WorkOutline color="primary" />,
// //       title: "Applications",
// //       value: data?.hiring_funnel?.applications || 0,
// //       color: theme.palette.primary.main,
// //     },
// //     {
// //       icon: <People color="secondary" />,
// //       title: "Interviews",
// //       value: data?.hiring_funnel?.interviews || 0,
// //       conversion: data?.hiring_funnel?.interview_conversion_rate || "0%",
// //       color: theme.palette.secondary.main,
// //     },
// //     {
// //       icon: <CheckCircle color="success" />,
// //       title: "Hires",
// //       value: data?.hiring_funnel?.hires || 0,
// //       conversion: data?.hiring_funnel?.hire_conversion_rate || "0%",
// //       color: theme.palette.success.main,
// //     },
// //   ]

// //   const kpiData = [
// //     {
// //       icon: <AccessTime />,
// //       title: "Average Time to Hire",
// //       value: data?.key_performance_metrics?.average_time_to_hire || "N/A",
// //       color: theme.palette.primary,
// //     },
// //     {
// //       icon: <MonetizationOn />,
// //       title: "Cost Per Hire",
// //       value: data?.key_performance_metrics?.cost_per_hire || "N/A",
// //       color: theme.palette.success,
// //     },
// //     {
// //       icon: <RateReview />,
// //       title: "Offer Acceptance Rate",
// //       value: data?.key_performance_metrics?.offer_acceptance_rate || "N/A",
// //       color: theme.palette.secondary,
// //     },
// //   ]

// //   return (
// //     <Grid container spacing={4}>
// //       <Grid item xs={12} lg={5}>
// //         <Card
// //           sx={{
// //             borderRadius: 3,
// //             boxShadow: theme.shadows[4],
// //             height: "100%",
// //             width: "520px",
// //             backgroundColor: "#F1FFFA",
// //             p: 2,
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent>
// //             <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
// //               Hiring Funnel
// //             </Typography>
// //             {loading ? (
// //               <Stack spacing={4} sx={{ mt: 3 }}>
// //                 <Skeleton variant="rectangular" height={60} sx={{ borderRadius: 2 }} />
// //                 <Skeleton variant="rectangular" height={60} sx={{ borderRadius: 2 }} />
// //                 <Skeleton variant="rectangular" height={60} sx={{ borderRadius: 2 }} />
// //               </Stack>
// //             ) : (
// //               <Stack spacing={2} sx={{ mt: 4 }}>
// //                 {funnelData.map((step, index) => (
// //                   <Grow in timeout={500 + index * 200} key={step.title}>
// //                     <Box>
// //                       <Paper
// //                         variant="outlined"
// //                         sx={{
// //                           p: 2,
// //                           display: "flex",
// //                           alignItems: "center",
// //                           borderRadius: 2,
// //                           borderColor: alpha(step.color, 0.3),
// //                           background: `linear-gradient(to right, ${alpha(step.color, 0.1)}, transparent)`,
// //                         }}
// //                       >
// //                         <Avatar sx={{ bgcolor: alpha(step.color, 0.15), color: step.color, mr: 2 }}>
// //                           {step.icon}
// //                         </Avatar>
// //                         <Box sx={{ flexGrow: 1 }}>
// //                           <Typography variant="body2" color="text.secondary">
// //                             {step.title}
// //                           </Typography>
// //                           <Typography variant="h5" fontWeight="bold">
// //                             {step.value}
// //                           </Typography>
// //                         </Box>
// //                         {step.conversion && (
// //                           <Box sx={{ textAlign: "right" }}>
// //                             <Typography variant="caption" color="text.secondary">
// //                               Conversion
// //                             </Typography>
// //                             <Typography variant="body1" fontWeight="bold" color={step.color}>
// //                               {step.conversion}
// //                             </Typography>
// //                           </Box>
// //                         )}
// //                       </Paper>
// //                       {index < funnelData.length - 1 && (
// //                         <Box display="flex" justifyContent="center" my={1}>
// //                           <ArrowDownward sx={{ color: "grey.400" }} />
// //                         </Box>
// //                       )}
// //                     </Box>
// //                   </Grow>
// //                 ))}
// //               </Stack>
// //             )}
// //           </CardContent>
// //         </Card>
// //       </Grid>

// //       <Grid item xs={12} lg={7}>
// //         <Card
// //           sx={{
// //             borderRadius: 3,
// //             boxShadow: theme.shadows[4],
// //             height: "100%",
// //             backgroundColor: "#F1FFFA",
// //             p: 2,
// //             transition: "all 0.3s ease",
// //             "&:hover": { boxShadow: theme.shadows[8] },
// //           }}
// //         >
// //           <CardContent>
// //             <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
// //               Key Performance Metrics
// //             </Typography>
// //             <Grid container spacing={3} sx={{ mt: 2, height: "100%" }}>
// //               {loading
// //                 ? Array.from(new Array(3)).map((_, index) => (
// //                     <Grid item xs={12} sm={4} key={index}>
// //                       <Skeleton variant="rectangular" height={150} sx={{ borderRadius: 2 }} />
// //                     </Grid>
// //                   ))
// //                 : kpiData.map((kpi, index) => (
// //                     <Grid item xs={12} sm={4} key={kpi.title}>
// //                       <Grow in timeout={500 + index * 200}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{
// //                             p: 3,
// //                             borderRadius: 2,
// //                             textAlign: "center",
// //                             height: "100%",
// //                             display: "flex",
// //                             flexDirection: "column",
// //                             justifyContent: "center",
// //                             borderColor: alpha(kpi.color.main, 0.3),
// //                             backgroundColor: alpha(kpi.color.main, 0.05),
// //                           }}
// //                         >
// //                           <Avatar
// //                             sx={{
// //                               bgcolor: alpha(kpi.color.main, 0.1),
// //                               color: kpi.color.main,
// //                               width: 56,
// //                               height: 56,
// //                               mx: "auto",
// //                               mb: 1.5,
// //                             }}
// //                           >
// //                             {kpi.icon}
// //                           </Avatar>
// //                           <Typography variant="body2" fontWeight="600" color="text.primary">
// //                             {kpi.title}
// //                           </Typography>
// //                           <Typography variant="h4" fontWeight="bold" color="text.primary" sx={{ mt: 1 }}>
// //                             {kpi.value}
// //                           </Typography>
// //                         </Paper>
// //                       </Grow>
// //                     </Grid>
// //                   ))}
// //             </Grid>
// //           </CardContent>
// //         </Card>
// //       </Grid>
// //     </Grid>
// //   )
// // }

// // const DemographicsTab = ({
// //   loading,
// //   data,
// //   skillChartRef,
// //   locationTableRef,
// //   timeRange,
// //   handleTimeRangeChange,
// //   jobFilter,
// //   handleJobFilterChange,
// //   filterOptions,
// //   onExportClick,
// // }) => {
// //   const theme = useTheme()
// //   const colorPalette = useMemo(() => {
// //     if (!data || !data.skill_distribution) {
// //       return []
// //     }
// //     return generateUniqueColors(data.skill_distribution.length)
// //   }, [data.skill_distribution])

// //   return (
// //     <Stack spacing={4}>
// //       <Paper
// //         elevation={0}
// //         sx={{
// //           p: 2,
// //           borderRadius: 3,
// //           backgroundColor: "#F1FFFA",
// //           border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
// //         }}
// //       >
// //         <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center" justifyContent="flex-end">
// //           <FormControl size="small">
// //             <Select
// //               value={timeRange}
// //               onChange={handleTimeRangeChange}
// //               sx={{
// //                 borderRadius: 2,
// //                 backgroundColor: "#F1FFFA",
// //                 minWidth: 140,

// //               }}
// //             >
// //               <MenuItem value="last30days">Last Month</MenuItem>
// //               <MenuItem value="last3months">Last 3 Months</MenuItem>
// //               <MenuItem value="last6months">Last 6 Months</MenuItem>
// //               <MenuItem value="lastyear">Last Year</MenuItem>
// //             </Select>
// //           </FormControl>
// //           <FormControl size="small">
// //             <Select
// //               value={jobFilter}
// //               onChange={handleJobFilterChange}
// //               sx={{
// //                 borderRadius: 2,
// //                 backgroundColor: "#F1FFFA",
// //                 minWidth: 180,
// //               }}
// //             >
// //               {filterOptions.job_roles.map((job) => (
// //                 <MenuItem key={job || "all-jobs"} value={job === "All Jobs" || !job ? "all" : job}>
// //                   {job || "All Jobs"}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <Button
// //             variant="outlined"
// //             startIcon={<CloudDownload />}
// //             size="medium"
// //             onClick={onExportClick}
// //             sx={{
// //               borderRadius: 2,
// //               textTransform: "none",
// //               fontWeight: 600,
// //             }}
// //           >
// //             Export Report
// //           </Button>
// //         </Stack>
// //       </Paper>
// //       <Grid container spacing={4}>
// //         <Grid item xs={12} lg={8}>
// //           <Card
// //             ref={skillChartRef}
// //             sx={{
// //               borderRadius: 3,
// //               boxShadow: theme.shadows[4],
// //               height: "100%",
// //               backgroundColor: "#F1FFFA",
// //             }}
// //           >
// //             <CardContent sx={{ p: 3 }}>
// //               <Typography variant="h6" gutterBottom fontWeight="bold" color="text.primary">
// //                 Skill Distribution
// //               </Typography>
// //               {loading ? (
// //                 <Skeleton variant="rectangular" height={450} />
// //               ) : (
// //                 <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
// //                   <Grid item xs={12} sm={8}>
// //                     <SkillDonutChart data={data.skill_distribution} colors={colorPalette} />
// //                   </Grid>
// //                   <Grid item xs={12} sm={4}>
// //                     <SkillList data={data.skill_distribution} colors={colorPalette} />
// //                   </Grid>
// //                 </Grid>
// //               )}
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} lg={4}>
// //           <Card
// //             ref={locationTableRef}
// //             sx={{
// //               borderRadius: 3,
// //               boxShadow: theme.shadows[4],
// //               height: "100%",
// //               width: "550px",
// //               backgroundColor: "#F1FFFA",
// //             }}
// //           >
// //             <CardContent sx={{ p: 4 }}>
// //               <Typography variant="h6" gutterBottom fontWeight="bold" color="text.primary">
// //                 Candidate Locations
// //               </Typography>
// //               <TableContainer sx={{ mt: 3 }}>
// //                 <Table>
// //                   <TableHead>
// //                     <TableRow>
// //                       <TableCell>
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Location
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell align="right">
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Candidates
// //                         </Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   </TableHead>
// //                   <TableBody>
// //                     {loading
// //                       ? Array.from(new Array(5)).map((_, index) => (
// //                           <TableRow key={index}>
// //                             <TableCell>
// //                               <Skeleton variant="text" />
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Skeleton variant="rounded" width={40} height={24} />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))
// //                       : data.candidate_locations.map((loc) => (
// //                           <TableRow
// //                             key={loc.location}
// //                             sx={{ "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.04) } }}
// //                           >
// //                             <TableCell component="th" scope="row">
// //                               <Typography variant="body2" fontWeight="500">
// //                                 {loc.location}
// //                               </Typography>
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Chip label={loc.candidates} size="small" color="primary" variant="outlined" />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))}
// //                   </TableBody>
// //                 </Table>
// //               </TableContainer>
// //             </CardContent>
// //           </Card>
// //         </Grid>
// //       </Grid>
// //     </Stack>
// //   )
// // }

// // const CandidatesTab = ({
// //   loading,
// //   candidates,
// //   totalCandidates,
// //   page,
// //   rowsPerPage,
// //   handleChangePage,
// //   handleChangeRowsPerPage,
// // }) => {
// //   const theme = useTheme()
// //   const getExperienceTooltip = (experienceArray) => {
// //     if (!Array.isArray(experienceArray) || experienceArray.length === 0) {
// //       return "No experience details available."
// //     }
// //     return experienceArray
// //       .map((exp) => `${exp.title || "N/A"} at ${exp.company || "N/A"} (${exp.duration || "N/A"})`)
// //       .join("\n")
// //   }

// //   return (
// //     <Card
// //       sx={{
// //         borderRadius: 3,
// //         boxShadow: theme.shadows[4],
// //         backgroundColor: "#F1FFFA",
// //       }}
// //     >
// //       <CardContent sx={{ p: 4 }}>
// //         <Typography variant="h6" gutterBottom fontWeight="bold" color="text.primary">
// //           Top Candidates
// //         </Typography>
// //         <TableContainer sx={{ mt: 3 }}>
// //           <Table sx={{ minWidth: 650 }} aria-label="top candidates table">
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Candidate
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Experience
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Top Skills
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Match Score
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Status
// //                   </Typography>
// //                 </TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {loading
// //                 ? Array.from(new Array(rowsPerPage)).map((_, index) => (
// //                     <TableRow key={index}>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton variant="circular" width={48} height={48} />
// //                           <Stack spacing={0.5}>
// //                             <Skeleton variant="text" width={120} />
// //                             <Skeleton variant="text" width={100} />
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton variant="text" width={100} />
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" spacing={0.5} flexWrap="wrap">
// //                           <Skeleton variant="rounded" width={60} height={24} />
// //                           <Skeleton variant="rounded" width={70} height={24} />
// //                           <Skeleton variant="rounded" width={50} height={24} />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton variant="rectangular" width={100} height={8} sx={{ borderRadius: 1 }} />
// //                           <Skeleton variant="text" width={30} />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton variant="rounded" width={90} height={28} />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))
// //                 : candidates.map((candidate) => (
// //                     <TableRow
// //                       key={candidate.candidate_id}
// //                       hover
// //                       sx={{ "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.04) } }}
// //                     >
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Avatar src={candidate.avatar} sx={{ width: 48, height: 48 }} />
// //                           <Stack>
// //                             <Typography variant="body2" fontWeight="600">
// //                               {candidate.candidate_name}
// //                             </Typography>
// //                             <Stack direction="row" alignItems="center" spacing={0.5}>
// //                               <LocationOn sx={{ fontSize: 16, color: "text.secondary" }} />
// //                               <Typography variant="caption" color="text.secondary">
// //                                 {candidate.location}
// //                               </Typography>
// //                             </Stack>
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={
// //                             <div style={{ whiteSpace: "pre-line" }}>{getExperienceTooltip(candidate.experience)}</div>
// //                           }
// //                           arrow
// //                         >
// //                           <Typography variant="body2" sx={{ cursor: "pointer" }}>
// //                             {(candidate.experience && candidate.experience[0]?.duration) || "N/A"}
// //                           </Typography>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={Array.isArray(candidate.skills) ? candidate.skills.join(", ") : ""}
// //                           arrow
// //                           placement="top"
// //                         >
// //                           <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ cursor: "pointer" }}>
// //                             {Array.isArray(candidate.skills) &&
// //                               candidate.skills.slice(0, 3).map((skill) => (
// //                                 <Chip key={skill} label={skill} size="small" variant="outlined" />
// //                               ))}
// //                           </Stack>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <LinearProgress
// //                             variant="determinate"
// //                             value={candidate.match_score}
// //                             sx={{
// //                               width: 100,
// //                               height: 8,
// //                               borderRadius: 1,
// //                             }}
// //                           />
// //                           <Typography variant="body2" color="text.secondary" fontWeight="500">
// //                             {candidate.match_score}%
// //                           </Typography>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Chip
// //                           icon={getStatusIcon(candidate.status)}
// //                           label={candidate.status.charAt(0).toUpperCase() + candidate.status.slice(1)}
// //                           color={getStatusColor(candidate.status)}
// //                           size="small"
// //                           variant="filled"
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //         <TablePagination
// //           rowsPerPageOptions={[5, 10, 25]}
// //           component="div"
// //           count={totalCandidates}
// //           rowsPerPage={rowsPerPage}
// //           page={page}
// //           onPageChange={handleChangePage}
// //           onRowsPerPageChange={handleChangeRowsPerPage}
// //         />
// //       </CardContent>
// //     </Card>
// //   )
// // }

// // function EmployerAnalytics() {
// //   const theme = useTheme()
// //   const [tabValue, setTabValue] = useState(0)
// //   const [timeRange, setTimeRange] = useState("last30days")
// //   const [jobFilter, setJobFilter] = useState("all")
// //   const [loading, setLoading] = useState(true)
// //   const [candidatesData, setCandidatesData] = useState([])
// //   const [overviewData, setOverviewData] = useState({
// //     summary_stats: { total_applications: 0, total_interviews: 0, total_hires: 0, acceptance_rate: "0%" },
// //     application_trend: [],
// //     recent_activity: [],
// //   })
// //   const [demographicsData, setDemographicsData] = useState({
// //     skill_distribution: [],
// //     candidate_locations: [],
// //   })
// //   const [trendsData, setTrendsData] = useState(null)
// //   const [filterOptions, setFilterOptions] = useState({
// //     job_roles: ["All Jobs"],
// //     time_ranges: ["Last Month", "Last 3 Months", "Last 6 Months", "Last Year"],
// //   })
// //   const [page, setPage] = useState(0)
// //   const [rowsPerPage, setRowsPerPage] = useState(5)
// //   const [isExportModalOpen, setIsExportModalOpen] = useState(false)
// //   const skillChartRef = useRef(null)
// //   const locationTableRef = useRef(null)

// //   const safeJsonParse = (str, fallback = []) => {
// //     if (typeof str !== "string") return fallback
// //     try {
// //       return JSON.parse(str)
// //     } catch (e) {
// //       return fallback
// //     }
// //   }

// //   useEffect(() => {
// //     const fetchInitialData = async () => {
// //       setLoading(true)
// //       try {
// //         const [candidatesResponse, overviewResponse, trendsResponse] = await Promise.all([
// //           apiClient.get("/hiring-analytics/top-matching-candidates/"),
// //           apiClient.get("/hiring-analytics/combined-dashboard/"),
// //           apiClient.get("/employer-analytics/trends"),
// //         ])
// //         const mappedCandidates = candidatesResponse.data.map((apiCandidate) => ({
// //           candidate_id: apiCandidate.candidate_id,
// //           candidate_name: apiCandidate.candidate_name,
// //           skills: apiCandidate.skills || [],
// //           match_score: apiCandidate.match_score,
// //           avatar: `/placeholder.svg?height=40&width=40`,
// //           experience: safeJsonParse(apiCandidate.experience, []),
// //           location: apiCandidate.location || "N/A",
// //           status: apiCandidate.status ? apiCandidate.status.toLowerCase() : "matched",
// //         }))

// //         setCandidatesData(mappedCandidates)
// //         setOverviewData(overviewResponse.data)
// //         setTrendsData(trendsResponse.data)
// //       } catch (error) {
// //         console.error("Failed to fetch initial data:", error)
// //       } finally {
// //         setLoading(false)
// //       }
// //     }
// //     fetchInitialData()
// //   }, [])

// //   useEffect(() => {
// //     const fetchDemographicsData = async () => {
// //       setLoading(true)
// //       let url = "/demographics/"
// //       if (jobFilter !== "all") {
// //         url = `/demographics/job/${encodeURIComponent(jobFilter)}/`
// //       } else if (timeRange !== "all") {
// //         url = `/demographics/time/${timeRange}/`
// //       }

// //       try {
// //         const response = await apiClient.get(url)
// //         setDemographicsData(response.data)
// //         if (response.data.filter_options) {
// //           setFilterOptions(response.data.filter_options)
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch demographics data:", error)
// //       } finally {
// //         setLoading(false)
// //       }
// //     }

// //     fetchDemographicsData()
// //   }, [jobFilter, timeRange])

// //   const handleTabChange = (event, newValue) => setTabValue(newValue)
// //   const handleTimeRangeChange = (event) => {
// //     setTimeRange(event.target.value)
// //     setJobFilter("all")
// //   }
// //   const handleJobFilterChange = (event) => {
// //     setJobFilter(event.target.value)
// //     setTimeRange("all")
// //   }
// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage)
// //   }
// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10))
// //     setPage(0)
// //   }

// //   return (
// //     <Layout title="Hiring Analytics">
// //       <Box sx={{ bgcolor: "#f8fafc", minHeight: "100vh" }}>
// //         <Container maxWidth="xl" sx={{ py: 4 }}>
// //           <Stack spacing={4}>
// //             <Paper
// //               sx={{
// //                 p: { xs: 2, sm: 3 },
// //                 borderRadius: 3,
// //                 backgroundColor: "#F1FFFA",
// //                 color: "#4D3CC3",
// //                 width: "100%",
// //               }}
// //             >
// //               <Typography
// //                 variant="h3"
// //                 component="h1"
// //                 fontWeight="bold"
// //                 sx={{
// //                   background: "#4F46BA",
// //                   backgroundClip: "text",
// //                   WebkitBackgroundClip: "text",
// //                   WebkitTextFillColor: "transparent",
// //                 }}
// //               >
// //                 Hiring Analytics Dashboard
// //               </Typography>
// //             </Paper>

// //             <Paper
// //               elevation={0}
// //               sx={{
// //                 borderRadius: 3,
// //                 border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
// //                 boxShadow: theme.shadows[2],
// //                 overflow: "hidden",
// //                 backgroundColor: "#F1FFFA",
// //                 width: "100%",
// //               }}
// //             >
// //               <Tabs
// //                 value={tabValue}
// //                 onChange={handleTabChange}
// //                 indicatorColor="primary"
// //                 textColor="primary"
// //                 variant="standard"
// //                 centered
// //                 sx={{
// //                   "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
// //                   "& .MuiTabs-indicator": { height: 3, borderRadius: "3px 3px 0 0" },
// //                 }}
// //               >
// //                 <Tab icon={<BarChart />} label="OVERVIEW" iconPosition="start" />
// //                 <Tab icon={<Timeline />} label="TRENDS" iconPosition="start" />
// //                 <Tab icon={<PieChart />} label="DEMOGRAPHICS" iconPosition="start" />
// //                 <Tab icon={<People />} label="CANDIDATES" iconPosition="start" />
// //                 <Tab icon={<History />} label="RECENT ACTIVITY" iconPosition="start" />
// //               </Tabs>
// //             </Paper>

// //             <Box>
// //               <TabPanel value={tabValue} index={0}>
// //                 <OverviewTab loading={loading} data={overviewData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={1}>
// //                 <TrendsTab loading={loading} data={trendsData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={2}>
// //                 <DemographicsTab
// //                   loading={loading}
// //                   data={demographicsData}
// //                   skillChartRef={skillChartRef}
// //                   locationTableRef={locationTableRef}
// //                   timeRange={timeRange}
// //                   handleTimeRangeChange={handleTimeRangeChange}
// //                   jobFilter={jobFilter}
// //                   handleJobFilterChange={handleJobFilterChange}
// //                   filterOptions={filterOptions}
// //                   onExportClick={() => setIsExportModalOpen(true)}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={3}>
// //                 <CandidatesTab
// //                   loading={loading}
// //                   candidates={candidatesData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
// //                   totalCandidates={candidatesData.length}
// //                   page={page}
// //                   rowsPerPage={rowsPerPage}
// //                   handleChangePage={handleChangePage}
// //                   handleChangeRowsPerPage={handleChangeRowsPerPage}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={4}>
// //                 <RecentActivityTab loading={loading} data={overviewData.recent_activity} />
// //               </TabPanel>
// //             </Box>
// //           </Stack>
// //         </Container>
// //       </Box>
// //       <ExportReportDialog
// //         open={isExportModalOpen}
// //         onClose={() => setIsExportModalOpen(false)}
// //         candidatesData={candidatesData}
// //         demographicsData={demographicsData}
// //         overviewData={overviewData}
// //         skillChartRef={skillChartRef}
// //         locationTableRef={locationTableRef}
// //       />
// //     </Layout>
// //   )
// // }

// // export default EmployerAnalytics
// // import { useState, useEffect, useRef, useMemo } from "react"
// // import {
// //   Box,
// //   Typography,
// //   Grid,
// //   Card,
// //   CardContent,
// //   Paper,
// //   Tabs,
// //   Tab,
// //   FormControl,
// //   Select,
// //   MenuItem,
// //   Button,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   ListItemAvatar,
// //   Avatar,
// //   Chip,
// //   ListItemIcon,
// //   LinearProgress,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Skeleton,
// //   TablePagination,
// //   Tooltip,
// //   Stack,
// //   Container,
// //   Fade,
// //   Grow,
// //   useTheme,
// //   alpha,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   RadioGroup,
// //   FormControlLabel,
// //   Radio,
// //   FormLabel,
// // } from "@mui/material"
// // import {
// //   TrendingUp,
// //   People,
// //   WorkOutline,
// //   School,
// //   BarChart,
// //   PieChart,
// //   Timeline,
// //   CloudDownload,
// //   Star,
// //   LocationOn,
// //   CheckCircle,
// //   HelpOutline,
// //   ArrowRightAlt,
// //   MonetizationOn,
// //   AccessTime,
// //   RateReview,
// //   History, // Added for the new tab
// // } from "@mui/icons-material"
// // import * as htmlToImage from "html-to-image"
// // import ReactApexChart from "react-apexcharts"
// // import Layout from "../common/Layout"
// // import apiClient from "../../context/apiClient"

// // const downloadFile = ({ data, fileName, fileType }) => {
// //   const blob = new Blob([data], { type: fileType })
// //   const a = document.createElement("a")
// //   a.download = fileName
// //   a.href = window.URL.createObjectURL(blob)
// //   const clickEvt = new MouseEvent("click", {
// //     view: window,
// //     bubbles: true,
// //     cancelable: true,
// //   })
// //   a.dispatchEvent(clickEvt)
// //   a.remove()
// // }

// // const convertToCSV = (data) => {
// //   if (!data || data.length === 0) return ""
// //   const headers = Object.keys(data[0])
// //   const csvRows = [headers.join(",")]
// //   for (const row of data) {
// //     const values = headers.map((header) => {
// //       const escaped = ("" + row[header]).replace(/"/g, '""')
// //       return `"${escaped}"`
// //     })
// //     csvRows.push(values.join(","))
// //   }
// //   return csvRows.join("\n")
// // }

// // const generateUniqueColors = (count) => {
// //   if (count === 0) return []
// //   const colors = []
// //   const hueStep = 360 / count
// //   for (let i = 0; i < count; i++) {
// //     const hue = i * hueStep
// //     colors.push(`hsl(${hue}, 70%, 50%)`)
// //   }
// //   return colors
// // }

// // const ExportReportDialog = ({
// //   open,
// //   onClose,
// //   candidatesData,
// //   demographicsData,
// //   overviewData,
// //   skillChartRef,
// //   locationTableRef,
// // }) => {
// //   const [reportType, setReportType] = useState("demographics_skills")
// //   const [format, setFormat] = useState("png")

// //   const handleDownload = async () => {
// //     let dataToExport = []
// //     let fileName = `${reportType}_report`
// //     const isImageFormat = format === "png"

// //     if (isImageFormat) {
// //       const elementToCapture = reportType === "demographics_skills" ? skillChartRef.current : locationTableRef.current
// //       if (!elementToCapture) {
// //         console.error("Target element for image capture not found.")
// //         return
// //       }
// //       try {
// //         const dataUrl = await htmlToImage.toPng(elementToCapture)
// //         const a = document.createElement("a")
// //         a.href = dataUrl
// //         a.download = `${reportType}_${new Date().toISOString().slice(0, 10)}.png`
// //         a.click()
// //       } catch (error) {
// //         console.error("Failed to capture component as image", error)
// //       }
// //     } else {
// //       switch (reportType) {
// //         case "candidates":
// //           dataToExport = candidatesData.map((c) => ({
// //             id: c.candidate_id,
// //             name: c.candidate_name,
// //             location: c.location,
// //             status: c.status,
// //             match_score: c.match_score,
// //             skills: c.skills.join("|"),
// //             experience: c.experience.map((e) => `${e.title} at ${e.company}`).join(" | "),
// //           }))
// //           break
// //         case "demographics_skills":
// //           dataToExport = demographicsData.skill_distribution
// //           fileName = "skill_distribution_report"
// //           break
// //         case "demographics_locations":
// //           dataToExport = demographicsData.candidate_locations
// //           fileName = "candidate_locations_report"
// //           break
// //         case "overview":
// //           dataToExport = [overviewData.summary_stats]
// //           break
// //         default:
// //           console.error("Invalid report type")
// //           return
// //       }

// //       if (format === "csv") {
// //         const csvData = convertToCSV(dataToExport)
// //         downloadFile({
// //           data: csvData,
// //           fileName: `${fileName}.csv`,
// //           fileType: "text/csv",
// //         })
// //       } else if (format === "json") {
// //         downloadFile({
// //           data: JSON.stringify(dataToExport, null, 2),
// //           fileName: `${fileName}.json`,
// //           fileType: "application/json",
// //         })
// //       }
// //     }
// //     onClose()
// //   }

// //   const isVisualReport = reportType === "demographics_skills" || reportType === "demographics_locations"

// //   return (
// //     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
// //       <DialogTitle fontWeight="bold">Export Report</DialogTitle>
// //       <DialogContent dividers>
// //         <Stack spacing={4}>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Report Type
// //             </FormLabel>
// //             <RadioGroup value={reportType} onChange={(e) => setReportType(e.target.value)}>
// //               <FormControlLabel value="demographics_skills" control={<Radio />} label="Skill Distribution" />
// //               <FormControlLabel value="demographics_locations" control={<Radio />} label="Candidate Locations" />
// //               <FormControlLabel value="candidates" control={<Radio />} label="Top Candidates (Data Only)" />
// //               <FormControlLabel value="overview" control={<Radio />} label="Hiring Stats Overview (Data Only)" />
// //             </RadioGroup>
// //           </FormControl>
// //           <FormControl component="fieldset">
// //             <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
// //               Select Format
// //             </FormLabel>
// //             <RadioGroup row value={format} onChange={(e) => setFormat(e.target.value)}>
// //               <FormControlLabel value="png" control={<Radio />} label="Image (PNG)" disabled={!isVisualReport} />
// //               <FormControlLabel value="csv" control={<Radio />} label="CSV" />
// //               <FormControlLabel value="json" control={<Radio />} label="JSON" />
// //             </RadioGroup>
// //           </FormControl>
// //         </Stack>
// //       </DialogContent>
// //       <DialogActions sx={{ p: 2 }}>
// //         <Button onClick={onClose} color="inherit">
// //           Cancel
// //         </Button>
// //         <Button onClick={handleDownload} variant="contained" startIcon={<CloudDownload />}>
// //           Download
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   )
// // }

// // const cleanSkill = (skill) => {
// //   return skill.replace(/[\[\]"]/g, "")
// // }

// // const SkillDonutChart = ({ data, colors }) => {
// //   const theme = useTheme()
// //   const chartSeries = data.map((item) => item.count)
// //   const chartOptions = {
// //     chart: { type: "donut", background: "transparent" },
// //     plotOptions: {
// //       pie: {
// //         donut: {
// //           size: "70%",
// //           labels: {
// //             show: true,
// //             total: {
// //               show: true,
// //               label: "Total Skills",
// //               color: theme.palette.text.secondary,
// //               formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0),
// //             },
// //           },
// //         },
// //       },
// //     },
// //     dataLabels: { enabled: false },
// //     legend: { show: false },
// //     colors: colors,
// //     tooltip: { y: { formatter: (val) => `${val} candidates` } },
// //   }
// //   return <ReactApexChart options={chartOptions} series={chartSeries} type="donut" height={420} />
// // }

// // const SkillList = ({ data, colors }) => {
// //   return (
// //     <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 2 }}>
// //       <List>
// //         {data.map((item, index) => (
// //           <ListItem key={item.skill} disablePadding>
// //             <Stack direction="row" alignItems="center" spacing={2} sx={{ width: "100%", py: 0.5 }}>
// //               <Box
// //                 sx={{
// //                   width: 16,
// //                   height: 16,
// //                   borderRadius: "4px",
// //                   bgcolor: colors[index % colors.length],
// //                   flexShrink: 0,
// //                 }}
// //               />
// //               <ListItemText
// //                 primary={
// //                   <Typography variant="body2" color="text.primary" noWrap>
// //                     {cleanSkill(item.skill)}
// //                   </Typography>
// //                 }
// //               />
// //               <Typography variant="body2" color="text.secondary" fontWeight="bold">
// //                 {item.count}
// //               </Typography>
// //             </Stack>
// //           </ListItem>
// //         ))}
// //       </List>
// //     </Box>
// //   )
// // }

// // const ApplicationTrendChart = ({ data, height = 450 }) => {
// //   const theme = useTheme()

// //   if (!data || !data.datasets || !data.datasets[0] || !data.datasets[0].data || data.datasets[0].data.length === 0) {
// //     return (
// //       <Box
// //         sx={{
// //           height,
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           bgcolor: alpha(theme.palette.grey[100], 0.3),
// //           borderRadius: 2,
// //           border: `1px dashed ${theme.palette.grey[300]}`,
// //           m: 3,
// //         }}
// //       >
// //         <Typography variant="body2" color="text.secondary">
// //           No trend data available.
// //         </Typography>
// //       </Box>
// //     )
// //   }

// //   const chartSeries = [
// //     {
// //       name: "Applications",
// //       data: data.datasets[0].data,
// //     },
// //   ]

// //   const chartOptions = {
// //     chart: {
// //       type: "area",
// //       height: height,
// //       toolbar: {
// //         show: false,
// //       },
// //       zoom: {
// //         enabled: false,
// //       },
// //       background: "transparent",
// //     },
// //     colors: [theme.palette.primary.main],
// //     dataLabels: {
// //       enabled: false,
// //     },
// //     stroke: {
// //       curve: "smooth",
// //       width: 3,
// //       lineCap: "round",
// //     },
// //     fill: {
// //       type: "gradient",
// //       gradient: {
// //         shadeIntensity: 1,
// //         opacityFrom: 0.4,
// //         opacityTo: 0.1,
// //         stops: [0, 90, 100],
// //       },
// //     },
// //     grid: {
// //       show: true,
// //       borderColor: theme.palette.divider,
// //       strokeDashArray: 4,
// //       xaxis: {
// //         lines: {
// //           show: false,
// //         },
// //       },
// //       yaxis: {
// //         lines: {
// //           show: true,
// //         },
// //       },
// //     },
// //     xaxis: {
// //       categories: data.labels,
// //       axisBorder: {
// //         show: false,
// //       },
// //       axisTicks: {
// //         show: false,
// //       },
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //           fontWeight: 500,
// //         },
// //       },
// //     },
// //     yaxis: {
// //       labels: {
// //         style: {
// //           colors: theme.palette.text.secondary,
// //         },
// //         formatter: function (val) {
// //           return val.toFixed(0)
// //         },
// //       },
// //     },
// //     tooltip: {
// //       x: {
// //         format: "MMM yyyy",
// //       },
// //       y: {
// //         formatter: (val) => `${val} applications`,
// //       },
// //       theme: "light",
// //       marker: {
// //         show: true,
// //       },
// //     },
// //   }

// //   return <ReactApexChart options={chartOptions} series={chartSeries} type="area" height={height} />
// // }

// // const mockData = {
// //   hiringMetrics: {
// //     totalApplications: 620,
// //     totalInterviews: 225,
// //     totalHires: 98,
// //     averageTimeToHire: "28 days",
// //     costPerHire: "$2,450",
// //     offerAcceptanceRate: "85%",
// //   },
// // }

// // function TabPanel(props) {
// //   const { children, value, index, ...other } = props
// //   return (
// //     <div
// //       role="tabpanel"
// //       hidden={value !== index}
// //       id={`analytics-tabpanel-${index}`}
// //       aria-labelledby={`analytics-tab-${index}`}
// //       {...other}
// //     >
// //       {value === index && (
// //         <Fade in={value === index} timeout={500}>
// //           <Box sx={{ pt: 4 }}>{children}</Box>
// //         </Fade>
// //       )}
// //     </div>
// //   )
// // }

// // const getStatusColor = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return "success"
// //     case "interviewed":
// //       return "primary"
// //     case "shortlisted":
// //       return "info"
// //     case "applied":
// //     case "matched":
// //       return "warning"
// //     default:
// //       return "default"
// //   }
// // }

// // const getStatusIcon = (status) => {
// //   switch (status) {
// //     case "hired":
// //       return <CheckCircle />
// //     case "interviewed":
// //       return <People />
// //     case "shortlisted":
// //       return <Star />
// //     case "applied":
// //     case "matched":
// //       return <WorkOutline />
// //     default:
// //       return <HelpOutline />
// //   }
// // }

// // const StatCard = ({ title, value, icon, gradient, loading }) => {
// //   const theme = useTheme()
// //   if (loading) {
// //     return (
// //       <Card
// //         sx={{
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[1],
// //           height: "100%",
// //         }}
// //       >
// //         <CardContent sx={{ p: 3 }}>
// //           <Stack direction="row" justifyContent="space-between" alignItems="center">
// //             <Stack spacing={1}>
// //               <Skeleton variant="text" width="80%" height={20} />
// //               <Skeleton variant="text" width="50%" height={40} />
// //             </Stack>
// //             <Skeleton variant="circular" width={64} height={64} />
// //           </Stack>
// //         </CardContent>
// //       </Card>
// //     )
// //   }
// //   return (
// //     <Grow in timeout={300}>
// //       <Card
// //         sx={{
// //           background: gradient,
// //           color: "white",
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[8],
// //           height: "100%",
// //           transition: "all 0.3s ease",
// //           "&:hover": {
// //             transform: "translateY(-4px)",
// //             boxShadow: theme.shadows[12],
// //           },
// //         }}
// //       >
// //         <CardContent sx={{ p: 3 }}>
// //           <Stack direction="row" justifyContent="space-between" alignItems="center">
// //             <Stack spacing={1}>
// //               <Typography variant="subtitle2" sx={{ opacity: 0.9, fontWeight: 600 }}>
// //                 {title}
// //               </Typography>
// //               <Typography variant="h3" fontWeight="bold" sx={{ lineHeight: 1.2 }}>
// //                 {value}
// //               </Typography>
// //             </Stack>
// //             <Avatar
// //               sx={{
// //                 bgcolor: "rgba(255,255,255,0.2)",
// //                 width: 64,
// //                 height: 64,
// //                 backdropFilter: "blur(10px)",
// //               }}
// //             >
// //               {icon}
// //             </Avatar>
// //           </Stack>
// //         </CardContent>
// //       </Card>
// //     </Grow>
// //   )
// // }

// // const OverviewTab = ({ loading, data }) => {
// //   const theme = useTheme()

// //   const applicationTrendsData = {
// //     labels: data.application_trend?.map((d) => d.month) || [],
// //     datasets: [
// //       {
// //         label: "Applications",
// //         data: data.application_trend?.map((d) => d.application_count) || [],
// //         backgroundColor: theme.palette.primary.main,
// //       },
// //     ],
// //   }

// //   const statCards = [
// //     {
// //       title: "Total Applications",
// //       value: data.summary_stats?.total_applications || 0,
// //       icon: <WorkOutline sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
// //     },
// //     {
// //       title: "Total Interviews",
// //       value: data.summary_stats?.total_interviews || 0,
// //       icon: <People sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
// //     },
// //     {
// //       title: "Total Hires",
// //       value: data.summary_stats?.total_hires || 0,
// //       icon: <School sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
// //     },
// //     {
// //       title: "Acceptance Rate",
// //       value: data.summary_stats?.acceptance_rate || "0%",
// //       icon: <TrendingUp sx={{ fontSize: 32 }} />,
// //       gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
// //     },
// //   ]

// //   return (
// //     <Stack spacing={4}>
// //       <Grid container spacing={3}>
// //         {statCards.map((card, index) => (
// //           <Grid item xs={12} sm={6} md={3} key={index}>
// //             <StatCard {...card} loading={loading} />
// //           </Grid>
// //         ))}
// //       </Grid>

// //       <Card
// //         sx={{
// //           borderRadius: 3,
// //           boxShadow: theme.shadows[4],
// //           width: "100%",
// //           backgroundColor: "#F1FFFA",
// //           transition: "all 0.3s ease",
// //           "&:hover": { boxShadow: theme.shadows[8] },
// //         }}
// //       >
// //         <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
// //           <Box sx={{ p: 3, pb: 0 }}>
// //             {loading ? (
// //               <Skeleton variant="text" width="60%" height={32} />
// //             ) : (
// //               <Typography variant="h6" fontWeight="bold" color="text.primary">
// //                 Application Trends
// //               </Typography>
// //             )}
// //           </Box>
// //           {loading ? (
// //             <Box sx={{ p: 3 }}>
// //               <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
// //             </Box>
// //           ) : (
// //             <ApplicationTrendChart data={applicationTrendsData} />
// //           )}
// //         </CardContent>
// //       </Card>
// //     </Stack>
// //   )
// // }

// // const RecentActivityTab = ({ loading, data }) => {
// //   const theme = useTheme()

// //   const getActivityIcon = (activityString) => {
// //     const lowerCaseActivity = activityString.toLowerCase()
// //     if (lowerCaseActivity.includes("hired")) return <CheckCircle />
// //     if (lowerCaseActivity.includes("interview")) return <People />
// //     if (lowerCaseActivity.includes("applied")) return <WorkOutline />
// //     return <RateReview />
// //   }

// //   return (
// //     <Card
// //       sx={{
// //         borderRadius: 3,
// //         boxShadow: theme.shadows[4],
// //         width: "100%",
// //         backgroundColor: "#F1FFFA",
// //         transition: "all 0.3s ease",
// //         "&:hover": { boxShadow: theme.shadows[8] },
// //       }}
// //     >
// //       <CardContent sx={{ p: 3 }}>
// //         {loading ? (
// //           <Skeleton variant="text" width="50%" height={32} />
// //         ) : (
// //           <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
// //             Recent Activity
// //           </Typography>
// //         )}
// //         <List sx={{ mt: 2 }}>
// //           {loading
// //             ? Array.from(new Array(5)).map((_, index) => (
// //                 <ListItem key={index} sx={{ px: 0, py: 1.5 }}>
// //                   <ListItemAvatar>
// //                     <Skeleton variant="circular" width={48} height={48} />
// //                   </ListItemAvatar>
// //                   <ListItemText primary={<Skeleton variant="text" width="80%" />} secondary={<Skeleton variant="text" width="60%" />} />
// //                 </ListItem>
// //               ))
// //             : data?.map((activity, index) => (
// //                 <ListItem
// //                   key={`${activity.candidate_name}-${index}`}
// //                   sx={{
// //                     px: 0,
// //                     py: 1.5,
// //                     borderRadius: 2,
// //                     transition: "all 0.2s ease",
// //                     "&:hover": {
// //                       bgcolor: alpha(theme.palette.primary.main, 0.04),
// //                     },
// //                   }}
// //                 >
// //                   <ListItemAvatar>
// //                     <Avatar
// //                       sx={{
// //                         bgcolor: alpha(theme.palette.primary.main, 0.1),
// //                         color: theme.palette.primary.main,
// //                         width: 48,
// //                         height: 48,
// //                         boxShadow: theme.shadows[2],
// //                       }}
// //                     >
// //                       {getActivityIcon(activity.activity)}
// //                     </Avatar>
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={
// //                       <Typography variant="body2" fontWeight="600" color="text.primary">
// //                         {activity.candidate_name}
// //                       </Typography>
// //                     }
// //                     secondary={
// //                       <Typography variant="caption" color="text.secondary">
// //                         {activity.activity} • {activity.time_ago}
// //                       </Typography>
// //                     }
// //                   />
// //                 </ListItem>
// //               ))}
// //         </List>
// //       </CardContent>
// //     </Card>
// //   )
// // }

// // const TrendsTab = ({ loading }) => {
// //   const theme = useTheme()
// //   return (
// //     <Grid container spacing={4}>
// //       <Grid item xs={12} md={6}>
// //         <Card
// //           sx={{
// //             borderRadius: 3,
// //             boxShadow: theme.shadows[4],
// //             height: "100%",
// //             backgroundColor: "#F1FFFA",
// //             transition: "all 0.3s ease",
// //             "&:hover": {
// //               boxShadow: theme.shadows[8],
// //             },
// //           }}
// //         >
// //           <CardContent sx={{ p: 4 }}>
// //             {loading ? (
// //               <Skeleton variant="text" width="40%" height={32} />
// //             ) : (
// //               <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
// //                 Hiring Funnel
// //               </Typography>
// //             )}
// //             <List sx={{ pt: 3 }}>
// //               {loading ? (
// //                 <>
// //                   <ListItem disablePadding sx={{ py: 1 }}>
// //                     <Skeleton variant="text" height={32} width="50%" />
// //                   </ListItem>
// //                   <ListItem sx={{ pl: 4, py: 1 }}>
// //                     <Skeleton variant="text" height={32} width="70%" />
// //                     <Skeleton variant="text" height={20} width="40%" />
// //                   </ListItem>
// //                   <ListItem sx={{ pl: 8, py: 1 }}>
// //                     <Skeleton variant="text" height={32} width="60%" />
// //                     <Skeleton variant="text" height={20} width="40%" />
// //                   </ListItem>
// //                 </>
// //               ) : (
// //                 <>
// //                   <ListItem disablePadding sx={{ py: 1 }}>
// //                     <ListItemText
// //                       primary={
// //                         <Typography variant="h6" fontWeight="bold" color="text.primary">
// //                           {mockData.hiringMetrics.totalApplications} Applications
// //                         </Typography>
// //                       }
// //                     />
// //                   </ListItem>
// //                   <ListItem sx={{ pl: 4, py: 1, display: "flex", alignItems: "center" }}>
// //                     <ArrowRightAlt
// //                       sx={{
// //                         mr: 2,
// //                         color: theme.palette.primary.main,
// //                         fontSize: 28,
// //                       }}
// //                     />
// //                     <ListItemText
// //                       primary={
// //                         <Typography variant="h6" fontWeight="bold" color="primary.main">
// //                           {mockData.hiringMetrics.totalInterviews} Interviews
// //                         </Typography>
// //                       }
// //                       secondary={
// //                         <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
// //                           {(
// //                             (mockData.hiringMetrics.totalInterviews / mockData.hiringMetrics.totalApplications) *
// //                             100
// //                           ).toFixed(1)}
// //                           % Conversion Rate
// //                         </Typography>
// //                       }
// //                     />
// //                   </ListItem>
// //                   <ListItem sx={{ pl: 8, py: 1, display: "flex", alignItems: "center" }}>
// //                     <ArrowRightAlt
// //                       sx={{
// //                         mr: 2,
// //                         color: theme.palette.success.main,
// //                         fontSize: 28,
// //                       }}
// //                     />
// //                     <ListItemText
// //                       primary={
// //                         <Typography variant="h6" fontWeight="bold" color="success.main">
// //                           {mockData.hiringMetrics.totalHires} Hires
// //                         </Typography>
// //                       }
// //                       secondary={
// //                         <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
// //                           {((mockData.hiringMetrics.totalHires / mockData.hiringMetrics.totalInterviews) * 100).toFixed(
// //                             1,
// //                           )}
// //                           % Conversion Rate
// //                         </Typography>
// //                       }
// //                     />
// //                   </ListItem>
// //                 </>
// //               )}
// //             </List>
// //           </CardContent>
// //         </Card>
// //       </Grid>
// //       <Grid item xs={12} md={6}>
// //         <Card
// //           sx={{
// //             borderRadius: 3,
// //             boxShadow: theme.shadows[4],
// //             height: "100%",
// //             backgroundColor: "#F1FFFA",
// //             transition: "all 0.3s ease",
// //             "&:hover": {
// //               boxShadow: theme.shadows[8],
// //             },
// //           }}
// //         >
// //           <CardContent sx={{ p: 4 }}>
// //             {loading ? (
// //               <Skeleton variant="text" width="60%" height={32} />
// //             ) : (
// //               <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
// //                 Key Performance Metrics
// //               </Typography>
// //             )}
// //             <List sx={{ pt: 3 }}>
// //               {loading ? (
// //                 Array.from(new Array(3)).map((_, index) => (
// //                   <ListItem key={index} sx={{ py: 2 }}>
// //                     <ListItemIcon>
// //                       <Skeleton variant="circular" width={40} height={40} />
// //                     </ListItemIcon>
// //                     <ListItemText
// //                       primary={<Skeleton variant="text" />}
// //                       secondary={<Skeleton variant="text" width="40%" />}
// //                     />
// //                   </ListItem>
// //                 ))
// //               ) : (
// //                 <>
// //                   <ListItem sx={{ py: 2 }}>
// //                     <ListItemIcon>
// //                       <Avatar
// //                         sx={{
// //                           bgcolor: alpha(theme.palette.primary.main, 0.1),
// //                           color: theme.palette.primary.main,
// //                           width: 40,
// //                           height: 40,
// //                         }}
// //                       >
// //                         <AccessTime />
// //                       </Avatar>
// //                     </ListItemIcon>
// //                     <ListItemText
// //                       primary={
// //                         <Typography variant="body1" fontWeight="600">
// //                           Average Time to Hire
// //                         </Typography>
// //                       }
// //                       secondary={
// //                         <Typography variant="body2" color="text.secondary">
// //                           {mockData.hiringMetrics.averageTimeToHire}
// //                         </Typography>
// //                       }
// //                     />
// //                   </ListItem>
// //                   <ListItem sx={{ py: 2 }}>
// //                     <ListItemIcon>
// //                       <Avatar
// //                         sx={{
// //                           bgcolor: alpha(theme.palette.success.main, 0.1),
// //                           color: theme.palette.success.main,
// //                           width: 40,
// //                           height: 40,
// //                         }}
// //                       >
// //                         <MonetizationOn />
// //                       </Avatar>
// //                     </ListItemIcon>
// //                     <ListItemText
// //                       primary={
// //                         <Typography variant="body1" fontWeight="600">
// //                           Cost Per Hire
// //                         </Typography>
// //                       }
// //                       secondary={
// //                         <Typography variant="body2" color="text.secondary">
// //                           {mockData.hiringMetrics.costPerHire}
// //                         </Typography>
// //                       }
// //                     />
// //                   </ListItem>
// //                   <ListItem sx={{ py: 2 }}>
// //                     <ListItemIcon>
// //                       <Avatar
// //                         sx={{
// //                           bgcolor: alpha(theme.palette.secondary.main, 0.1),
// //                           color: theme.palette.secondary.main,
// //                           width: 40,
// //                           height: 40,
// //                         }}
// //                       >
// //                         <RateReview />
// //                       </Avatar>
// //                     </ListItemIcon>
// //                     <ListItemText
// //                       primary={
// //                         <Typography variant="body1" fontWeight="600">
// //                           Offer Acceptance Rate
// //                         </Typography>
// //                       }
// //                       secondary={
// //                         <Typography variant="body2" color="text.secondary">
// //                           {mockData.hiringMetrics.offerAcceptanceRate}
// //                         </Typography>
// //                       }
// //                     />
// //                   </ListItem>
// //                 </>
// //               )}
// //             </List>
// //           </CardContent>
// //         </Card>
// //       </Grid>
// //     </Grid>
// //   )
// // }

// // const DemographicsTab = ({
// //   loading,
// //   data,
// //   skillChartRef,
// //   locationTableRef,
// //   timeRange,
// //   handleTimeRangeChange,
// //   jobFilter,
// //   handleJobFilterChange,
// //   filterOptions,
// //   onExportClick,
// // }) => {
// //   const theme = useTheme()
// //   const colorPalette = useMemo(() => {
// //     if (!data || !data.skill_distribution) {
// //       return []
// //     }
// //     return generateUniqueColors(data.skill_distribution.length)
// //   }, [data.skill_distribution])

// //   return (
// //     <Stack spacing={4}>
// //       <Paper
// //         elevation={0}
// //         sx={{
// //           p: 2,
// //           borderRadius: 3,
// //           backgroundColor: "#F1FFFA",
// //           border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
// //         }}
// //       >
// //         <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center" justifyContent="flex-end">
// //           <FormControl size="small">
// //             <Select
// //               value={timeRange}
// //               onChange={handleTimeRangeChange}
// //               sx={{
// //                 borderRadius: 2,
// //                 backgroundColor: "#F1FFFA",
// //                 minWidth: 140,
// //               }}
// //             >
// //               <MenuItem value="last30days">Last Month</MenuItem>
// //               <MenuItem value="last3months">Last 3 Months</MenuItem>
// //               <MenuItem value="last6months">Last 6 Months</MenuItem>
// //               <MenuItem value="lastyear">Last Year</MenuItem>
// //             </Select>
// //           </FormControl>
// //           <FormControl size="small">
// //             <Select
// //               value={jobFilter}
// //               onChange={handleJobFilterChange}
// //               sx={{
// //                 borderRadius: 2,
// //                 backgroundColor: "#F1FFFA",
// //                 minWidth: 180,
// //               }}
// //             >
// //               {filterOptions.job_roles.map((job) => (
// //                 <MenuItem key={job || "all-jobs"} value={job === "All Jobs" || !job ? "all" : job}>
// //                   {job || "All Jobs"}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <Button
// //             variant="outlined"
// //             startIcon={<CloudDownload />}
// //             size="medium"
// //             onClick={onExportClick}
// //             sx={{
// //               borderRadius: 2,
// //               textTransform: "none",
// //               fontWeight: 600,
// //             }}
// //           >
// //             Export Report
// //           </Button>
// //         </Stack>
// //       </Paper>
// //       <Grid container spacing={4}>
// //         <Grid item xs={12} lg={8}>
// //           <Card
// //             ref={skillChartRef}
// //             sx={{
// //               borderRadius: 3,
// //               boxShadow: theme.shadows[4],
// //               height: "100%",
// //               backgroundColor: "#F1FFFA",
// //             }}
// //           >
// //             <CardContent sx={{ p: 3 }}>
// //               <Typography variant="h6" gutterBottom fontWeight="bold" color="text.primary">
// //                 Skill Distribution
// //               </Typography>
// //               {loading ? (
// //                 <Skeleton variant="rectangular" height={450} />
// //               ) : (
// //                 <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
// //                   <Grid item xs={12} sm={8}>
// //                     <SkillDonutChart data={data.skill_distribution} colors={colorPalette} />
// //                   </Grid>
// //                   <Grid item xs={12} sm={4}>
// //                     <SkillList data={data.skill_distribution} colors={colorPalette} />
// //                   </Grid>
// //                 </Grid>
// //               )}
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} lg={4}>
// //           <Card
// //             ref={locationTableRef}
// //             sx={{
// //               borderRadius: 3,
// //               boxShadow: theme.shadows[4],
// //               height: "100%",
// //               width: "100%",
// //               backgroundColor: "#F1FFFA",
// //             }}
// //           >
// //             <CardContent sx={{ p: 4 }}>
// //               <Typography variant="h6" gutterBottom fontWeight="bold" color="text.primary">
// //                 Candidate Locations
// //               </Typography>
// //               <TableContainer sx={{ mt: 3 }}>
// //                 <Table>
// //                   <TableHead>
// //                     <TableRow>
// //                       <TableCell>
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Location
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell align="right">
// //                         <Typography variant="subtitle2" fontWeight="bold">
// //                           Candidates
// //                         </Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   </TableHead>
// //                   <TableBody>
// //                     {loading
// //                       ? Array.from(new Array(5)).map((_, index) => (
// //                           <TableRow key={index}>
// //                             <TableCell>
// //                               <Skeleton variant="text" />
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Skeleton variant="rounded" width={40} height={24} />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))
// //                       : data.candidate_locations.map((loc) => (
// //                           <TableRow
// //                             key={loc.location}
// //                             sx={{ "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.04) } }}
// //                           >
// //                             <TableCell component="th" scope="row">
// //                               <Typography variant="body2" fontWeight="500">
// //                                 {loc.location}
// //                               </Typography>
// //                             </TableCell>
// //                             <TableCell align="right">
// //                               <Chip label={loc.candidates} size="small" color="primary" variant="outlined" />
// //                             </TableCell>
// //                           </TableRow>
// //                         ))}
// //                   </TableBody>
// //                 </Table>
// //               </TableContainer>
// //             </CardContent>
// //           </Card>
// //         </Grid>
// //       </Grid>
// //     </Stack>
// //   )
// // }

// // const CandidatesTab = ({
// //   loading,
// //   candidates,
// //   totalCandidates,
// //   page,
// //   rowsPerPage,
// //   handleChangePage,
// //   handleChangeRowsPerPage,
// // }) => {
// //   const theme = useTheme()
// //   const getExperienceTooltip = (experienceArray) => {
// //     if (!Array.isArray(experienceArray) || experienceArray.length === 0) {
// //       return "No experience details available."
// //     }
// //     return experienceArray
// //       .map((exp) => `${exp.title || "N/A"} at ${exp.company || "N/A"} (${exp.duration || "N/A"})`)
// //       .join("\n")
// //   }

// //   return (
// //     <Card
// //       sx={{
// //         borderRadius: 3,
// //         boxShadow: theme.shadows[4],
// //         backgroundColor: "#F1FFFA",
// //       }}
// //     >
// //       <CardContent sx={{ p: 4 }}>
// //         <Typography variant="h6" gutterBottom fontWeight="bold" color="text.primary">
// //           Top Candidates
// //         </Typography>
// //         <TableContainer sx={{ mt: 3 }}>
// //           <Table sx={{ minWidth: 650 }} aria-label="top candidates table">
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Candidate
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Experience
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Top Skills
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Match Score
// //                   </Typography>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Typography variant="subtitle2" fontWeight="bold">
// //                     Status
// //                   </Typography>
// //                 </TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {loading
// //                 ? Array.from(new Array(rowsPerPage)).map((_, index) => (
// //                     <TableRow key={index}>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton variant="circular" width={48} height={48} />
// //                           <Stack spacing={0.5}>
// //                             <Skeleton variant="text" width={120} />
// //                             <Skeleton variant="text" width={100} />
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton variant="text" width={100} />
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" spacing={0.5} flexWrap="wrap">
// //                           <Skeleton variant="rounded" width={60} height={24} />
// //                           <Skeleton variant="rounded" width={70} height={24} />
// //                           <Skeleton variant="rounded" width={50} height={24} />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Skeleton variant="rectangular" width={100} height={8} sx={{ borderRadius: 1 }} />
// //                           <Skeleton variant="text" width={30} />
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Skeleton variant="rounded" width={90} height={28} />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))
// //                 : candidates.map((candidate) => (
// //                     <TableRow
// //                       key={candidate.candidate_id}
// //                       hover
// //                       sx={{ "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.04) } }}
// //                     >
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <Avatar src={candidate.avatar} sx={{ width: 48, height: 48 }} />
// //                           <Stack>
// //                             <Typography variant="body2" fontWeight="600">
// //                               {candidate.candidate_name}
// //                             </Typography>
// //                             <Stack direction="row" alignItems="center" spacing={0.5}>
// //                               <LocationOn sx={{ fontSize: 16, color: "text.secondary" }} />
// //                               <Typography variant="caption" color="text.secondary">
// //                                 {candidate.location}
// //                               </Typography>
// //                             </Stack>
// //                           </Stack>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={
// //                             <div style={{ whiteSpace: "pre-line" }}>{getExperienceTooltip(candidate.experience)}</div>
// //                           }
// //                           arrow
// //                         >
// //                           <Typography variant="body2" sx={{ cursor: "pointer" }}>
// //                             {(candidate.experience && candidate.experience[0]?.duration) || "N/A"}
// //                           </Typography>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Tooltip
// //                           title={Array.isArray(candidate.skills) ? candidate.skills.join(", ") : ""}
// //                           arrow
// //                           placement="top"
// //                         >
// //                           <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ cursor: "pointer" }}>
// //                             {Array.isArray(candidate.skills) &&
// //                               candidate.skills.slice(0, 3).map((skill) => (
// //                                 <Chip key={skill} label={skill} size="small" variant="outlined" />
// //                               ))}
// //                           </Stack>
// //                         </Tooltip>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" alignItems="center" spacing={2}>
// //                           <LinearProgress
// //                             variant="determinate"
// //                             value={candidate.match_score}
// //                             sx={{
// //                               width: 100,
// //                               height: 8,
// //                               borderRadius: 1,
// //                             }}
// //                           />
// //                           <Typography variant="body2" color="text.secondary" fontWeight="500">
// //                             {candidate.match_score}%
// //                           </Typography>
// //                         </Stack>
// //                       </TableCell>
// //                       <TableCell>
// //                         <Chip
// //                           icon={getStatusIcon(candidate.status)}
// //                           label={candidate.status.charAt(0).toUpperCase() + candidate.status.slice(1)}
// //                           color={getStatusColor(candidate.status)}
// //                           size="small"
// //                           variant="filled"
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //         <TablePagination
// //           rowsPerPageOptions={[5, 10, 25]}
// //           component="div"
// //           count={totalCandidates}
// //           rowsPerPage={rowsPerPage}
// //           page={page}
// //           onPageChange={handleChangePage}
// //           onRowsPerPageChange={handleChangeRowsPerPage}
// //         />
// //       </CardContent>
// //     </Card>
// //   )
// // }

// // function EmployerAnalytics() {
// //   const theme = useTheme()
// //   const [tabValue, setTabValue] = useState(0)
// //   const [timeRange, setTimeRange] = useState("last30days")
// //   const [jobFilter, setJobFilter] = useState("all")
// //   const [loading, setLoading] = useState(true)
// //   const [candidatesData, setCandidatesData] = useState([])
// //   const [overviewData, setOverviewData] = useState({
// //     summary_stats: { total_applications: 0, total_interviews: 0, total_hires: 0, acceptance_rate: "0%" },
// //     application_trend: [],
// //     recent_activity: [],
// //   })
// //   const [demographicsData, setDemographicsData] = useState({
// //     skill_distribution: [],
// //     candidate_locations: [],
// //   })
// //   const [filterOptions, setFilterOptions] = useState({
// //     job_roles: ["All Jobs"],
// //     time_ranges: ["Last Month", "Last 3 Months", "Last 6 Months", "Last Year"],
// //   })
// //   const [page, setPage] = useState(0)
// //   const [rowsPerPage, setRowsPerPage] = useState(5)
// //   const [isExportModalOpen, setIsExportModalOpen] = useState(false)
// //   const skillChartRef = useRef(null)
// //   const locationTableRef = useRef(null)

// //   const safeJsonParse = (str, fallback = []) => {
// //     if (typeof str !== "string") return fallback
// //     try {
// //       return JSON.parse(str)
// //     } catch (e) {
// //       return fallback
// //     }
// //   }

// //   useEffect(() => {
// //     const fetchInitialData = async () => {
// //       setLoading(true)
// //       try {
// //         const [candidatesResponse, overviewResponse] = await Promise.all([
// //           apiClient.get("/hiring-analytics/top-matching-candidates/"),
// //           apiClient.get("/hiring-analytics/combined-dashboard/"),
// //         ])
// //         const mappedCandidates = candidatesResponse.data.map((apiCandidate) => ({
// //           candidate_id: apiCandidate.candidate_id,
// //           candidate_name: apiCandidate.candidate_name,
// //           skills: apiCandidate.skills || [],
// //           match_score: apiCandidate.match_score,
// //           avatar: `/placeholder.svg?height=40&width=40`,
// //           experience: safeJsonParse(apiCandidate.experience, []),
// //           location: apiCandidate.location || "N/A",
// //           status: apiCandidate.status ? apiCandidate.status.toLowerCase() : "matched",
// //         }))

// //         setCandidatesData(mappedCandidates)
// //         setOverviewData(overviewResponse.data)
// //       } catch (error) {
// //         console.error("Failed to fetch initial data:", error)
// //       } finally {
// //         setLoading(false)
// //       }
// //     }
// //     fetchInitialData()
// //   }, [])

// //   useEffect(() => {
// //     const fetchDemographicsData = async () => {
// //       setLoading(true)
// //       let url = "/demographics/"
// //       if (jobFilter !== "all") {
// //         url = `/demographics/job/${encodeURIComponent(jobFilter)}/`
// //       } else if (timeRange !== "all") {
// //         url = `/demographics/time/${timeRange}/`
// //       }

// //       try {
// //         const response = await apiClient.get(url)
// //         setDemographicsData(response.data)
// //         if (response.data.filter_options) {
// //           setFilterOptions(response.data.filter_options)
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch demographics data:", error)
// //       } finally {
// //         setLoading(false)
// //       }
// //     }

// //     fetchDemographicsData()
// //   }, [jobFilter, timeRange])

// //   const handleTabChange = (event, newValue) => setTabValue(newValue)
// //   const handleTimeRangeChange = (event) => {
// //     setTimeRange(event.target.value)
// //     setJobFilter("all")
// //   }
// //   const handleJobFilterChange = (event) => {
// //     setJobFilter(event.target.value)
// //     setTimeRange("all")
// //   }
// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage)
// //   }
// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10))
// //     setPage(0)
// //   }

// //   return (
// //     <Layout title="Hiring Analytics">
// //       <Box sx={{ bgcolor: "#f8fafc", minHeight: "100vh" }}>
// //         <Container maxWidth="xl" sx={{ py: 4 }}>
// //           <Stack spacing={4}>
// //             <Paper
// //               sx={{
// //                 p: { xs: 2, sm: 3 },
// //                 borderRadius: 3,
// //                 backgroundColor: "#F1FFFA",
// //                 color: "#4D3CC3",
// //                 width: "100%",
// //               }}
// //             >
// //               <Typography
// //                 variant="h3"
// //                 component="h1"
// //                 fontWeight="bold"
// //                 sx={{
// //                   background: "#4F46BA",
// //                   backgroundClip: "text",
// //                   WebkitBackgroundClip: "text",
// //                   WebkitTextFillColor: "transparent",
// //                 }}
// //               >
// //                 Hiring Analytics Dashboard
// //               </Typography>
// //             </Paper>

// //             <Paper
// //               elevation={0}
// //               sx={{
// //                 borderRadius: 3,
// //                 border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
// //                 boxShadow: theme.shadows[2],
// //                 overflow: "hidden",
// //                 backgroundColor: "#F1FFFA",
// //                 width: "100%",
// //               }}
// //             >
// //               <Tabs
// //                 value={tabValue}
// //                 onChange={handleTabChange}
// //                 indicatorColor="primary"
// //                 textColor="primary"
// //                 variant="standard"
// //                 centered
// //                 sx={{
// //                   "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
// //                   "& .MuiTabs-indicator": { height: 3, borderRadius: "3px 3px 0 0" },
// //                 }}
// //               >
// //                 <Tab icon={<BarChart />} label="OVERVIEW" iconPosition="start" />
// //                 <Tab icon={<Timeline />} label="TRENDS" iconPosition="start" />
// //                 <Tab icon={<PieChart />} label="DEMOGRAPHICS" iconPosition="start" />
// //                 <Tab icon={<People />} label="CANDIDATES" iconPosition="start" />
// //                 <Tab icon={<History />} label="RECENT ACTIVITY" iconPosition="start" />
// //               </Tabs>
// //             </Paper>

// //             <Box>
// //               <TabPanel value={tabValue} index={0}>
// //                 <OverviewTab loading={loading} data={overviewData} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={1}>
// //                 <TrendsTab loading={loading} />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={2}>
// //                 <DemographicsTab
// //                   loading={loading}
// //                   data={demographicsData}
// //                   skillChartRef={skillChartRef}
// //                   locationTableRef={locationTableRef}
// //                   timeRange={timeRange}
// //                   handleTimeRangeChange={handleTimeRangeChange}
// //                   jobFilter={jobFilter}
// //                   handleJobFilterChange={handleJobFilterChange}
// //                   filterOptions={filterOptions}
// //                   onExportClick={() => setIsExportModalOpen(true)}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={3}>
// //                 <CandidatesTab
// //                   loading={loading}
// //                   candidates={candidatesData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
// //                   totalCandidates={candidatesData.length}
// //                   page={page}
// //                   rowsPerPage={rowsPerPage}
// //                   handleChangePage={handleChangePage}
// //                   handleChangeRowsPerPage={handleChangeRowsPerPage}
// //                 />
// //               </TabPanel>
// //               <TabPanel value={tabValue} index={4}>
// //                 <RecentActivityTab loading={loading} data={overviewData.recent_activity} />
// //               </TabPanel>
// //             </Box>
// //           </Stack>
// //         </Container>
// //       </Box>
// //       <ExportReportDialog
// //         open={isExportModalOpen}
// //         onClose={() => setIsExportModalOpen(false)}
// //         candidatesData={candidatesData}
// //         demographicsData={demographicsData}
// //         overviewData={overviewData}
// //         skillChartRef={skillChartRef}
// //         locationTableRef={locationTableRef}
// //       />
// //     </Layout>
// //   )
// // }

// // export default EmployerAnalytics

"use client";

import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Stack,
  Paper,
  useTheme,
  Tabs,
  Tab,
  FormControl,
  Select,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  LinearProgress,
  TablePagination,
  Tooltip,
  Container,
  Fade,
  Grow,
  alpha,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
} from "@mui/material";
import {
  People,
  LocationOn,
  TrendingUp,
  WorkOutline,
  School,
  BarChart,
  PieChart,
  Timeline,
  CloudDownload,
  Star,
  CheckCircle,
  HelpOutline,
  MonetizationOn,
  AccessTime,
  RateReview,
  History,
  ArrowDownward,
} from "@mui/icons-material";
import * as htmlToImage from "html-to-image";
import ReactApexChart from "react-apexcharts";
import Layout from "../common/Layout";
import apiClient from "../../context/apiClient";

// NOTE: No changes needed in utility functions
const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType });
  const a = document.createElement("a");
  a.download = fileName;
  a.href = window.URL.createObjectURL(blob);
  const clickEvt = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  a.dispatchEvent(clickEvt);
  a.remove();
};

const convertToCSV = (data) => {
  if (!data || data.length === 0) return "";
  const headers = Object.keys(data[0]);
  const csvRows = [headers.join(",")];
  for (const row of data) {
    const values = headers.map((header) => {
      const escaped = ("" + row[header]).replace(/"/g, '""');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(","));
  }
  return csvRows.join("\n");
};

const generateUniqueColors = (count) => {
  if (count === 0) return [];
  const colors = [];
  const hueStep = 360 / count;
  for (let i = 0; i < count; i++) {
    const hue = i * hueStep;
    colors.push(`hsl(${hue}, 70%, 50%)`);
  }
  return colors;
};

// NOTE: No changes needed in ExportReportDialog as it inherits styles from the theme
const ExportReportDialog = ({
  open,
  onClose,
  candidatesData,
  demographicsData,
  overviewData,
  skillChartRef,
  locationTableRef,
}) => {
  const [reportType, setReportType] = useState("demographics_skills");
  const [format, setFormat] = useState("png");

  const handleDownload = async () => {
    let dataToExport = [];
    let fileName = `${reportType}_report`;
    const isImageFormat = format === "png";

    if (isImageFormat) {
      const elementToCapture =
        reportType === "demographics_skills"
          ? skillChartRef.current
          : locationTableRef.current;
      if (!elementToCapture) {
        console.error("Target element for image capture not found.");
        return;
      }
      try {
        const dataUrl = await htmlToImage.toPng(elementToCapture);
        const a = document.createElement("a");
        a.href = dataUrl;
        a.download = `${reportType}_${new Date()
          .toISOString()
          .slice(0, 10)}.png`;
        a.click();
      } catch (error) {
        console.error("Failed to capture component as image", error);
      }
    } else {
      switch (reportType) {
        case "candidates":
          dataToExport = candidatesData.map((c) => ({
            id: c.candidate_id,
            name: c.candidate_name,
            location: c.location,
            status: c.status,
            match_score: c.match_score,
            skills: c.skills.join("|"),
            experience: c.experience
              .map((e) => `${e.title} at ${e.company}`)
              .join(" | "),
          }));
          break;
        case "demographics_skills":
          dataToExport = demographicsData.skill_distribution;
          fileName = "skill_distribution_report";
          break;
        case "demographics_locations":
          dataToExport = demographicsData.candidate_locations;
          fileName = "candidate_locations_report";
          break;
        case "overview":
          dataToExport = [overviewData.summary_stats];
          break;
        default:
          console.error("Invalid report type");
          return;
      }

      if (format === "csv") {
        const csvData = convertToCSV(dataToExport);
        downloadFile({
          data: csvData,
          fileName: `${fileName}.csv`,
          fileType: "text/csv",
        });
      } else if (format === "json") {
        downloadFile({
          data: JSON.stringify(dataToExport, null, 2),
          fileName: `${fileName}.json`,
          fileType: "application/json",
        });
      }
    }
    onClose();
  };

  const isVisualReport =
    reportType === "demographics_skills" ||
    reportType === "demographics_locations";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle fontWeight="bold">Export Report</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={4}>
          <FormControl component="fieldset">
            <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
              Select Report Type
            </FormLabel>
            <RadioGroup
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
            >
              <FormControlLabel
                value="demographics_skills"
                control={<Radio />}
                label="Skill Distribution"
              />
              <FormControlLabel
                value="demographics_locations"
                control={<Radio />}
                label="Candidate Locations"
              />
              <FormControlLabel
                value="candidates"
                control={<Radio />}
                label="Top Candidates (Data Only)"
              />
              <FormControlLabel
                value="overview"
                control={<Radio />}
                label="Hiring Stats Overview (Data Only)"
              />
            </RadioGroup>
          </FormControl>
          <FormControl component="fieldset">
            <FormLabel component="legend" sx={{ fontWeight: 600, mb: 1 }}>
              Select Format
            </FormLabel>
            <RadioGroup
              row
              value={format}
              onChange={(e) => setFormat(e.target.value)}
            >
              <FormControlLabel
                value="png"
                control={<Radio />}
                label="Image (PNG)"
                disabled={!isVisualReport}
              />
              <FormControlLabel value="csv" control={<Radio />} label="CSV" />
              <FormControlLabel value="json" control={<Radio />} label="JSON" />
            </RadioGroup>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleDownload}
          variant="contained"
          startIcon={<CloudDownload />}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const cleanSkill = (skill) => {
  return skill.replace(/[\[\]"]/g, "");
};

const SkillDonutChart = ({ data, colors }) => {
  const theme = useTheme();
  const chartSeries = data.map((item) => item.count);
  const chartOptions = {
    chart: { type: "donut", background: "transparent" },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total Skills",
              color: theme.palette.text.secondary,
              formatter: (w) =>
                w.globals.seriesTotals.reduce((a, b) => a + b, 0),
            },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    legend: { show: false },
    colors: colors,
    tooltip: { y: { formatter: (val) => `${val} candidates` } },
    theme: {
      mode: theme.palette.mode,
    },
    stroke: {
      colors: [theme.palette.background.paper],
    },
  };
  return (
    <ReactApexChart
      options={chartOptions}
      series={chartSeries}
      type="donut"
      height={420}
    />
  );
};

const SkillList = ({ data, colors }) => {
  return (
    <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 2 }}>
      <List>
        {data.map((item, index) => (
          <ListItem key={item.skill} disablePadding>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{ width: "100%", py: 0.5 }}
            >
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: "4px",
                  bgcolor: colors[index % colors.length],
                  flexShrink: 0,
                }}
              />
              <ListItemText
                primary={
                  <Typography variant="body2" color="text.primary" noWrap>
                    {cleanSkill(item.skill)}
                  </Typography>
                }
              />
              <Typography
                variant="body2"
                color="text.secondary"
                fontWeight="bold"
              >
                {item.count}
              </Typography>
            </Stack>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

const ApplicationTrendChart = ({ data, height = 450 }) => {
  const theme = useTheme();

  if (
    !data ||
    !data.datasets ||
    !data.datasets[0] ||
    !data.datasets[0].data ||
    data.datasets[0].data.length === 0
  ) {
    return (
      <Box
        sx={{
          height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: (theme) => alpha(theme.palette.divider, 0.04),
          borderRadius: 2,
          border: (theme) => `1px dashed ${theme.palette.divider}`,
          m: 3,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          No trend data available.
        </Typography>
      </Box>
    );
  }

  const chartSeries = [
    {
      name: "Applications",
      data: data.datasets[0].data,
    },
  ];

  const chartOptions = {
    chart: {
      type: "area",
      height: height,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      background: "transparent",
    },
    colors: [theme.palette.primary.main],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
      lineCap: "round",
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.1,
        stops: [0, 90, 100],
      },
    },
    grid: {
      show: true,
      borderColor: theme.palette.divider,
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      categories: data.labels,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: theme.palette.text.secondary,
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: theme.palette.text.secondary,
        },
        formatter: function (val) {
          return val.toFixed(0);
        },
      },
    },
    tooltip: {
      x: {
        format: "MMM yyyy",
      },
      y: {
        formatter: (val) => `${val} applications`,
      },
      theme: theme.palette.mode,
      marker: {
        show: true,
      },
    },
  };

  return (
    <ReactApexChart
      options={chartOptions}
      series={chartSeries}
      type="area"
      height={height}
    />
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`analytics-tabpanel-${index}`}
      aria-labelledby={`analytics-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Fade in={value === index} timeout={500}>
          <Box sx={{ pt: 4 }}>{children}</Box>
        </Fade>
      )}
    </div>
  );
}

const getStatusColor = (status) => {
  switch (status) {
    case "hired":
      return "success";
    case "interviewed":
      return "primary";
    case "shortlisted":
      return "info";
    case "applied":
    case "matched":
      return "warning";
    default:
      return "default";
  }
};

const getStatusIcon = (status) => {
  switch (status) {
    case "hired":
      return <CheckCircle />;
    case "interviewed":
      return <People />;
    case "shortlisted":
      return <Star />;
    case "applied":
    case "matched":
      return <WorkOutline />;
    default:
      return <HelpOutline />;
  }
};

const OverviewTab = ({ loading, data }) => {
  const theme = useTheme();

  const applicationTrendsData = {
    labels: data.application_trend?.map((d) => d.month) || [],
    datasets: [
      {
        label: "Applications",
        data: data.application_trend?.map((d) => d.application_count) || [],
        backgroundColor: theme.palette.primary.main,
      },
    ],
  };

  const statCards = [
    {
      label: "Total Applications",
      value: data.summary_stats?.total_applications || 0,
    },
    {
      label: "Total Interviews",
      value: data.summary_stats?.total_interviews || 0,
    },
    {
      label: "Total Hires",
      value: data.summary_stats?.total_hires || 0,
    },
    {
      label: "Acceptance Rate",
      value: data.summary_stats?.acceptance_rate || "0%",
    },
  ];

  return (
    <Stack spacing={4}>
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {loading
          ? [...Array(4)].map((_, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={140}
                  sx={{ borderRadius: "12px" }}
                />
              </Grid>
            ))
          : statCards.map((card, index) => (
              <Box key={index} sx={{ flex: 1, minWidth: 0 }}>
                <Box
                  sx={{
                    width: "100%",
                    height: 140,
                    backgroundColor: "primary.main", // Use theme color
                    borderRadius: "12px",
                    boxShadow: theme.shadows[3],
                    position: "relative",
                    overflow: "hidden",
                    p: { xs: 1.5, sm: 2, md: 2.5 },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: 0,
                    }}
                  >
                    <svg
                      width="100%"
                      height="100%"
                      viewBox="0 0 280 140"
                      preserveAspectRatio="none"
                      style={{ position: "absolute", right: 0, top: 0 }}
                    >
                      <path
                        d="M200 0 L280 0 L280 140 C 250 140, 230 105, 230 70 C 230 35, 250 0, 200 0 Z"
                        fill={
                          theme.palette.accent?.main ||
                          theme.palette.primary.main
                        }
                      />
                    </svg>
                  </Box>
                  <Box sx={{ position: "relative", zIndex: 1 }}>
                    <Typography
                      sx={{
                        fontSize: { xs: "0.7rem", sm: "0.75rem" },
                        fontWeight: 600,
                        color: alpha(theme.palette.primary.contrastText, 0.85),
                        textTransform: "uppercase",
                        lineHeight: 1.2,
                      }}
                    >
                      {card.label}
                    </Typography>
                  </Box>
                  <Box sx={{ position: "relative", zIndex: 1 }}>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "1.75rem",
                          sm: "2rem",
                          md: "2.25rem",
                        },
                        fontWeight: "bold",
                        color: "primary.contrastText",
                        lineHeight: 1,
                      }}
                    >
                      {card.value}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
      </Grid>

      <Card
        sx={{
          backgroundColor: "mint.main",
          transition: "all 0.3s ease",
          "&:hover": { boxShadow: theme.shadows[8] },
        }}
      >
        <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
          <Box sx={{ p: { xs: 2, sm: 3 }, pb: 0 }}>
            {loading ? (
              <Skeleton variant="text" width="60%" height={32} />
            ) : (
              <Typography variant="h6" fontWeight="bold" color="text.primary">
                Application Trends
              </Typography>
            )}
          </Box>
          {loading ? (
            <Box sx={{ p: { xs: 2, sm: 3 } }}>
              <Skeleton
                variant="rectangular"
                height={400}
                sx={{ borderRadius: 2 }}
              />
            </Box>
          ) : (
            <ApplicationTrendChart data={applicationTrendsData} />
          )}
        </CardContent>
      </Card>
    </Stack>
  );
};

const RecentActivityTab = ({ loading, data }) => {
  const theme = useTheme();

  const getActivityIcon = (activityString) => {
    const lowerCaseActivity = activityString.toLowerCase();
    if (lowerCaseActivity.includes("hired")) return <CheckCircle />;
    if (lowerCaseActivity.includes("interview")) return <People />;
    if (lowerCaseActivity.includes("applied")) return <WorkOutline />;
    return <RateReview />;
  };

  return (
    <Card
      sx={{
        backgroundColor: "mint.main",
        transition: "all 0.3s ease",
        "&:hover": { boxShadow: theme.shadows[8] },
      }}
    >
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        {loading ? (
          <Skeleton variant="text" width="50%" height={32} />
        ) : (
          <Typography
            variant="h6"
            fontWeight="bold"
            gutterBottom
            color="text.primary"
          >
            Recent Activity
          </Typography>
        )}
        <List sx={{ mt: 2 }}>
          {loading
            ? Array.from(new Array(5)).map((_, index) => (
                <ListItem key={index} sx={{ px: 0, py: 1.5 }}>
                  <ListItemAvatar>
                    <Skeleton variant="circular" width={48} height={48} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Skeleton variant="text" width="80%" />}
                    secondary={<Skeleton variant="text" width="60%" />}
                  />
                </ListItem>
              ))
            : data?.map((activity, index) => (
                <ListItem
                  key={`${activity.candidate_name}-${index}`}
                  sx={{
                    px: 0,
                    py: 1.5,
                    borderRadius: 2,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, 0.04),
                    },
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      sx={{
                        bgcolor: (theme) =>
                          alpha(theme.palette.primary.main, 0.1),
                        color: "primary.main",
                        width: 48,
                        height: 48,
                        boxShadow: theme.shadows[2],
                      }}
                    >
                      {getActivityIcon(activity.activity)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography
                        variant="body2"
                        fontWeight="600"
                        color="text.primary"
                      >
                        {activity.candidate_name}
                      </Typography>
                    }
                    secondary={
                      <Typography variant="caption" color="text.secondary">
                        {activity.activity} • {activity.time_ago}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
        </List>
      </CardContent>
    </Card>
  );
};

// MODIFIED: TrendsTab component is now responsive
const TrendsTab = ({ loading, data }) => {
  const theme = useTheme();

  const funnelData = [
    {
      icon: <WorkOutline color="primary" />,
      title: "Applications",
      value: data?.hiring_funnel?.applications || 0,
      color: theme.palette.primary.main,
    },
    {
      icon: <People color="secondary" />,
      title: "Interviews",
      value: data?.hiring_funnel?.interviews || 0,
      conversion: data?.hiring_funnel?.interview_conversion_rate || "0%",
      color: theme.palette.secondary.main,
    },
    {
      icon: <CheckCircle color="success" />,
      title: "Hires",
      value: data?.hiring_funnel?.hires || 0,
      conversion: data?.hiring_funnel?.hire_conversion_rate || "0%",
      color: theme.palette.success.main,
    },
  ];

  const kpiData = [
    {
      icon: <AccessTime />,
      title: "Average Time to Hire",
      value: data?.key_performance_metrics?.average_time_to_hire || "N/A",
      color: theme.palette.primary,
    },
    {
      icon: <MonetizationOn />,
      title: "Cost Per Hire",
      value: data?.key_performance_metrics?.cost_per_hire || "N/A",
      color: theme.palette.success,
    },
    {
      icon: <RateReview />,
      title: "Offer Acceptance Rate",
      value: data?.key_performance_metrics?.offer_acceptance_rate || "N/A",
      color: theme.palette.secondary,
    },
  ];

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={5}>
        <Card
          sx={{
            height: "100%",
            width: "100%", // <-- Responsive width
            maxWidth: "600px", // <-- Max width for larger screens
            margin: "0 auto", // Center the card in the grid item
            backgroundColor: "mint.main",
            transition: "all 0.3s ease",
            "&:hover": { boxShadow: theme.shadows[8] },
          }}
        >
          <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              color="text.primary"
            >
              Hiring Funnel
            </Typography>
            {loading ? (
              <Stack spacing={4} sx={{ mt: 3 }}>
                <Skeleton
                  variant="rectangular"
                  height={60}
                  sx={{ borderRadius: 2 }}
                />
                <Skeleton
                  variant="rectangular"
                  height={60}
                  sx={{ borderRadius: 2 }}
                />
                <Skeleton
                  variant="rectangular"
                  height={60}
                  sx={{ borderRadius: 2 }}
                />
              </Stack>
            ) : (
              <Stack spacing={2} sx={{ mt: 4 }}>
                {funnelData.map((step, index) => (
                  <Grow in timeout={500 + index * 200} key={step.title}>
                    <Box>
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 2,
                          borderColor: alpha(step.color, 0.3),
                          background: `linear-gradient(to right, ${alpha(
                            step.color,
                            0.1,
                          )}, transparent)`,
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: alpha(step.color, 0.15),
                            color: step.color,
                            mr: 2,
                          }}
                        >
                          {step.icon}
                        </Avatar>
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography variant="body2" color="text.secondary">
                            {step.title}
                          </Typography>
                          <Typography variant="h5" fontWeight="bold">
                            {step.value}
                          </Typography>
                        </Box>
                        {step.conversion && (
                          <Box sx={{ textAlign: "right" }}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Conversion
                            </Typography>
                            <Typography
                              variant="body1"
                              fontWeight="bold"
                              color={step.color}
                            >
                              {step.conversion}
                            </Typography>
                          </Box>
                        )}
                      </Paper>
                      {index < funnelData.length - 1 && (
                        <Box display="flex" justifyContent="center" my={1}>
                          <ArrowDownward sx={{ color: "divider" }} />
                        </Box>
                      )}
                    </Box>
                  </Grow>
                ))}
              </Stack>
            )}
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} lg={7}>
        <Card
          sx={{
            height: "100%",
            width: "100%", // <-- Responsive width
            maxWidth: "700px", // <-- Max width for larger screens
            margin: "0 auto", // Center the card in the grid item
            backgroundColor: "mint.main",
            transition: "all 0.3s ease",
            "&:hover": { boxShadow: theme.shadows[8] },
          }}
        >
          <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              color="text.primary"
            >
              Key Performance Metrics
            </Typography>
            <Grid container spacing={3} sx={{ mt: 2, height: "100%" }}>
              {loading
                ? Array.from(new Array(3)).map((_, index) => (
                    <Grid item xs={12} sm={4} key={index}>
                      <Skeleton
                        variant="rectangular"
                        height={150}
                        sx={{ borderRadius: 2 }}
                      />
                    </Grid>
                  ))
                : kpiData.map((kpi, index) => (
                    <Grid item xs={12} sm={4} key={kpi.title}>
                      <Grow in timeout={500 + index * 200}>
                        <Paper
                          variant="outlined"
                          sx={{
                            p: { xs: 2, sm: 3 },
                            borderRadius: 2,
                            textAlign: "center",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            borderColor: alpha(kpi.color.main, 0.3),
                            backgroundColor: alpha(kpi.color.main, 0.05),
                          }}
                        >
                          <Avatar
                            sx={{
                              bgcolor: alpha(kpi.color.main, 0.1),
                              color: kpi.color.main,
                              width: 56,
                              height: 56,
                              mx: "auto",
                              mb: 1.5,
                            }}
                          >
                            {kpi.icon}
                          </Avatar>
                          <Typography
                            variant="body2"
                            fontWeight="600"
                            color="text.primary"
                          >
                            {kpi.title}
                          </Typography>
                          <Typography
                            variant="h4"
                            fontWeight="bold"
                            color="text.primary"
                            sx={{ mt: 1 }}
                          >
                            {kpi.value}
                          </Typography>
                        </Paper>
                      </Grow>
                    </Grid>
                  ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

// MODIFIED: DemographicsTab component is now responsive
const DemographicsTab = ({
  loading,
  data,
  skillChartRef,
  locationTableRef,
  timeRange,
  handleTimeRangeChange,
  jobFilter,
  handleJobFilterChange,
  filterOptions,
  onExportClick,
}) => {
  const theme = useTheme();
  const colorPalette = useMemo(() => {
    if (!data || !data.skill_distribution) {
      return [];
    }
    return generateUniqueColors(data.skill_distribution.length);
  }, [data.skill_distribution]);

  return (
    <Stack spacing={4}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          backgroundColor: "mint.main",
          border: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems="center"
          justifyContent="flex-end"
        >
          <FormControl size="small" sx={{ width: { xs: "100%", md: "auto" } }}>
            <Select
              value={timeRange}
              onChange={handleTimeRangeChange}
              sx={{
                minWidth: 140,
              }}
            >
              <MenuItem value="last30days">Last Month</MenuItem>
              <MenuItem value="last3months">Last 3 Months</MenuItem>
              <MenuItem value="last6months">Last 6 Months</MenuItem>
              <MenuItem value="lastyear">Last Year</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ width: { xs: "100%", md: "auto" } }}>
            <Select
              value={jobFilter}
              onChange={handleJobFilterChange}
              sx={{
                minWidth: 180,
              }}
            >
              {filterOptions.job_roles.map((job) => (
                <MenuItem
                  key={job || "all-jobs"}
                  value={job === "All Jobs" || !job ? "all" : job}
                >
                  {job || "All Jobs"}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="outlined"
            startIcon={<CloudDownload />}
            size="medium"
            onClick={onExportClick}
            sx={{
              width: { xs: "100%", md: "auto" },
            }}
          >
            Export Report
          </Button>
        </Stack>
      </Paper>
      <Grid container spacing={4}>
        <Grid item xs={12} lg={7}>
          <Card
            ref={skillChartRef}
            sx={{
              height: "100%",
              width: "100%", // <-- Responsive width
              backgroundColor: "mint.main",
            }}
          >
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
              <Typography
                variant="h6"
                gutterBottom
                fontWeight="bold"
                color="text.primary"
              >
                Skill Distribution
              </Typography>
              {loading ? (
                <Skeleton variant="rectangular" height={450} />
              ) : (
                <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                  <Grid item xs={12} md={8}>
                    <SkillDonutChart
                      data={data.skill_distribution}
                      colors={colorPalette}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <SkillList
                      data={data.skill_distribution}
                      colors={colorPalette}
                    />
                  </Grid>
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} lg={5}>
          <Card
            ref={locationTableRef}
            sx={{
              height: "100%",
              width: "100%", // <-- Responsive width
              maxWidth: "700px", // <-- Max width for larger screens
              margin: "0 auto", // Center the card
              backgroundColor: "mint.main",
            }}
          >
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
              <Typography
                variant="h6"
                gutterBottom
                fontWeight="bold"
                color="text.primary"
              >
                Candidate Locations
              </Typography>
              <TableContainer sx={{ mt: 3, maxHeight: 450 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography variant="subtitle2" fontWeight="bold">
                          Location
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="subtitle2" fontWeight="bold">
                          Candidates
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading
                      ? Array.from(new Array(5)).map((_, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                            <TableCell align="right">
                              <Skeleton
                                variant="rounded"
                                width={40}
                                height={24}
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      : data.candidate_locations.map((loc) => (
                          <TableRow
                            key={loc.location}
                            sx={{
                              "&:hover": {
                                bgcolor: (theme) =>
                                  alpha(theme.palette.primary.main, 0.04),
                              },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              <Typography variant="body2" fontWeight="500">
                                {loc.location}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Chip
                                label={loc.candidates}
                                size="small"
                                color="primary"
                                variant="outlined"
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Stack>
  );
};

// MODIFIED: CandidatesTab component is now responsive
const CandidatesTab = ({
  loading,
  candidates,
  totalCandidates,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const theme = useTheme();
  const getExperienceTooltip = (experienceArray) => {
    if (!Array.isArray(experienceArray) || experienceArray.length === 0) {
      return "No experience details available.";
    }
    return experienceArray
      .map(
        (exp) =>
          `${exp.title || "N/A"} at ${exp.company || "N/A"} (${
            exp.duration || "N/A"
          })`,
      )
      .join("\n");
  };

  return (
    <Card
      sx={{
        backgroundColor: "mint.main",
      }}
    >
      <CardContent sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
        <Typography
          variant="h6"
          gutterBottom
          fontWeight="bold"
          color="text.primary"
        >
          Top Candidates
        </Typography>
        {/* ADDED: Box with overflowX for horizontal scrolling on small screens */}
        <Box sx={{ overflowX: "auto" }}>
          <TableContainer sx={{ mt: 3 }}>
            <Table sx={{ minWidth: 650 }} aria-label="top candidates table">
              <TableHead>
                <TableRow>
                  <TableCell>Candidate</TableCell>
                  <TableCell>Experience</TableCell>
                  <TableCell>Top Skills</TableCell>
                  <TableCell>Match Score</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading
                  ? Array.from(new Array(rowsPerPage)).map((_, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Skeleton
                              variant="circular"
                              width={48}
                              height={48}
                            />
                            <Stack spacing={0.5}>
                              <Skeleton variant="text" width={120} />
                              <Skeleton variant="text" width={100} />
                            </Stack>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={100} />
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" spacing={0.5} flexWrap="wrap">
                            <Skeleton
                              variant="rounded"
                              width={60}
                              height={24}
                            />
                            <Skeleton
                              variant="rounded"
                              width={70}
                              height={24}
                            />
                            <Skeleton
                              variant="rounded"
                              width={50}
                              height={24}
                            />
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Skeleton
                              variant="rectangular"
                              width={100}
                              height={8}
                              sx={{ borderRadius: 1 }}
                            />
                            <Skeleton variant="text" width={30} />
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="rounded" width={90} height={28} />
                        </TableCell>
                      </TableRow>
                    ))
                  : candidates.map((candidate) => (
                      <TableRow
                        key={candidate.candidate_id}
                        hover
                        sx={{
                          "&:hover": {
                            bgcolor: (theme) =>
                              alpha(theme.palette.primary.main, 0.04),
                          },
                        }}
                      >
                        <TableCell>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Avatar
                              src={candidate.avatar}
                              sx={{ width: 48, height: 48 }}
                            />
                            <Stack>
                              <Typography variant="body2" fontWeight="600">
                                {candidate.candidate_name}
                              </Typography>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={0.5}
                              >
                                <LocationOn
                                  sx={{
                                    fontSize: 16,
                                    color: "text.secondary",
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {candidate.location}
                                </Typography>
                              </Stack>
                            </Stack>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Tooltip
                            title={
                              <div style={{ whiteSpace: "pre-line" }}>
                                {getExperienceTooltip(candidate.experience)}
                              </div>
                            }
                            arrow
                          >
                            <Typography
                              variant="body2"
                              sx={{ cursor: "pointer" }}
                            >
                              {(candidate.experience &&
                                candidate.experience[0]?.duration) ||
                                "N/A"}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Tooltip
                            title={
                              Array.isArray(candidate.skills)
                                ? candidate.skills.join(", ")
                                : ""
                            }
                            arrow
                            placement="top"
                          >
                            <Stack
                              direction="row"
                              spacing={0.5}
                              flexWrap="wrap"
                              sx={{ cursor: "pointer", gap: 0.5 }}
                            >
                              {Array.isArray(candidate.skills) &&
                                candidate.skills
                                  .slice(0, 3)
                                  .map((skill) => (
                                    <Chip
                                      key={skill}
                                      label={skill}
                                      size="small"
                                      variant="outlined"
                                    />
                                  ))}
                            </Stack>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <LinearProgress
                              variant="determinate"
                              value={candidate.match_score}
                              sx={{
                                width: 100,
                                height: 8,
                                borderRadius: 1,
                              }}
                            />
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              fontWeight="500"
                            >
                              {candidate.match_score}%
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Chip
                            icon={getStatusIcon(candidate.status)}
                            label={
                              candidate.status.charAt(0).toUpperCase() +
                              candidate.status.slice(1)
                            }
                            color={getStatusColor(candidate.status)}
                            size="small"
                            variant="filled"
                          />
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCandidates}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </CardContent>
    </Card>
  );
};

function EmployerAnalytics() {
  const theme = useTheme();
  const [tabValue, setTabValue] = useState(0);
  const [timeRange, setTimeRange] = useState("last30days");
  const [jobFilter, setJobFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [candidatesData, setCandidatesData] = useState([]);
  const [overviewData, setOverviewData] = useState({
    summary_stats: {
      total_applications: 0,
      total_interviews: 0,
      total_hires: 0,
      acceptance_rate: "0%",
    },
    application_trend: [],
    recent_activity: [],
  });
  const [demographicsData, setDemographicsData] = useState({
    skill_distribution: [],
    candidate_locations: [],
  });
  const [trendsData, setTrendsData] = useState(null);
  const [filterOptions, setFilterOptions] = useState({
    job_roles: ["All Jobs"],
    time_ranges: ["Last Month", "Last 3 Months", "Last 6 Months", "Last Year"],
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const skillChartRef = useRef(null);
  const locationTableRef = useRef(null);

  const safeJsonParse = (str, fallback = []) => {
    if (typeof str !== "string") return fallback;
    try {
      return JSON.parse(str);
    } catch (e) {
      return fallback;
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        const [candidatesResponse, overviewResponse, trendsResponse] =
          await Promise.all([
            apiClient.get("/hiring-analytics/top-matching-candidates/"),
            apiClient.get("/hiring-analytics/combined-dashboard/"),
            apiClient.get("/employer-analytics/trends"),
          ]);
        const mappedCandidates = candidatesResponse.data.map(
          (apiCandidate) => ({
            candidate_id: apiCandidate.candidate_id,
            candidate_name: apiCandidate.candidate_name,
            skills: apiCandidate.skills || [],
            match_score: apiCandidate.match_score,
            avatar: `/placeholder.svg?height=40&width=40`,
            experience: safeJsonParse(apiCandidate.experience, []),
            location: apiCandidate.location || "N/A",
            status: apiCandidate.status
              ? apiCandidate.status.toLowerCase()
              : "matched",
          }),
        );

        setCandidatesData(mappedCandidates);
        setOverviewData(overviewResponse.data);
        setTrendsData(trendsResponse.data);
      } catch (error) {
        console.error("Failed to fetch initial data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInitialData();
  }, []);

  useEffect(() => {
    const fetchDemographicsData = async () => {
      setLoading(true);
      let url = "/demographics/";
      if (jobFilter !== "all") {
        url = `/demographics/job/${encodeURIComponent(jobFilter)}/`;
      } else if (timeRange !== "all") {
        url = `/demographics/time/${timeRange}/`;
      }

      try {
        const response = await apiClient.get(url);
        setDemographicsData(response.data);
        if (response.data.filter_options) {
          setFilterOptions(response.data.filter_options);
        }
      } catch (error) {
        console.error("Failed to fetch demographics data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDemographicsData();
  }, [jobFilter, timeRange]);

  const handleTabChange = (event, newValue) => setTabValue(newValue);
  const handleTimeRangeChange = (event) => {
    setTimeRange(event.target.value);
    setJobFilter("all");
  };
  const handleJobFilterChange = (event) => {
    setJobFilter(event.target.value);
    setTimeRange("all");
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Layout title="Hiring Analytics">
      <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
        <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 } }}>
          <Stack spacing={{ xs: 2, md: 4 }}>
            <Paper
              sx={{
                p: { xs: 2, sm: 3 },
                backgroundColor: "mint.main",
                color: "primary.main",
              }}
            >
              <Typography
                variant="h4"
                component="h1"
                fontWeight="bold"
                sx={{
                  background: (theme) => theme.palette.primary.main,
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: { xs: "1.75rem", sm: "2.5rem" },
                }}
              >
                Hiring Analytics Dashboard
              </Typography>
            </Paper>

            <Paper
              elevation={0}
              sx={{
                backgroundColor: "background.paper",
                overflow: "hidden",
                backgroundColor: "mint.main",
              }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={{
                  "& .MuiTab-root": {
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: { xs: "0.8rem", sm: "0.875rem" },
                  },
                  "& .MuiTabs-indicator": {
                    height: 3,
                    borderRadius: "3px 3px 0 0",
                  },
                }}
              >
                <Tab
                  icon={<BarChart />}
                  label="OVERVIEW"
                  iconPosition="start"
                />
                <Tab icon={<Timeline />} label="TRENDS" iconPosition="start" />
                <Tab
                  icon={<PieChart />}
                  label="DEMOGRAPHICS"
                  iconPosition="start"
                />
                <Tab
                  icon={<People />}
                  label="CANDIDATES"
                  iconPosition="start"
                />
                <Tab
                  icon={<History />}
                  label="RECENT ACTIVITY"
                  iconPosition="start"
                />
              </Tabs>
            </Paper>

            <Box>
              <TabPanel value={tabValue} index={0}>
                <OverviewTab loading={loading} data={overviewData} />
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <TrendsTab loading={loading} data={trendsData} />
              </TabPanel>
              <TabPanel value={tabValue} index={2}>
                <DemographicsTab
                  loading={loading}
                  data={demographicsData}
                  skillChartRef={skillChartRef}
                  locationTableRef={locationTableRef}
                  timeRange={timeRange}
                  handleTimeRangeChange={handleTimeRangeChange}
                  jobFilter={jobFilter}
                  handleJobFilterChange={handleJobFilterChange}
                  filterOptions={filterOptions}
                  onExportClick={() => setIsExportModalOpen(true)}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={3}>
                <CandidatesTab
                  loading={loading}
                  candidates={candidatesData.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage,
                  )}
                  totalCandidates={candidatesData.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={4}>
                <RecentActivityTab
                  loading={loading}
                  data={overviewData.recent_activity}
                />
              </TabPanel>
            </Box>
          </Stack>
        </Container>
      </Box>
      <ExportReportDialog
        open={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        candidatesData={candidatesData}
        demographicsData={demographicsData}
        overviewData={overviewData}
        skillChartRef={skillChartRef}
        locationTableRef={locationTableRef}
      />
    </Layout>
  );
}

export default EmployerAnalytics;
